(function(){
  var BOOKING_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
  var BOULEVARD_TOKENIZE_URL = 'https://pci.boulevard.app/cards/tokenize';
  var PHOTO_ANALYZE_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/analyze-hair-services';
  var DISPLAY_TIME_ZONE = 'America/New_York';
  var CLIENT_DASHBOARD_STORAGE_KEY = 'hairstories_client_dashboard_v1';
  var CLIENT_DASHBOARD_TOKEN_STORAGE_KEY = 'hairstories_client_dashboard_token_v1';
  var CLIENT_DASHBOARD_LIVE_STORAGE_KEY = 'hairstories_client_dashboard_live_v1';

  var SERVICE_MAP = window.BK_SERVICE_MAP || {};
  var SERVICE_NAMES = window.BK_SERVICE_NAMES || {};
  var MODIFIER_MAP = window.BK_MODIFIER_MAP || {};
  var PHOTO_OPTION_NAMES = window.BK_PHOTO_OPTION_NAMES || {};
  var PHOTO_HAIRCUT_CONFIRM_QUESTION_ID = window.BK_PHOTO_HAIRCUT_CONFIRM_QUESTION_ID || 'client_confirm_haircut';
  var PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID = window.BK_PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID || 'client_confirm_haircut_big_change';
  var PHOTO_GRAY_COVERAGE_QUESTION_ID = window.BK_PHOTO_GRAY_COVERAGE_QUESTION_ID || 'gray_coverage_intent';
  var PHOTO_GRAY_STRATEGY_QUESTION_ID = window.BK_PHOTO_GRAY_STRATEGY_QUESTION_ID || 'gray_strategy_followup';
  var PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID = window.BK_PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID || 'inspo_focus_areas';
  var PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID = window.BK_PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID || 'multi_inspo_focus_areas';
  var SERVICE_ID_ALIASES = window.BK_SERVICE_ID_ALIASES || {};
  var THINKING_LINES_BY_MODE = window.BK_THINKING_LINES_BY_MODE || {};
  var GRAY_COVERAGE_OPTIONS = window.BK_GRAY_COVERAGE_OPTIONS || [];
  var GRAY_STRATEGY_OPTIONS = window.BK_GRAY_STRATEGY_OPTIONS || [];
  var INSPO_FOCUS_OPTIONS = window.BK_INSPO_FOCUS_OPTIONS || [];
  var INSPO_FOCUS_ALIAS_MAP = window.BK_INSPO_FOCUS_ALIAS_MAP || {};
  var PHOTO_CONSULT_LINES_BY_ID = window.BK_PHOTO_CONSULT_LINES_BY_ID || {};
  var PHOTO_SUPPORT_TEXT_BY_ID = window.BK_PHOTO_SUPPORT_TEXT_BY_ID || {};
  var BOOKING_QUESTION_SCREENS = window.BK_BOOKING_QUESTION_SCREENS || [];
  var BOOKING_PROGRESS_BY_SCREEN = window.BK_BOOKING_PROGRESS_BY_SCREEN || {};

  var state = JSON.parse(JSON.stringify(window.BK_INITIAL_STATE || {}));

  var root = document.getElementById('booking-app');
  var stackList = document.getElementById('bkStackList');
  var summaryHeading = document.getElementById('bkSummaryHeading');
  var summaryMeta = document.getElementById('bkSummaryMeta');
  var perServiceStaffPanels = document.getElementById('bkPerServiceStaffPanels');
  var stylistActionsMount = document.getElementById('bkStylistActionsMount');
  var timeActionsMount = document.getElementById('bkTimeActionsMount');
  var actionsHome = document.getElementById('bkActionsHome');
  var rangeChoices = document.getElementById('bkRangeChoices');
  var rangePrevBtn = document.getElementById('bkRangePrev');
  var rangeNextBtn = document.getElementById('bkRangeNext');
  var timeChoices = document.getElementById('bkTimeChoices');
  var timeMeta = document.getElementById('bkTimeMeta');
  var reviewPanel = document.getElementById('bkReviewPanel');
  var donePanel = document.getElementById('bkDonePanel');
  var paymentMethodsPanel = document.getElementById('bkPaymentMethods');
  var paymentQuickPanel = document.getElementById('bkPaymentQuick');
  var dashboardPanel = document.getElementById('bkDashboardPanel');
  var staffDirectoryPanel = document.getElementById('bkStaffDirectoryPanel');
  var progressEl = document.getElementById('bkProgress');
  var progressFillEl = document.getElementById('bkProgressFill');
  var guestHeading = document.getElementById('bkGuestHeading');
  var guestContactFields = document.getElementById('bkGuestContactFields');
  var entryGate = document.getElementById('bkEntryGate');
  var entryChoices = document.getElementById('bkEntryChoices');
  var actionsBar = document.getElementById('bkActionsBar');
  var messageEl = document.getElementById('bkMessage');
  var debugPanel = document.getElementById('bkDebugPanel');
  var backBtn = document.getElementById('bkBackBtn');
  var nextBtn = document.getElementById('bkNextBtn');
  var bookingAccountInline = document.getElementById('bkBookingAccountInline');

  var firstNameInput = document.getElementById('bkFirstName');
  var lastNameInput = document.getElementById('bkLastName');
  var emailInput = document.getElementById('bkEmail');
  var phoneInput = document.getElementById('bkPhone');
  var gratuityCustomInput = document.getElementById('bkGratuityCustom');
  var gratuityCustomWrap = document.getElementById('bkGratuityCustomWrap');
  var cardNameInput = document.getElementById('bkCardName');
  var cardNumberInput = document.getElementById('bkCardNumber');
  var cardBrandTag = document.getElementById('bkCardBrandTag');
  var cardExpMonthInput = document.getElementById('bkCardExpMonth');
  var cardExpYearInput = document.getElementById('bkCardExpYear');
  var cardCvvInput = document.getElementById('bkCardCvv');
  var cardPostalInput = document.getElementById('bkCardPostal');

  var photoGoalInput = document.getElementById('bkPhotoGoal');
  var currentDropzone = document.getElementById('bkCurrentDropzone');
  var inspoDropzone = document.getElementById('bkInspoDropzone');
  var currentDropzoneCount = document.getElementById('bkCurrentDropzoneCount');
  var inspoDropzoneCount = document.getElementById('bkInspoDropzoneCount');
  var currentPhotoFilesInput = document.getElementById('bkCurrentPhotoFiles');
  var inspoPhotoFilesInput = document.getElementById('bkInspoPhotoFiles');
  var currentPhotoPreviews = document.getElementById('bkCurrentPhotoPreviews');
  var inspoPhotoPreviews = document.getElementById('bkInspoPhotoPreviews');
  var photoClearBtn = document.getElementById('bkPhotoClear');
  var photoAnalyzeBtn = document.getElementById('bkPhotoAnalyze');
  var photoSummary = document.getElementById('bkPhotoSummary');
  var photoResults = document.getElementById('bkPhotoResults');
  var photoQuestions = document.getElementById('bkPhotoQuestions');
  var photoRefineBtn = document.getElementById('bkPhotoRefine');
  var photoApplyBtn = document.getElementById('bkPhotoApply');
  var photoFollowupTitle = document.getElementById('bkPhotoFollowupTitle');
  var photoFollowupText = document.getElementById('bkPhotoFollowupText');
  var photoFollowupChoices = document.getElementById('bkPhotoFollowupChoices');
  var photoConsultStatus = document.getElementById('bkPhotoConsultStatus');
  var photoConsultLine = document.getElementById('bkPhotoConsultLine');
  var stylistStepTitle = document.getElementById('bkStylistStepTitle');
  var stylistStepText = document.getElementById('bkStylistStepText');
  var thinkingPanels = Array.prototype.slice.call(document.querySelectorAll('[data-thinking-panel]'));

  var currentAvailabilityGroups = [];
  var availabilityRequestToken = 0;
  var selectedSlotRetryTimer = null;
  var currentPhotoImages = [];
  var inspirationPhotoImages = [];
  var thinkingTimer = null;
  var thinkingIndex = 0;
  var consultHeaderTimer = null;
  var consultHeaderIndex = 0;
  var sharedTrackActivity = window.HS_CHECKIN_SHARED && typeof window.HS_CHECKIN_SHARED.trackActivity === 'function'
    ? window.HS_CHECKIN_SHARED.trackActivity
    : function(){};

  function trackBookingActivity(eventType, eventName, metadata){
    try {
      sharedTrackActivity(eventType, eventName, metadata || {});
    } catch (_error) {
    }
  }

  function trackGratuitySelectionActivity(source){
    try {
      var label = gratuityLabel();
      trackBookingActivity('interaction', source || 'next_visit_booking_gratuity_selected', {
        page_section: 'next_visit_booking',
        gratuity_choice: state.gratuityChoice || 'none',
        gratuity_percentage: gratuityPercentageValue(),
        gratuity_fixed_amount: gratuityFixedAmount(),
        tip_label: label === 'None' ? 'No tip' : label
      });
    } catch (_error) {
    }
  }

  function trackBookingSelection(eventName, metadata){
    trackBookingActivity('interaction', eventName, Object.assign({
      page_section: 'next_visit_booking'
    }, metadata || {}));
  }

  function startOfDayLocal(date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDaysLocal(date, days){
    var next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  }

  function formatRangeShortDate(date){
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(date);
  }

  function weeklyRangeOptions(){
    var today = startOfDayLocal(new Date());
    return Array.from({ length: 8 }, function(_value, index){
      var start = addDaysLocal(today, index * 7);
      var end = addDaysLocal(start, 6);
      var title = index === 0
        ? 'This week'
        : (index === 1 ? 'Next week' : (index === 2 ? 'Week after' : 'Week ' + (index + 1)));
      return {
        id: 'week_' + index,
        title: title,
        meta: formatRangeShortDate(start) + ' – ' + formatRangeShortDate(end)
      };
    });
  }

  function rangeOptionForKey(key){
    var normalized = String(key || '').trim();
    if (normalized === 'this_week') normalized = 'week_0';
    if (normalized === 'next_week') normalized = 'week_1';
    if (normalized === 'in_2_weeks') normalized = 'week_2';
    var match = weeklyRangeOptions().find(function(option){
      return option.id === normalized;
    });
    if (match) return match;
    return null;
  }

  function setMessage(text, tone){
    messageEl.textContent = text || '';
    messageEl.className = 'bk-message' + (tone ? ' ' + tone : '');
  }

  function showDebug(data){
    if (!debugPanel) return;
    debugPanel.style.display = 'none';
    debugPanel.textContent = '';
  }

  function thinkingLinesForMode(mode){
    return THINKING_LINES_BY_MODE[mode] || THINKING_LINES_BY_MODE.default || [
      'pulling together the details of your look...'
    ];
  }

  function questionMentionsHaircutIntent(question){
    var text = String(question && question.question || '').toLowerCase();
    var id = String(question && question.id || '').toLowerCase();
    if (id === String(PHOTO_HAIRCUT_CONFIRM_QUESTION_ID || '').toLowerCase()) return true;
    if (id === String(PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID || '').toLowerCase()) return true;
    return /book a haircut|keep this color-only|bigger haircut change|trim and shape refresh|trim or refresh/.test(text);
  }

  function questionMentionsGrayIntent(question){
    var text = String(question && question.question || '').toLowerCase();
    var id = String(question && question.id || '').toLowerCase();
    return /gray|grey/.test(text) || /gray|grey/.test(id);
  }

  function questionBelongsToFrontendFlow(question){
    var text = String(question && question.question || '').toLowerCase();
    var id = String(question && question.id || '').toLowerCase();
    return /blowdry|blow dry|finish|standalone styling|separate styling|extensions?/.test(text) ||
      /blowdry|blow_dry|finish|extension/.test(id) ||
      /\blong or thick\b|\bextra long\b|\bdense\b|\bdensity\b|\bthick\b/.test(text) ||
      /\blong_thick\b|\bextra_long\b|\bdense\b|\bdensity\b|\bthick\b/.test(id);
  }

  function grayCoverageOptions(){
    return GRAY_COVERAGE_OPTIONS.slice();
  }

  function grayStrategyOptions(){
    return GRAY_STRATEGY_OPTIONS.slice();
  }

  function inspoFocusOptions(){
    return INSPO_FOCUS_OPTIONS.slice();
  }

  function inferredInspoFocusOptions(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var trace = analysis && analysis.consultation_trace ? analysis.consultation_trace : {};
    var summaryText = [
      technical.current_hair,
      technical.inspiration_hair,
      technical.transformation_analysis,
      technical.realism_notes,
      trace.base_color_plan,
      trace.dimension_plan,
      trace.haircut_plan,
      trace.booking_logic,
      analysis && analysis.summary
    ].join(' ').toLowerCase();

    var options = [];
    var add = function(id){
      var match = inspoFocusOptions().find(function(option){ return option.id === id; });
      if (!match) return;
      if (options.some(function(option){ return option.id === id; })) return;
      options.push(match);
    };

    if (analysisSuggestsHaircut(analysis) || analysisImpliesObviousLongToBobShift(analysis)) {
      add('haircut');
    }
    if (/highlight|bright|blonde|face frame|face-framing|dimension|balayage|lighter/.test(summaryText)) {
      add('brightness');
    }
    if (/cool|warm|ashy|beige|creamy|tone|toning|brassy|brassiness|neutral/.test(summaryText)) {
      add('tone');
    }
    if (/root shadow|diffused root|soft root|softer root|root blend|blended root|growout/.test(summaryText)) {
      add('root_softness');
    }
    if (/depth|contrast|richer|darker top|deeper top|darker overall|richness/.test(summaryText)) {
      add('overall_depth');
    }
    if (/vibe|polish|softness|polished|lived-in|overall look|overall feel/.test(summaryText)) {
      add('overall_vibe');
    }

    if (options.length < 3) {
      ['haircut', 'brightness', 'tone', 'root_softness', 'overall_depth', 'overall_vibe'].forEach(add);
    }

    return options.slice(0, 5);
  }

  function normalizeInspoFocusSelections(values){
    var raw = Array.isArray(values) ? values : [];
    var normalized = [];

    raw.forEach(function(value){
      var id = String(value || '').trim();
      if (!id) return;

      if (id === 'both') {
        if (normalized.indexOf('haircut') === -1) normalized.push('haircut');
        if (normalized.indexOf('brightness') === -1) normalized.push('brightness');
        return;
      }

      if (id === 'color') {
        if (normalized.indexOf('brightness') === -1) normalized.push('brightness');
        return;
      }

      if (id === 'cut') {
        if (normalized.indexOf('haircut') === -1) normalized.push('haircut');
        return;
      }

      if (id === 'finish') {
        if (normalized.indexOf('overall_vibe') === -1) normalized.push('overall_vibe');
        return;
      }

      if (normalized.indexOf(id) === -1) {
        normalized.push(id);
      }
    });

    return normalized.slice(0, 6);
  }

  function inspoFocusSelectionMatches(selectedId, targetId){
    selectedId = String(selectedId || '').trim();
    targetId = String(targetId || '').trim();
    if (!selectedId || !targetId) return false;
    if (selectedId === targetId) return true;
    if (targetId === 'both') {
      return selectedId === 'haircut' || selectedId === 'brightness';
    }
    if (targetId === 'color') {
      return selectedId === 'brightness';
    }
    if (targetId === 'cut') {
      return selectedId === 'haircut';
    }
    if (targetId === 'finish') {
      return selectedId === 'overall_vibe';
    }

    var aliases = INSPO_FOCUS_ALIAS_MAP[targetId] || [];
    return aliases.indexOf(selectedId) !== -1;
  }

  function getPhotoInspoFocusSelections(){
    var canonical = state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID];
    if (Array.isArray(canonical)) return normalizeInspoFocusSelections(canonical);
    var legacy = state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID];
    return Array.isArray(legacy) ? normalizeInspoFocusSelections(legacy) : [];
  }

  function setPhotoInspoFocusSelections(values){
    var next = normalizeInspoFocusSelections(values);
    if (next.length) {
      state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID] = next;
    } else {
      delete state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID];
    }
    delete state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID];

    if (!next.length) {
      delete state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID];
      delete state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID];
    } else if (next.some(function(optionId){ return inspoFocusSelectionMatches(optionId, 'haircut'); })) {
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] = true;
      if (state.photoAnalysis && analysisImpliesObviousLongToBobShift(state.photoAnalysis)) {
        state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] = true;
      }
    } else if (state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true) {
      delete state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID];
      delete state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID];
    }
  }

  function hasQuestionWithId(questions, questionId){
    return (Array.isArray(questions) ? questions : []).some(function(question){
      return question && question.id === questionId;
    });
  }

  function photoGrayDecisionStillOpen(){
    return state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID] === 'gray_unsure' &&
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_GRAY_STRATEGY_QUESTION_ID);
  }

  function photoGrayQuestionStillNeeded(){
    if (!state.photoAnalysis) return false;
    var analysis = state.photoAnalysis;
    var rawQuestions = Array.isArray(analysis.follow_up_questions) ? analysis.follow_up_questions : [];
    var modelAskedGray = rawQuestions.some(function(question){
      return question && question.id === PHOTO_GRAY_COVERAGE_QUESTION_ID;
    });
    var blockingIds = photoBlockingDecisionIds();
    var grayBlocking = blockingIds.indexOf(PHOTO_GRAY_COVERAGE_QUESTION_ID) !== -1 ||
      blockingIds.indexOf(PHOTO_GRAY_STRATEGY_QUESTION_ID) !== -1;
    var grayRelevant = modelAskedGray ||
      grayBlocking ||
      analysisSuggestsPhotoColorWork(analysis) ||
      analysisSuggestsSingleProcess(analysis) ||
      questionMentionsGrayIntent({ id: '', question: String(analysis.summary || '') });

    return grayRelevant &&
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_GRAY_COVERAGE_QUESTION_ID);
  }

  function photoMultiAnswerIncludes(questionId, optionId){
    var value = questionId === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID
      ? getPhotoInspoFocusSelections()
      : state.photoFollowUpAnswers[questionId];
    return Array.isArray(value) && value.some(function(selectedId){
      return questionId === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID
        ? inspoFocusSelectionMatches(selectedId, optionId)
        : selectedId === optionId;
    });
  }

  function photoBlockingDecisionIds(){
    var analysis = state.photoAnalysis || {};
    var ids = Array.isArray(analysis.still_blocking_decisions)
      ? analysis.still_blocking_decisions.map(function(id){ return String(id || '').trim(); }).filter(Boolean)
      : [];

    ids = ids.filter(function(id){
      if (id === PHOTO_GRAY_STRATEGY_QUESTION_ID) {
        return state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID] === 'gray_unsure' &&
          !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_GRAY_STRATEGY_QUESTION_ID);
      }
      return !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, id);
    });

    if (photoGrayDecisionStillOpen() && ids.indexOf(PHOTO_GRAY_STRATEGY_QUESTION_ID) === -1) {
      ids.push(PHOTO_GRAY_STRATEGY_QUESTION_ID);
    }

    return ids;
  }

  function photoConsultLinesForQuestion(question, index, total){
    var id = String(question && question.id || '');
    var prompt = String(question && question.question || '').toLowerCase();
    var progress = 'Question ' + index + ' of ' + total;
    if (PHOTO_CONSULT_LINES_BY_ID[id]) {
      return [
        progress + ' • ' + PHOTO_CONSULT_LINES_BY_ID[id][0],
        PHOTO_CONSULT_LINES_BY_ID[id][1],
        PHOTO_CONSULT_LINES_BY_ID[id][2]
      ];
    }

    if (/brightness|face frame|full highlight|partial|lighter|dimension|highlight/.test(prompt)) {
      return [
        progress + ' • Reading where the brightness actually belongs',
        'Comparing placement, not just overall lightness',
        'Checking whether you need new dimension or just a smarter tone shift'
      ];
    }

    if (/tone|warm|cool|gloss|shine|rich|red|brunette|depth/.test(prompt)) {
      return [
        progress + ' • Dialing in the tone strategy',
        'Looking at whether this is a tonal shift, a depth shift, or both',
        'Checking if existing dimension can be reused instead of adding more lightening'
      ];
    }

    return [
      progress + ' • Refining the service strategy',
      'Cross-checking maintenance, placement, and end result',
      'Making sure the recommendation feels like a real stylist consult'
    ];
  }

  function photoFollowupSupportText(question, index, total){
    var id = String(question && question.id || '');
    var progress = 'Question ' + index + ' of ' + total + '. ';
    if (PHOTO_SUPPORT_TEXT_BY_ID[id]) {
      return progress + PHOTO_SUPPORT_TEXT_BY_ID[id];
    }

    return progress + 'One quick answer helps us tighten the recommendation so the booking matches the result more accurately.';
  }

  function syncPhotoConsultHeader(question, index, total){
    if (consultHeaderTimer) {
      clearInterval(consultHeaderTimer);
      consultHeaderTimer = null;
    }

    if (photoConsultStatus) photoConsultStatus.classList.remove('is-active');
    if (photoConsultLine) photoConsultLine.textContent = '';
  }

  function setThinkingState(active, mode){
    var lines = thinkingLinesForMode(mode);
    var title = '';
    var meta = mode === 'refine'
      ? ''
      : 'Looking at tone, brightness, placement, and what needs to be booked.';

    if (thinkingTimer) {
      clearInterval(thinkingTimer);
      thinkingTimer = null;
    }

    thinkingIndex = 0;

    thinkingPanels.forEach(function(panel){
      var titleEl = panel.querySelector('.bk-thinkingTitle');
      var lineEl = panel.querySelector('[data-thinking-line]');
      var metaEl = panel.querySelector('[data-thinking-meta]');
      var screen = panel.closest('.bk-screen');

      if (titleEl) titleEl.textContent = title;
      if (lineEl) lineEl.textContent = lines[0] || '';
      if (metaEl) metaEl.textContent = meta;
      panel.classList.toggle('is-active', !!active);
      if (screen) {
        screen.classList.toggle('is-thinking', !!active);
      }
    });

    if (!active) return;
  }

  function updateDebugPanel(source){
    var normalizedQuestions = normalizedPhotoQuestions(state.photoAnalysis);
    var activeQuestion = currentPhotoQuestion();
    var analyzerServices = state.photoAnalysis && Array.isArray(state.photoAnalysis.recommended_services)
      ? state.photoAnalysis.recommended_services
      : (state.photoAnalysis && state.photoAnalysis.booking_strategy && Array.isArray(state.photoAnalysis.booking_strategy.recommended_services)
        ? state.photoAnalysis.booking_strategy.recommended_services
        : []);
    if (!debugPanel) return;
    debugPanel.style.display = 'none';
    debugPanel.textContent = '';
    return;
    debugPanel.textContent = JSON.stringify({
      source: source || 'client',
      photoGoal: state.photoGoal,
      photoApplied: state.photoApplied,
      analysisSummary: state.photoAnalysis && state.photoAnalysis.summary ? state.photoAnalysis.summary : '',
      current_hair_analysis: state.photoAnalysis && state.photoAnalysis.current_hair_analysis
        ? state.photoAnalysis.current_hair_analysis
        : null,
      inspiration_hair_analysis: state.photoAnalysis && state.photoAnalysis.inspiration_hair_analysis
        ? state.photoAnalysis.inspiration_hair_analysis
        : null,
      material_inspo_components: state.photoAnalysis && Array.isArray(state.photoAnalysis.material_inspo_components)
        ? state.photoAnalysis.material_inspo_components
        : [],
      transformation_path: state.photoAnalysis && state.photoAnalysis.transformation_path
        ? state.photoAnalysis.transformation_path
        : null,
      question_bundle: state.photoAnalysis && state.photoAnalysis.question_bundle
        ? state.photoAnalysis.question_bundle
        : null,
      helpful_question_preferences: state.photoAnalysis && state.photoAnalysis.question_bundle && Array.isArray(state.photoAnalysis.question_bundle.helpful_preferences)
        ? state.photoAnalysis.question_bundle.helpful_preferences
        : [],
      analysisConfidence: state.photoAnalysis && typeof state.photoAnalysis.confidence === 'number'
        ? state.photoAnalysis.confidence
        : null,
      analysisNeedsHumanReview: state.photoAnalysis && typeof state.photoAnalysis.needs_human_review === 'boolean'
        ? state.photoAnalysis.needs_human_review
        : null,
      booking_strategy: state.photoAnalysis && state.photoAnalysis.booking_strategy
        ? state.photoAnalysis.booking_strategy
        : null,
      analyzer_recommended_services: analyzerServices,
      analyzer_follow_up_questions: state.photoAnalysis && Array.isArray(state.photoAnalysis.follow_up_questions)
        ? state.photoAnalysis.follow_up_questions
        : [],
      normalizedPhotoQuestions: normalizedQuestions,
      currentPhotoQuestion: activeQuestion,
      totalPhotoQuestions: normalizedQuestions.length,
      unansweredPhotoQuestions: unansweredPhotoQuestionCount(),
      answeredPhotoQuestions: normalizedQuestions
        .filter(function(question){
          return Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, question.id);
        })
        .map(function(question){
          return {
            id: question.id,
            answer: state.photoFollowUpAnswers[question.id]
          };
        }),
      photoFollowUpAnswers: state.photoFollowUpAnswers,
      photoFlowFlags: {
        haircutConfirmed: state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID],
        haircutBigChangeConfirmed: state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID],
        grayCoverageIntent: state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID],
        grayStrategyFollowup: state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID]
      },
      bookingAnswers: {
        blowdryStyle: state.answers.blowdryStyle,
        blowdryHairType: state.answers.blowdryHairType,
        singleProcessGlaze: state.answers.singleProcessGlaze,
        haircutLongOrThick: state.answers.haircutLongOrThick,
        haircutBigChange: state.answers.haircutBigChange
      },
      photoSuggestedServices: state.photoSuggestedServices,
      serviceStack: state.serviceStack,
      servicePayload: servicePayload()
    }, null, 2);
  }

  function escapeHtml(value){
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function syncInputs(){
    state.firstName = String(firstNameInput.value || '').trim();
    state.lastName = String(lastNameInput.value || '').trim();
    state.email = String(emailInput.value || '').trim();
    state.phone = String(phoneInput.value || '').trim();
    state.gratuityCustom = String(gratuityCustomInput && gratuityCustomInput.value || '').trim();
    state.cardName = String(cardNameInput.value || '').trim();
    state.cardNumber = String(cardNumberInput.value || '').replace(/\s+/g, '');
    state.cardExpMonth = String(cardExpMonthInput.value || '').trim();
    state.cardExpYear = String(cardExpYearInput.value || '').trim();
    state.cardCvv = String(cardCvvInput.value || '').trim();
    state.cardPostal = String(cardPostalInput.value || '').trim();
    updateCardBrandTag();
    persistDashboardProfile();
  }

  function digitsOnly(value){
    return String(value || '').replace(/\D+/g, '');
  }

  function detectCardBrand(number){
    var digits = digitsOnly(number);
    if (!digits) return null;
    if (/^4\d{12}(\d{3}){0,2}$/.test(digits)) return { label: 'Visa', lengths: [13, 16, 19] };
    if (/^(5[1-5]\d{0,14}|2(2[2-9]\d{0,12}|[3-6]\d{0,13}|7([01]\d{0,12}|20\d{0,11})))$/.test(digits)) return { label: 'MC', lengths: [16] };
    if (/^3[47]\d{0,13}$/.test(digits)) return { label: 'Amex', lengths: [15] };
    if (/^6(011|5|4[4-9])\d{0,15}$/.test(digits)) return { label: 'Discover', lengths: [16, 19] };
    return null;
  }

  function passesLuhn(number){
    var digits = digitsOnly(number);
    if (!digits) return false;
    var sum = 0;
    var shouldDouble = false;
    for (var index = digits.length - 1; index >= 0; index -= 1) {
      var digit = Number(digits.charAt(index));
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  }

  function validCardBrandLabel(number){
    var digits = digitsOnly(number);
    var brand = detectCardBrand(digits);
    if (!brand) return '';
    if (brand.lengths.indexOf(digits.length) === -1) return '';
    if (!passesLuhn(digits)) return '';
    return brand.label;
  }

  function updateCardBrandTag(){
    if (!cardBrandTag) return;
    var label = validCardBrandLabel(state.cardNumber);
    cardBrandTag.textContent = label;
    cardBrandTag.classList.toggle('is-visible', !!label);
  }

  function gratuityPercentageValue(){
    syncInputs();
    if (state.gratuityChoice === 'none') return null;
    if (state.gratuityChoice === 'custom') {
      var custom = Number(state.gratuityCustom);
      return Number.isFinite(custom) && custom >= 0 ? custom : null;
    }
    var preset = Number(state.gratuityChoice);
    return Number.isFinite(preset) && preset >= 0 ? preset : null;
  }

  function gratuityLabel(){
    var percentage = gratuityPercentageValue();
    return percentage === null ? 'None' : (String(percentage).replace(/\.0$/, '') + '%');
  }

  function gratuityFixedAmount(){
    var percentage = gratuityPercentageValue();
    var estimate = state.slotEstimate;

    if (percentage === null) return null;
    if (!estimate || typeof estimate.total !== 'number') return null;

    return Math.max(0, Math.round(estimate.total * (percentage / 100)));
  }

  function compactPhotoAnalysisText(value){
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function buildAppointmentPhotoNote(){
    if (!state.photoAnalysis) return '';

    var parts = [];
    var summary = compactPhotoAnalysisText(state.photoAnalysis.summary);
    var currentHair = state.photoAnalysis.current_hair_analysis || {};
    var inspoHair = state.photoAnalysis.inspiration_hair_analysis || {};
    var currentNotes = compactPhotoAnalysisText(currentHair.notes);
    var inspoNotes = compactPhotoAnalysisText(inspoHair.notes);
    var goal = compactPhotoAnalysisText(state.photoGoal);

    if (goal) parts.push('Photo goal: ' + goal);
    if (summary) parts.push('Analysis: ' + summary);
    if (currentNotes) parts.push('Current: ' + currentNotes);
    if (inspoNotes) parts.push('Inspo: ' + inspoNotes);

    return parts.join(' | ').slice(0, 1200);
  }

  function currentRangeLabel(){
    var option = rangeOptionForKey(state.rangeKey);
    return option ? (option.title + ' (' + option.meta + ')') : 'Current availability search';
  }

  function availabilityRangeKeyForRequest(){
    var key = String(state.rangeKey || '').trim();
    if (key === 'week_0') return 'this_week';
    if (key === 'week_1') return 'next_week';
    if (key === 'week_2') return 'in_2_weeks';
    return key;
  }

  function weeklyRangeDatesForKey(key){
    var match = String(key || '').trim().match(/^week_(\d+)$/);
    if (!match) return [];
    var weekIndex = Number(match[1]);
    if (!Number.isFinite(weekIndex) || weekIndex < 0) return [];
    var start = addDaysLocal(startOfDayLocal(new Date()), weekIndex * 7);
    return Array.from({ length: 7 }, function(_value, dayIndex){
      return addDaysLocal(start, dayIndex).toISOString().slice(0, 10);
    });
  }

  function todayInputValue(){
    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  async function joinWaitlistFromCurrentSelection(){
    var clientToken = String(state.clientAccount && state.clientAccount.clientToken || '').trim();
    var cards = availableSavedCards();
    var savedCardId = String(state.selectedSavedCardId || '').trim();
    var waitlistMode = String(state.clientAccount && state.clientAccount.waitlistMode || 'first_available').trim() || 'first_available';
    var waitlistDateInput = document.getElementById('bkWaitlistDate');
    var preferredDate = String(waitlistDateInput && waitlistDateInput.value || state.clientAccount && state.clientAccount.waitlistPreferredDate || '').trim();
    var cardToken = '';

    if (!clientToken) {
      throw new Error('Sign in to join the waitlist.');
    }
    if (!cards.length && clientToken) {
      try {
        await fetchClientDashboardData();
      } catch (_error) {
        // If the refresh fails, we'll continue with whatever local state we have.
      }
      cards = availableSavedCards();
    }
    if (!savedCardId && cards.length) {
      savedCardId = String(cards[0] && cards[0].id || '').trim();
    }
    state.clientAccount.waitlistPreferredDate = preferredDate;
    if (waitlistMode === 'specific_date' && !preferredDate) {
      throw new Error('Choose a date for the waitlist.');
    }
    if (!savedCardId) {
      syncInputs();
      if (hasCompleteCardInput()) {
        cardToken = await tokenizeCard({
          name: state.cardName || [state.firstName, state.lastName].filter(Boolean).join(' ').trim(),
          number: state.cardNumber,
          cvv: state.cardCvv,
          exp_month: state.cardExpMonth,
          exp_year: state.cardExpYear,
          address_postal_code: state.cardPostal
        });
      } else {
        hydrateBookingProfileFromSignedInClient();
        goTo('guest');
        setMessage('Add a card below to join the waitlist.', 'is-error');
        updateUI();
        return null;
      }
    }

    state.clientAccount.waitlistLoading = true;
    updateUI();

    try {
      var requestedServices = servicePayload();
      var serviceNames = state.serviceStack.map(function(item){
        return item.name;
      }).filter(Boolean).join(', ');
      var notes = ['Requested from booking flow', 'Availability preference: ' + currentRangeLabel()];
      if (serviceNames) notes.push('Services: ' + serviceNames);

      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'client-waitlist-create',
          client_token: clientToken,
          saved_card_id: savedCardId,
          card_token: cardToken,
          services: requestedServices,
          waitlist_mode: waitlistMode,
          preferred_date: waitlistMode === 'specific_date' ? preferredDate : '',
          range_key: state.rangeKey,
          notes: notes.join(' · '),
          send_confirmation_email: true
        })
      });

      var data = await response.json().catch(function(){ return null; });
      showDebug({
        debug: {
          source: 'waitlistCreate',
          response: data,
          status: response.status
        }
      });
      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.error) || 'Could not join the waitlist.');
      }

      setMessage('You’ve been added to the waitlist.', 'is-success');
      return data;
    } finally {
      state.clientAccount.waitlistLoading = false;
      updateUI();
    }
  }

  function confirmedTotalLabel(){
    var summary = state.confirmation && state.confirmation.summary;
    if (summary && typeof summary.total === 'number') {
      return formatMoney(summary.total);
    }
    return state.slotEstimate && typeof state.slotEstimate.total === 'number'
      ? formatMoney(state.slotEstimate.total)
      : 'Pending';
  }

  function confirmedGratuityAmount(){
    var summary = state.confirmation && state.confirmation.summary;
    var percentage = gratuityPercentageValue();

    if (summary && typeof summary.gratuityAmount === 'number' && summary.gratuityAmount > 0) {
      return summary.gratuityAmount;
    }

    if (summary && typeof summary.subtotal === 'number' && percentage !== null) {
      return Math.round(summary.subtotal * (percentage / 100));
    }

    return null;
  }

  function confirmedGratuityLabel(){
    var amount = confirmedGratuityAmount();
    if (amount !== null && amount > 0) {
      return gratuityLabel() + ' · ' + formatMoney(amount);
    }
    return gratuityLabel();
  }

  function formatDoneTimestamp(value){
    if (!value) return '';
    try {
      var date = new Date(value);
      if (isNaN(date.getTime())) return String(value);
      return date.toLocaleString(undefined, {
        month:'short',
        day:'numeric',
        hour:'numeric',
        minute:'2-digit'
      });
    } catch (_error) {
      return String(value);
    }
  }

  function formatMoney(amount){
    var normalized = typeof amount === 'number' ? amount / 100 : 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(normalized);
  }

  function safeLocalStorageGet(key){
    try {
      return window.localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value){
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {}
  }

  function loadClientDashboard(){
    var raw = safeLocalStorageGet(CLIENT_DASHBOARD_STORAGE_KEY);
    if (!raw) {
      return {
        profile: null,
        appointments: []
      };
    }

    try {
      var parsed = JSON.parse(raw);
      return {
        profile: parsed && parsed.profile ? parsed.profile : null,
        appointments: Array.isArray(parsed && parsed.appointments) ? parsed.appointments : []
      };
    } catch (_error) {
      return {
        profile: null,
        appointments: []
      };
    }
  }

  function emptyLiveDashboardData(){
    return {
      profile: null,
      appointments: [],
      cards: [],
      vouchers: [],
      referral_codes: [],
      referrals: [],
      debug: null
    };
  }

  function loadSavedLiveDashboardData(){
    var raw = safeLocalStorageGet(CLIENT_DASHBOARD_LIVE_STORAGE_KEY);
    if (!raw) return emptyLiveDashboardData();
    try {
      var parsed = JSON.parse(raw);
      return {
        profile: parsed && parsed.profile ? parsed.profile : null,
        appointments: Array.isArray(parsed && parsed.appointments) ? parsed.appointments : [],
        cards: Array.isArray(parsed && parsed.cards) ? parsed.cards : [],
        vouchers: Array.isArray(parsed && parsed.vouchers) ? parsed.vouchers : [],
        referral_codes: Array.isArray(parsed && parsed.referral_codes) ? parsed.referral_codes : [],
        referrals: Array.isArray(parsed && parsed.referrals) ? parsed.referrals : [],
        debug: parsed && parsed.debug ? parsed.debug : null
      };
    } catch (_error) {
      return emptyLiveDashboardData();
    }
  }

  function loadSavedClientDashboardToken(){
    return safeLocalStorageGet(CLIENT_DASHBOARD_TOKEN_STORAGE_KEY) || '';
  }

  function saveClientDashboardToken(token){
    safeLocalStorageSet(CLIENT_DASHBOARD_TOKEN_STORAGE_KEY, String(token || '').trim());
  }

  function saveLiveDashboardData(data){
    safeLocalStorageSet(CLIENT_DASHBOARD_LIVE_STORAGE_KEY, JSON.stringify({
      profile: data && data.profile ? data.profile : null,
      appointments: Array.isArray(data && data.appointments) ? data.appointments : [],
      cards: Array.isArray(data && data.cards) ? data.cards : [],
      vouchers: Array.isArray(data && data.vouchers) ? data.vouchers : [],
      referral_codes: Array.isArray(data && data.referral_codes) ? data.referral_codes : [],
      referrals: Array.isArray(data && data.referrals) ? data.referrals : [],
      debug: data && data.debug ? data.debug : null
    }));
  }

  function normalizeAccountIdentifier(){
    return String(state.clientAccount.identifier || '').trim();
  }

  async function startClientAccountAuth(){
    var identifier = normalizeAccountIdentifier();
    if (!identifier) {
      throw new Error('Enter your email or phone first.');
    }

    state.clientAccount.loading = true;
    updateUI();

    try {
      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'client-auth-start',
          method: state.clientAccount.authMethod,
          identifier: identifier
        })
      });

      var data = await response.json().catch(function(){ return null; });
      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.error) || 'Could not start sign-in.');
      }

      state.clientAccount.authStart = data;
      state.clientAccount.requestId = String(data.request_id || '').trim();
      state.clientAccount.challengeToken = String(data.challenge_token || '').trim();
      state.clientAccount.authVerify = null;
      trackBookingSelection('next_visit_booking_auth_started', {
        auth_method: state.clientAccount.authMethod || 'phone',
        identifier: identifier
      });
      showDebug({
        debug: {
          source: 'clientAuthStart',
          response: data
        }
      });
      if (data.status === 'code_sent') {
        setMessage('Code sent. Enter it below to verify.', 'is-success');
      } else {
        setMessage(data.note || 'Sign-in start is not fully configured yet.', 'is-error');
      }
      return data;
    } finally {
      state.clientAccount.loading = false;
      updateUI();
    }
  }

  async function verifyClientAccountCode(){
    var identifier = normalizeAccountIdentifier();
    var code = String(state.clientAccount.verificationCode || '').trim();

    if (!identifier) {
      throw new Error('Enter your email or phone first.');
    }
    if (!code) {
      throw new Error('Enter the verification code.');
    }

    state.clientAccount.loading = true;
    updateUI();

    try {
      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'client-auth-verify',
          method: state.clientAccount.authMethod,
          identifier: identifier,
          code: code,
          request_id: state.clientAccount.requestId || null,
          challenge_token: state.clientAccount.challengeToken || null
        })
      });

      var data = await response.json().catch(function(){ return null; });
      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.error) || 'Could not verify sign-in code.');
      }

      state.clientAccount.authVerify = data;
      if (data && data.client_token) {
        state.clientAccount.clientToken = String(data.client_token || '').trim();
        saveClientDashboardToken(state.clientAccount.clientToken);
      }
      hydrateBookingProfileFromSignedInClient();
      trackBookingSelection('next_visit_booking_auth_verified', {
        auth_method: state.clientAccount.authMethod || 'phone',
        identifier: identifier,
        status: data && data.status ? data.status : ''
      });
      showDebug({
        debug: {
          source: 'clientAuthVerify',
          response: data
        }
      });
      if (data.status === 'signed_in') {
        await fetchClientDashboardBootstrap();
        await fetchClientDashboardData();
        setMessage('Signed in to your Boulevard account.', 'is-success');
      } else if (data.status === 'verified_no_session') {
        setMessage('Code verified. The next missing step is issuing the Boulevard client session.', 'is-success');
      } else {
        setMessage(data.note || 'Verification completed.', 'is-success');
      }
      return data;
    } finally {
      state.clientAccount.loading = false;
      updateUI();
    }
  }

  function saveClientDashboard(){
    safeLocalStorageSet(CLIENT_DASHBOARD_STORAGE_KEY, JSON.stringify(state.clientDashboard || {
      profile: null,
      appointments: []
    }));
  }

  function persistDashboardProfile(){
    var existing = state.clientDashboard && state.clientDashboard.profile ? state.clientDashboard.profile : null;
    var signedInProfile = (state.clientAccount && state.clientAccount.dashboardData && state.clientAccount.dashboardData.profile)
      || (state.clientAccount && state.clientAccount.authVerify && state.clientAccount.authVerify.client)
      || existing
      || null;
    var firstName = String((signedInProfile && (signedInProfile.firstName || signedInProfile.first_name)) || state.firstName || '').trim();
    var lastName = String((signedInProfile && (signedInProfile.lastName || signedInProfile.last_name)) || state.lastName || '').trim();
    var email = String((signedInProfile && signedInProfile.email) || state.email || '').trim();
    var phone = String((signedInProfile && (signedInProfile.mobilePhone || signedInProfile.phone)) || state.phone || '').trim();
    var id = String((signedInProfile && signedInProfile.id) || '').trim();

    if (!(firstName || lastName || email || phone || id)) return;
    state.clientDashboard.profile = {
      id: id,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
      mobilePhone: phone
    };
    saveClientDashboard();
  }

  function hydrateDashboardProfile(){
    state.clientDashboard = loadClientDashboard();
    state.clientAccount.clientToken = loadSavedClientDashboardToken();
    state.clientAccount.dashboardData = loadSavedLiveDashboardData();
    var profile = state.clientDashboard.profile || null;
    if (!profile) return;

    state.firstName = state.firstName || String(profile.first_name || '').trim();
    state.lastName = state.lastName || String(profile.last_name || '').trim();
    state.email = state.email || String(profile.email || '').trim();
    state.phone = state.phone || String(profile.phone || '').trim();

    if (firstNameInput) firstNameInput.value = state.firstName;
    if (lastNameInput) lastNameInput.value = state.lastName;
    if (emailInput) emailInput.value = state.email;
    if (phoneInput) phoneInput.value = state.phone;
  }

  function activeSignedInClientProfile(){
    var hasAttachedSession = !!(state.clientAccount && state.clientAccount.bootstrap && state.clientAccount.bootstrap.status === 'session_attached');
    var hasSavedToken = !!String(state.clientAccount && state.clientAccount.clientToken || '').trim();
    if (!hasAttachedSession && !hasSavedToken) return null;
    return (state.clientAccount.dashboardData && state.clientAccount.dashboardData.profile)
      || (state.clientAccount.authVerify && state.clientAccount.authVerify.client)
      || (state.clientDashboard && state.clientDashboard.profile)
      || null;
  }

  function hasSavedClientSession(){
    return !!String(state.clientAccount && state.clientAccount.clientToken || '').trim();
  }

  function hasLiveClientDashboardData(){
    var data = state.clientAccount && state.clientAccount.dashboardData;
    if (!data) return false;
    if (data.profile) return true;
    if (Array.isArray(data.appointments) && data.appointments.length) return true;
    if (Array.isArray(data.cards) && data.cards.length) return true;
    if (Array.isArray(data.vouchers) && data.vouchers.length) return true;
    if (Array.isArray(data.referrals) && data.referrals.length) return true;
    if (Array.isArray(data.referral_codes) && data.referral_codes.length) return true;
    return false;
  }

  function dashboardSessionLooksStale(data){
    var probeClientId = String(data && data.debug && data.debug.probe && data.debug.probe.client_id || '').trim();
    var hasProfile = !!(data && data.profile);
    var hasAppointments = !!(Array.isArray(data && data.appointments) && data.appointments.length);
    var hasCards = !!(Array.isArray(data && data.cards) && data.cards.length);
    var hasVouchers = !!(Array.isArray(data && data.vouchers) && data.vouchers.length);
    var hasReferralCodes = !!(Array.isArray(data && data.referral_codes) && data.referral_codes.length);
    var hasReferrals = !!(Array.isArray(data && data.referrals) && data.referrals.length);
    return !probeClientId && !hasProfile && !hasAppointments && !hasCards && !hasVouchers && !hasReferralCodes && !hasReferrals;
  }

  function hydrateBookingProfileFromSignedInClient(){
    var profile = activeSignedInClientProfile();
    if (!profile) return false;

    var firstName = String(profile.firstName || profile.first_name || '').trim();
    var lastName = String(profile.lastName || profile.last_name || '').trim();
    var email = String(profile.email || '').trim();
    var phone = String(profile.mobilePhone || profile.phone || '').trim();

    state.firstName = state.firstName || firstName;
    state.lastName = state.lastName || lastName;
    state.email = state.email || email;
    state.phone = state.phone || phone;

    if (firstNameInput) firstNameInput.value = state.firstName;
    if (lastNameInput) lastNameInput.value = state.lastName;
    if (emailInput) emailInput.value = state.email;
    if (phoneInput) phoneInput.value = state.phone;

    persistDashboardProfile();
    return !!(state.firstName && state.lastName && state.email && state.phone);
  }

  function clearDashboardAppointmentAction(){
    state.clientAccount.appointmentAction = {
      appointmentId: '',
      mode: '',
      loading: false,
      selectedDate: '',
      selectedTimeId: '',
      dates: [],
      times: []
    };
  }

  async function dashboardActionRequest(payload){
    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    var data = await response.json().catch(function(){ return null; });
    showDebug({
      debug: {
        source: 'dashboardAction',
        payload: payload,
        response: data,
        status: response.status
      }
    });
    if (!response.ok || !data || !data.ok) {
      throw new Error((data && data.error) || 'Could not update this appointment.');
    }
    return data;
  }

  async function cancelDashboardAppointment(appointmentId){
    state.clientAccount.appointmentAction = {
      appointmentId: appointmentId,
      mode: 'cancel',
      loading: true,
      selectedDate: '',
      selectedTimeId: '',
      dates: [],
      times: []
    };
    setMessage('Cancelling appointment…');
    renderDashboard();
    try {
      await dashboardActionRequest({
        action: 'client-appointment-cancel',
        client_token: state.clientAccount.clientToken,
        appointment_id: appointmentId
      });
      clearDashboardAppointmentAction();
      await fetchClientDashboardData();
      setMessage('Appointment cancelled.', 'is-success');
    } catch (error) {
      clearDashboardAppointmentAction();
      setMessage(error && error.message ? error.message : 'Could not cancel appointment.', 'is-error');
      return false;
    } finally {
      if (state.clientAccount.appointmentAction.appointmentId === appointmentId) {
        state.clientAccount.appointmentAction.loading = false;
      }
      renderDashboard();
    }
  }

  async function loadDashboardRescheduleDates(appointmentId){
    state.clientAccount.appointmentAction = {
      appointmentId: appointmentId,
      mode: 'reschedule-dates',
      loading: true,
      selectedDate: '',
      selectedTimeId: '',
      dates: [],
      times: []
    };
    setMessage('Loading reschedule dates…');
    renderDashboard();
    try {
      var data = await dashboardActionRequest({
        action: 'client-appointment-reschedule-dates',
        client_token: state.clientAccount.clientToken,
        appointment_id: appointmentId
      });
      state.clientAccount.appointmentAction = {
        appointmentId: appointmentId,
        mode: 'reschedule-dates',
        loading: false,
        selectedDate: '',
        selectedTimeId: '',
        dates: Array.isArray(data.dates) ? data.dates : [],
        times: []
      };
      setMessage(state.clientAccount.appointmentAction.dates.length ? 'Choose a new date.' : 'No reschedule dates are available right now.', state.clientAccount.appointmentAction.dates.length ? '' : 'is-error');
      renderDashboard();
    } catch (error) {
      clearDashboardAppointmentAction();
      setMessage(error && error.message ? error.message : 'Could not load reschedule dates.', 'is-error');
      renderDashboard();
      return false;
    }
  }

  async function loadDashboardRescheduleTimes(appointmentId, date){
    state.clientAccount.appointmentAction.loading = true;
    state.clientAccount.appointmentAction.selectedDate = date;
    state.clientAccount.appointmentAction.selectedTimeId = '';
    state.clientAccount.appointmentAction.times = [];
    setMessage('Loading times…');
    renderDashboard();
    try {
      var data = await dashboardActionRequest({
        action: 'client-appointment-reschedule-times',
        client_token: state.clientAccount.clientToken,
        appointment_id: appointmentId,
        date: date
      });
      state.clientAccount.appointmentAction.mode = 'reschedule-times';
      state.clientAccount.appointmentAction.loading = false;
      state.clientAccount.appointmentAction.times = Array.isArray(data.times) ? data.times : [];
      setMessage(state.clientAccount.appointmentAction.times.length ? 'Choose a new time.' : 'No times are available on that date.', state.clientAccount.appointmentAction.times.length ? '' : 'is-error');
      renderDashboard();
    } catch (error) {
      state.clientAccount.appointmentAction.loading = false;
      setMessage(error && error.message ? error.message : 'Could not load reschedule times.', 'is-error');
      renderDashboard();
      return false;
    }
  }

  async function confirmDashboardReschedule(appointmentId, bookableTimeId){
    state.clientAccount.appointmentAction.loading = true;
    state.clientAccount.appointmentAction.selectedTimeId = bookableTimeId;
    setMessage('Rescheduling appointment…');
    renderDashboard();
    try {
      await dashboardActionRequest({
        action: 'client-appointment-reschedule',
        client_token: state.clientAccount.clientToken,
        appointment_id: appointmentId,
        bookable_time_id: bookableTimeId
      });
      clearDashboardAppointmentAction();
      await fetchClientDashboardData();
      setMessage('Appointment rescheduled.', 'is-success');
    } catch (error) {
      setMessage(error && error.message ? error.message : 'Could not reschedule appointment.', 'is-error');
      return false;
    } finally {
      if (state.clientAccount.appointmentAction.appointmentId === appointmentId) {
        state.clientAccount.appointmentAction.loading = false;
      }
      renderDashboard();
    }
  }

  function renderBookingAccountInline(){
    if (!bookingAccountInline) return;
    bookingAccountInline.classList.remove('is-visible');
    bookingAccountInline.innerHTML = '';
  }

  function summaryPriceValue(item){
    if (!item) return null;
    var candidates = [
      item.total,
      item.price,
      item.booked_price,
      item.display_price,
      item.service_total,
      item.estimated_total
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      if (typeof candidates[i] === 'number' && isFinite(candidates[i])) return candidates[i];
    }
    return null;
  }

  function findSelectedSlot(){
    var selectedSlot = null;
    currentAvailabilityGroups.some(function(group){
      var slots = Array.isArray(group && group.slots) ? group.slots : [];
      return slots.some(function(slot){
        if (slot && slot.id === state.slotId) {
          selectedSlot = slot;
          return true;
        }
        return false;
      });
    });
    return selectedSlot;
  }

  function findBreakoutForService(item, breakout, index){
    if (!item || !Array.isArray(breakout) || !breakout.length) return null;
    for (var i = 0; i < breakout.length; i += 1) {
      var row = breakout[i];
      if (row && row.service_id && item.service_id && String(row.service_id) === String(item.service_id)) {
        return row;
      }
    }
    return breakout[index] || null;
  }

  function summaryAccountMarkup(){
    var profile = activeSignedInClientProfile();
    if (profile) {
      var firstName = String(profile.firstName || profile.first_name || '').trim();
      var lastName = String(profile.lastName || profile.last_name || '').trim();
      var fullName = [firstName, lastName].filter(Boolean).join(' ').trim() || dashboardProfileName(profile) || 'Signed in';
      var phone = String(profile.mobilePhone || profile.phone || '').trim();
      var email = String(profile.email || '').trim();
      return ''
        + '<div class="bk-summaryAccount">'
        +   '<p class="bk-summaryAccountLabel">Logged in</p>'
        +   '<p class="bk-summaryAccountName">' + escapeHtml(fullName) + '</p>'
        +   '<p class="bk-summaryAccountMeta">' + escapeHtml([phone, email].filter(Boolean).join(' · ')) + '</p>'
        +   '<button class="bk-summaryAccountAction" type="button" data-choice-type="dashboard-auth-reset">Use a different phone</button>'
        + '</div>';
    }

    if (state.clientAccount.authStart && state.clientAccount.requestId) {
      return ''
        + '<div class="bk-summaryAccount">'
        +   '<p class="bk-summaryAccountLabel">Verify your phone</p>'
        +   '<p class="bk-summaryAccountMeta">Enter the code we texted to keep this booking connected to your account and saved details.</p>'
        +   '<label class="bk-field bk-field--quiet"><span class="bk-label">Phone</span><input class="bk-input" id="bkDashboardIdentifier" inputmode="tel" placeholder="' + escapeHtml('+13105555555') + '" value="' + escapeHtml(state.clientAccount.identifier || '') + '" /></label>'
        +   '<label class="bk-field bk-field--quiet"><span class="bk-label">Verification code</span><input class="bk-input" id="bkDashboardCode" inputmode="numeric" placeholder="123456" value="' + escapeHtml(state.clientAccount.verificationCode || '') + '" /></label>'
        +   '<div class="bk-inlineActions">'
        +     '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="dashboard-auth-verify">' + escapeHtml(state.clientAccount.loading ? 'Checking…' : 'Verify code') + '</button>'
        +     '<button class="bk-btn bk-btn--ghost" type="button" data-choice-type="dashboard-auth-reset">Use a different phone</button>'
        +   '</div>'
        + '</div>';
    }

    return ''
      + '<div class="bk-summaryAccount">'
      +   '<p class="bk-summaryAccountLabel">Sign in with your phone</p>'
      +   '<p class="bk-summaryAccountMeta">Use the number already on file so we can pull in your saved details and keep booking seamless.</p>'
      +   '<label class="bk-field bk-field--quiet"><span class="bk-label">Phone</span><input class="bk-input" id="bkDashboardIdentifier" inputmode="tel" placeholder="' + escapeHtml('+13105555555') + '" value="' + escapeHtml(state.clientAccount.identifier || '') + '" /></label>'
      +   '<div class="bk-inlineActions">'
      +     '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="dashboard-auth-start">' + escapeHtml(state.clientAccount.loading ? 'Working…' : 'Text me a code') + '</button>'
      +   '</div>'
      + '</div>';
  }

  function summaryServicesMarkup(){
    if (!state.serviceStack.length) {
      return '<p class="bk-summaryNote">Your visit will gather here as you build it.</p>';
    }

    var selectedSlot = findSelectedSlot();
    var breakout = selectedSlot && Array.isArray(selectedSlot.service_breakout)
      ? selectedSlot.service_breakout
      : [];

    return '<div class="bk-summaryServices">' + state.serviceStack.map(function(item, index){
      var breakoutRow = findBreakoutForService(item, breakout, index);
      var metaParts = [];
      var stylist = breakoutRow && breakoutRow.staff_name
        ? String(breakoutRow.staff_name).trim()
        : String(item.stylist_name || '').trim();
      if (stylist) metaParts.push(stylist);
      if (item.selected_options && item.selected_options.length) {
        metaParts.push(item.selected_options.map(function(option){ return option.name; }).join(', '));
      }
      var linePrice = summaryPriceValue(breakoutRow);
      if (typeof linePrice !== 'number') linePrice = summaryPriceValue(item);
      if (typeof linePrice === 'number') metaParts.push(formatMoney(linePrice));

      return ''
        + '<div class="bk-summaryService">'
        +   '<p class="bk-summaryServiceName">' + escapeHtml(item.name) + '</p>'
        +   (metaParts.length ? '<p class="bk-summaryServiceMeta">' + escapeHtml(metaParts.join(' · ')) + '</p>' : '')
        + '</div>';
    }).join('') + '</div>';
  }

  async function fetchClientDashboardBootstrap(){
    state.clientAccount.loading = true;
    renderDashboard();

    try {
      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'client-dashboard-bootstrap',
          client_token: state.clientAccount.clientToken || null
        })
      });

      var data = await response.json().catch(function(){ return null; });
      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.error) || 'Could not load Boulevard account status.');
      }

      state.clientAccount.bootstrap = data;
      hydrateBookingProfileFromSignedInClient();
      saveClientDashboardToken(state.clientAccount.clientToken);
      return data;
    } finally {
      state.clientAccount.loading = false;
      renderDashboard();
    }
  }

  async function fetchClientDashboardData(){
    if (!state.clientAccount.clientToken) {
      state.clientAccount.dashboardData = null;
      return null;
    }

    state.clientAccount.loading = true;
    renderDashboard();

    try {
      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'client-dashboard-data',
          client_token: state.clientAccount.clientToken
        })
      });

      var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data || !data.ok) {
      throw new Error((data && data.error) || 'Could not load Boulevard appointments.');
    }

    state.clientAccount.dashboardData = data;
    saveLiveDashboardData(data);
    if (dashboardSessionLooksStale(data)) {
      state.clientAccount.bootstrap = null;
      state.clientAccount.dashboardData = null;
      state.clientAccount.clientToken = '';
      state.selectedSavedCardId = '';
      saveClientDashboardToken('');
      saveLiveDashboardData(emptyLiveDashboardData());
      throw new Error('Your saved Boulevard sign-in expired. Sign in again to load appointments and saved cards.');
    }
    if (data && data.profile) {
      state.clientDashboard.profile = data.profile;
      saveClientDashboard();
    }
    if (state.selectedSavedCardId) {
      var hasSelectedCard = Array.isArray(data.cards) && data.cards.some(function(card){
        return String(card && card.id || '').trim() === state.selectedSavedCardId;
        });
        if (!hasSelectedCard) {
          state.selectedSavedCardId = '';
        }
      }
      hydrateBookingProfileFromSignedInClient();
      showDebug({
        debug: {
          source: 'clientDashboardData',
          response: data
        }
      });
      return data;
    } finally {
      state.clientAccount.loading = false;
      renderDashboard();
    }
  }

  function dashboardAppointmentKey(record){
    if (!record) return '';
    var appointmentId = String(record.appointment_id || record.id || '').trim();
    if (appointmentId) return appointmentId;
    var appointmentIds = Array.isArray(record.appointment_ids) ? record.appointment_ids : [];
    var firstAppointmentId = String(appointmentIds[0] || '').trim();
    if (firstAppointmentId) return firstAppointmentId;
    return String(record.cart_id || '').trim();
  }

  function mergedDashboardAppointments(){
    var localAppointments = Array.isArray(state.clientDashboard && state.clientDashboard.appointments)
      ? state.clientDashboard.appointments.slice()
      : [];
    var remoteAppointments = Array.isArray(state.clientAccount && state.clientAccount.dashboardData && state.clientAccount.dashboardData.appointments)
      ? state.clientAccount.dashboardData.appointments.map(function(record){
          return {
            appointment_id: String(record && record.id || '').trim(),
            start_at: record && record.start_at || '',
            completed_at: '',
            slot_label: record && record.location_name
              ? record.location_name + ' · ' + formatDashboardDate(record && record.start_at, 'Scheduled visit')
              : formatDashboardDate(record && record.start_at, 'Scheduled visit'),
            services: Array.isArray(record && record.services) ? record.services : [],
            total: null,
            gratuity_amount: null,
            cart_id: '',
            guest: {
              email: state.clientAccount.dashboardData && state.clientAccount.dashboardData.profile && state.clientAccount.dashboardData.profile.email || '',
              phone: state.clientAccount.dashboardData && state.clientAccount.dashboardData.profile && state.clientAccount.dashboardData.profile.mobilePhone || ''
            },
            state: record && record.state || '',
            cancelled: !!(record && record.cancelled),
            cancellable: !!(record && record.cancellable),
            reschedulable: !!(record && record.reschedulable),
            notes: record && record.notes || '',
            location_name: record && record.location_name || ''
          };
        })
      : [];

    var merged = new Map();

    localAppointments.forEach(function(record){
      var key = dashboardAppointmentKey(record) || ('local-' + Math.random());
      merged.set(key, record);
    });

    remoteAppointments.forEach(function(record){
      var key = dashboardAppointmentKey(record) || ('remote-' + Math.random());
      var existing = merged.get(key);
      merged.set(key, existing ? Object.assign({}, record, existing) : record);
    });

    return Array.from(merged.values());
  }

  function isoDateValue(value){
    var text = String(value || '').trim();
    if (!text) return null;
    var parsed = new Date(text);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  function appointmentDate(record){
    return isoDateValue(record && (record.start_at || record.completed_at));
  }

  function appointmentSortValue(record){
    var date = appointmentDate(record);
    return date ? date.getTime() : 0;
  }

  function appointmentIsUpcoming(record){
    var date = appointmentDate(record);
    return !!date && date.getTime() >= Date.now();
  }

    function formatDashboardDate(value, fallback){
      var date = isoDateValue(value);
      if (!date) return fallback || 'Date unavailable';
      return new Intl.DateTimeFormat('en-US', {
      timeZone: DISPLAY_TIME_ZONE,
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
      }).format(date);
    }

    function formatDashboardDateOnly(value, fallback){
      var date = isoDateValue(value);
      if (!date) return fallback || 'Date unavailable';
      return new Intl.DateTimeFormat('en-US', {
        timeZone: DISPLAY_TIME_ZONE,
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      }).format(date);
    }

    function formatDashboardTimeOnly(value, fallback){
      var date = isoDateValue(value);
      if (!date) return fallback || 'Time unavailable';
      return new Intl.DateTimeFormat('en-US', {
        timeZone: DISPLAY_TIME_ZONE,
        hour: 'numeric',
        minute: '2-digit'
      }).format(date);
    }

  function dashboardProfileName(profile){
    return [profile && profile.first_name, profile && profile.last_name].filter(Boolean).join(' ').trim();
  }

  function storeConfirmedAppointment(){
    if (!state.confirmation || !state.confirmation.cart_id) return;

    var checkout = state.confirmation.checkout || {};
    var checkoutCart = checkout.cart || {};
    var summary = state.confirmation.summary || {};
    var appointments = Array.isArray(checkout.appointments) ? checkout.appointments : [];
    var appointmentIds = appointments.map(function(item){ return item && item.appointmentId; }).filter(Boolean);
    var record = {
      appointment_id: String(appointmentIds[0] || '').trim(),
      cart_id: state.confirmation.cart_id,
      appointment_ids: appointmentIds,
      completed_at: checkoutCart.completedAt || '',
      start_at: state.slotStartAt || '',
      slot_label: state.slotLabel || '',
      total: typeof summary.total === 'number' ? summary.total : null,
      subtotal: typeof summary.subtotal === 'number' ? summary.subtotal : null,
      gratuity_amount: typeof summary.gratuityAmount === 'number' ? summary.gratuityAmount : null,
      guest: {
        first_name: state.firstName || '',
        last_name: state.lastName || '',
        email: state.email || '',
        phone: state.phone || ''
      },
      services: state.serviceStack.map(function(item){
        return {
          key: item.key,
          name: item.name,
          stylist_name: item.stylist_name || 'No preference',
          options: (item.selected_options || []).map(function(option){
            return option.name;
          })
        };
      })
    };

    state.clientDashboard.profile = {
      id: String((activeSignedInClientProfile() && activeSignedInClientProfile().id) || '').trim(),
      first_name: state.firstName || '',
      last_name: state.lastName || '',
      email: state.email || '',
      phone: state.phone || '',
      mobilePhone: state.phone || ''
    };

    var existing = Array.isArray(state.clientDashboard.appointments)
      ? state.clientDashboard.appointments.filter(function(item){
          return item && item.cart_id !== record.cart_id;
        })
      : [];

    existing.unshift(record);
    existing.sort(function(a, b){
      return appointmentSortValue(b) - appointmentSortValue(a);
    });

    state.clientDashboard.appointments = existing.slice(0, 24);
    saveClientDashboard();
  }

  function formatTimeOnly(slot){
    if (slot && slot.start_at) {
      try {
        return new Intl.DateTimeFormat('en-US', {
          timeZone: DISPLAY_TIME_ZONE,
          hour: 'numeric',
          minute: '2-digit'
        }).format(new Date(slot.start_at));
      } catch (_error) {}
    }
    var label = String((slot && slot.label) || '');
    var parts = label.split(',');
    return parts.length ? parts[parts.length - 1].trim() : label;
  }

  function selectedBlowdryKey(){
    return state.answers.blowdryStyle === 'signature' ? 'blowdry_signature' : 'blowdry_classic';
  }

  function hasStandaloneBlowdryInVisit(){
    return state.answers.entryChoice === 'blowdry' || (state.answers.entryChoice === 'color' && state.answers.colorNeedsBlowdry === true && state.answers.colorNeedsHaircut !== true);
  }

  function serviceEndsWithFinishingService(){
    var last = state.serviceStack[state.serviceStack.length - 1];
    if (!last) return false;
    return isHaircutLikeServiceKey(last.key) || last.key === 'blowdry_classic' || last.key === 'blowdry_signature';
  }

  function serviceStackHasWetEnding(){
    if (!state.serviceStack.length) return false;
    if (serviceEndsWithFinishingService()) return false;
    return state.serviceStack.some(function(item){
      return item && (
        item.key === 'single_process' ||
        item.key === 'face_frame' ||
        item.key === 'partial_highlight' ||
        item.key === 'full_highlight'
      );
    });
  }

  function finishingScreenBeforeStylists(){
    if (!serviceStackHasWetEnding()) return '';

    if (state.answers.colorNeedsBlowdry === null) {
      return 'color-blowdry';
    }

    if (state.answers.colorNeedsBlowdry !== true) {
      return '';
    }

    if (!state.answers.blowdryStyle) {
      return 'blowdry-style';
    }

    if (!state.answers.blowdryHairType) {
      return 'blowdry-hair-type';
    }

    return '';
  }

  function resetStylistStep(){
    state.stylistStepIndex = 0;
  }

  function currentStylistService(){
    return state.serviceStack[state.stylistStepIndex] || null;
  }

  function advanceStylistStep(){
    if (state.stylistStepIndex < state.serviceStack.length - 1) {
      state.stylistStepIndex += 1;
      updateUI();
      return false;
    }
    return true;
  }

  function renderSummaryMeta(){
    if (!summaryMeta) return;
    if (state.screen === 'dashboard' && !state.serviceStack.length) {
      summaryMeta.innerHTML = '<p class="bk-summaryNote">Saved visits and account details.</p>';
      return;
    }

    var selectedSlot = findSelectedSlot();
    var breakout = selectedSlot && Array.isArray(selectedSlot.service_breakout)
      ? selectedSlot.service_breakout
      : [];
    var priceMarkup = '';
    if (state.slotId && state.slotEstimate && typeof state.slotEstimate.total === 'number') {
      priceMarkup = ''
        + '<div class="bk-summaryPrice">'
        +   '<span class="bk-summaryPriceLabel">Estimated total</span>'
        +   '<span class="bk-summaryPriceValue">' + escapeHtml(formatMoney(state.slotEstimate.total)) + '</span>'
        + '</div>'
        + '<div class="bk-summaryAppointment">'
        +   '<p class="bk-summaryAppointmentTime">' + escapeHtml(state.slotLabel || '') + '</p>'
        + '</div>'
        + '<p class="bk-summaryNote">Final price may vary with hair length or changes during the visit.</p>';
    } else if (state.serviceStack.length) {
      priceMarkup = '<p class="bk-summaryNote">Price and timing will show once you choose a time.</p>';
    }

    summaryMeta.classList.toggle('is-empty', false);
    summaryMeta.innerHTML = ''
      + summaryAccountMarkup()
      + summaryServicesMarkup()
      + priceMarkup;
  }

  function renderTimeMeta(){
    return;
  }

  function slotStaffSummary(slot){
    var breakout = Array.isArray(slot && slot.service_breakout) ? slot.service_breakout : [];
    var names = [];
    breakout.forEach(function(item){
      var name = String(item && item.staff_name || '').trim();
      if (name && names.indexOf(name) === -1) names.push(name);
    });
    if (!names.length) return '';
    if (names.length <= 2) return names.join(', ');
    return names.slice(0, 2).join(', ') + ' +' + String(names.length - 2);
  }

  function isRateLimitedBookingMessage(message){
    var raw = String(message || '').toLowerCase();
    return raw.indexOf('rate limit') > -1 || raw.indexOf('status=429') > -1 || raw.indexOf('api limit exceeded') > -1;
  }

  function clearSelectedSlotRetry(){
    if (selectedSlotRetryTimer) {
      clearTimeout(selectedSlotRetryTimer);
      selectedSlotRetryTimer = null;
    }
  }

  function bookingDelay(ms){
    return new Promise(function(resolve){
      setTimeout(resolve, ms);
    });
  }

  async function fetchSlotEstimateWithRetry(slotId, attempts){
    var maxAttempts = Math.max(1, Number(attempts) || 1);
    var lastError = null;
    for (var attempt = 0; attempt < maxAttempts; attempt += 1) {
      try {
        return await fetchSlotEstimate(slotId);
      } catch (error) {
        lastError = error;
        if (!isRateLimitedBookingMessage(error && error.message) || attempt >= maxAttempts - 1) {
          throw error;
        }
        await bookingDelay(300 * (attempt + 1));
      }
    }
    throw lastError || new Error('Could not load slot details.');
  }

  function scheduleSelectedSlotRetry(slotId, slotLabel, selectedSlot){
    clearSelectedSlotRetry();
    selectedSlotRetryTimer = setTimeout(async function(){
      selectedSlotRetryTimer = null;
      if (state.slotId !== slotId) return;
      try {
        var slotDetails = await fetchSlotEstimateWithRetry(slotId, 2);
        if (state.slotId !== slotId) return;
        state.slotEstimate = slotDetails && slotDetails.summary ? slotDetails.summary : null;
        if (selectedSlot) {
          selectedSlot.slot_summary = slotDetails && slotDetails.summary ? slotDetails.summary : null;
          selectedSlot.service_breakout = slotDetails && Array.isArray(slotDetails.service_breakout)
            ? slotDetails.service_breakout
            : [];
          selectedSlot.breakout_error = null;
        }
      } catch (_error) {
        if (state.slotId !== slotId) return;
      } finally {
        if (state.slotId === slotId) {
          renderTimeGroups(currentAvailabilityGroups, state.slotId);
          renderSummaryMeta();
          renderTimeMeta();
          updateUI();
        }
      }
    }, 1400);
  }

  function renderRangeChoices(){
    if (!rangeChoices) return;
    var options = weeklyRangeOptions();
    var selectedIndex = options.findIndex(function(option){
      return option.id === String(state.rangeKey || '').trim() ||
        (option.id === 'week_0' && state.rangeKey === 'this_week') ||
        (option.id === 'week_1' && state.rangeKey === 'next_week') ||
        (option.id === 'week_2' && state.rangeKey === 'in_2_weeks');
    });

    rangeChoices.innerHTML = options.map(function(option){
      var selected = option.id === String(state.rangeKey || '').trim() ||
        (option.id === 'week_0' && state.rangeKey === 'this_week') ||
        (option.id === 'week_1' && state.rangeKey === 'next_week') ||
        (option.id === 'week_2' && state.rangeKey === 'in_2_weeks');
      return ''
        + '<button class="bk-choice bk-choice--range' + (selected ? ' is-selected' : '') + '" type="button" data-choice-type="range" data-choice-id="' + escapeHtml(option.id) + '">'
        +   '<p class="bk-choice__title">' + escapeHtml(option.title) + '</p>'
        +   '<p class="bk-choice__meta">' + escapeHtml(option.meta) + '</p>'
        + '</button>';
    }).join('');

    if (rangePrevBtn) rangePrevBtn.disabled = selectedIndex <= 0;
    if (rangeNextBtn) rangeNextBtn.disabled = selectedIndex === -1 || selectedIndex >= options.length - 1;

    if (selectedIndex >= 0) {
      var selectedButton = rangeChoices.querySelector('[data-choice-id="' + options[selectedIndex].id + '"]');
      if (selectedButton && typeof selectedButton.scrollIntoView === 'function') {
        selectedButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }

  function shiftWeekRange(delta){
    var options = weeklyRangeOptions();
    var currentIndex = options.findIndex(function(option){
      return option.id === String(state.rangeKey || '').trim();
    });
    if (currentIndex < 0) currentIndex = 0;
    var nextIndex = Math.max(0, Math.min(options.length - 1, currentIndex + delta));
    if (nextIndex === currentIndex) return false;
    state.rangeKey = options[nextIndex].id;
    return true;
  }

  function canonicalServiceId(serviceId){
    var normalized = String(serviceId || '').trim();
    return SERVICE_ID_ALIASES[normalized] || normalized;
  }

  function servicePayload(){
    return state.serviceStack.map(function(item){
      return {
        service_id: canonicalServiceId(item.service_id),
        staff_id: item.stylist_id || 'any',
        preferred_staff_ids: Array.isArray(item.preferred_stylist_ids) ? item.preferred_stylist_ids.slice() : [],
        option_ids: (item.selected_options || []).map(function(option){
          return option.id;
        })
      };
    });
  }

  function findStaffOption(serviceId, staffId){
    var options = state.staffOptionsByService[serviceId] || [];
    return options.find(function(option){
      return option.id === staffId;
    }) || null;
  }

  function selectedStylistIdsForItem(item){
    if (Array.isArray(item && item.preferred_stylist_ids) && item.preferred_stylist_ids.length) {
      return item.preferred_stylist_ids.filter(Boolean);
    }
    if (item && item.stylist_id && item.stylist_id !== 'any') {
      return [item.stylist_id];
    }
    return [];
  }

  function stylistSummaryLabel(serviceId, selectedIds){
    var ids = Array.isArray(selectedIds) ? selectedIds.filter(Boolean) : [];
    if (!ids.length) return 'No preference';
    var labels = ids.map(function(staffId){
      var option = findStaffOption(serviceId, staffId);
      return option && option.name ? option.name : '';
    }).filter(Boolean);
    if (!labels.length) return 'Selected stylists';
    if (labels.length <= 2) return labels.join(', ');
    return labels.slice(0, 2).join(', ') + ' +' + String(labels.length - 2);
  }

  function hasServiceKey(key){
    return state.serviceStack.some(function(item){
      return item.key === key;
    });
  }

  function isHaircutLikeServiceKey(key){
    return key === 'haircut' ||
      key === 'curly_cut' ||
      key === 'haircut_pixie_short' ||
      key === 'mens_haircut';
  }

  function manualEntryHasStandardHaircut(){
    return state.answers.entryChoice === 'haircut' && state.answers.manualServiceKey === 'haircut';
  }

  function isHighlightServiceKey(key){
    return key === 'face_frame' || key === 'partial_highlight' || key === 'full_highlight';
  }

  function needsAirDryTransitionForServices(services){
    var items = Array.isArray(services) ? services : [];
    for (var i = 0; i < items.length - 1; i += 1) {
      var current = items[i];
      var next = items[i + 1];
      if (
        current &&
        current.key === 'single_process' &&
        next &&
        isHighlightServiceKey(next.key)
      ) {
        return true;
      }
    }
    return false;
  }

  function pushService(key){
    if (state.serviceStack.some(function(item){ return item.key === key; })) return;
    state.serviceStack.push({
      key: key,
      name: SERVICE_NAMES[key],
      service_id: canonicalServiceId(SERVICE_MAP[key]),
      stylist_id: 'any',
      stylist_name: 'No preference',
      preferred_stylist_ids: [],
      price: null,
      selected_options: []
    });
  }

  function selectedOptionsForService(key){
    var selected = [];

    if (
      key === 'single_process' &&
      (
        state.answers.singleProcessGlaze === true ||
        state.answers.colorGoal === 'darker_richer'
      )
    ) {
      selected.push(MODIFIER_MAP.single_process.glaze);
    }

    if (key === 'single_process' && needsAirDryTransitionForServices(state.serviceStack)) {
      selected.push(MODIFIER_MAP.single_process.air_dry_transition);
    }

    if (key === 'haircut') {
      if (state.answers.haircutLongOrThick === true) {
        selected.push(MODIFIER_MAP.haircut.long_thick);
      }
      if (state.answers.haircutBigChange === true) {
        selected.push(MODIFIER_MAP.haircut.big_change);
      }
    }

    if (key === 'extension_maintenance' && state.answers.extensionMaintenanceTracks) {
      selected.push(MODIFIER_MAP.extension_maintenance[state.answers.extensionMaintenanceTracks]);
    }

    if (
      (key === 'blowdry_classic' || key === 'blowdry_signature') &&
      state.answers.entryChoice === 'extensions' &&
      state.answers.manualServiceKey === 'extension_maintenance'
    ) {
      selected.push(MODIFIER_MAP[key].extensions);
    } else if ((key === 'blowdry_classic' || key === 'blowdry_signature') && state.answers.blowdryHairType) {
      selected.push(MODIFIER_MAP[key][state.answers.blowdryHairType]);
    }

    return selected.filter(Boolean);
  }

  function knownServiceKeyById(serviceId){
    serviceId = canonicalServiceId(serviceId);
    var keys = Object.keys(SERVICE_MAP);
    for (var i = 0; i < keys.length; i += 1) {
      if (canonicalServiceId(SERVICE_MAP[keys[i]]) === serviceId) return keys[i];
    }
    return '';
  }

  function knownServiceKeyByName(serviceName){
    var normalized = String(serviceName || '').trim().toLowerCase();
    if (!normalized) return '';

    var keys = Object.keys(SERVICE_NAMES);
    for (var i = 0; i < keys.length; i += 1) {
      if (String(SERVICE_NAMES[keys[i]] || '').trim().toLowerCase() === normalized) {
        return keys[i];
      }
    }
    return '';
  }

  function bookingEntryChoiceForServiceKey(serviceKey){
    var key = String(serviceKey || '').trim();
    if (!key) return '';
    if (key === 'haircut' || key === 'curly_cut' || key === 'haircut_pixie_short' || key === 'mens_haircut' || key === 'bang_trim') return 'haircut';
    if (key.indexOf('extension_') === 0) return 'extensions';
    if (key.indexOf('treatment_') === 0) return 'treatment';
    if (key.indexOf('blowdry_') === 0) return 'blowdry';
    return 'color';
  }

  function normalizedInlineBookingContext(rawContext){
    if (!rawContext || typeof rawContext !== 'object') return null;

    var entryChoice = String(rawContext.entry || rawContext.entryChoice || '').trim().toLowerCase();
    var manualServiceKey = String(rawContext.service || rawContext.manualServiceKey || '').trim();
    var serviceName = String(rawContext.service_name || rawContext.serviceName || '').trim();
    var rangeKey = String(rawContext.range || rawContext.rangeKey || '').trim();
    var identifier = String(rawContext.identifier || rawContext.client_identifier || rawContext.client_phone || rawContext.phone || '').trim();

    if (!manualServiceKey && serviceName) {
      manualServiceKey = knownServiceKeyByName(serviceName);
    }
    if (!entryChoice && manualServiceKey) {
      entryChoice = bookingEntryChoiceForServiceKey(manualServiceKey);
    }

    if (!entryChoice && !manualServiceKey && !identifier) return null;
    return {
      entryChoice: entryChoice,
      manualServiceKey: manualServiceKey,
      rangeKey: rangeKey,
      identifier: identifier
    };
  }

  function parsedBookingDeepLink(){
    try {
      var inlineContext = normalizedInlineBookingContext(window.HS_INLINE_BOOKING_CONTEXT || null);
      if (inlineContext) return inlineContext;

      var url = new URL(window.location.href);
      var entryChoice = String(url.searchParams.get('entry') || '').trim().toLowerCase();
      var manualServiceKey = String(url.searchParams.get('service') || '').trim();
      var serviceName = String(url.searchParams.get('service_name') || '').trim();
      var rangeKey = String(url.searchParams.get('range') || '').trim();
      var identifier = String(url.searchParams.get('phone') || '').trim();

      if (!manualServiceKey && serviceName) {
        manualServiceKey = knownServiceKeyByName(serviceName);
      }
      if (!entryChoice && manualServiceKey) {
        entryChoice = bookingEntryChoiceForServiceKey(manualServiceKey);
      }

      if (!entryChoice && !manualServiceKey && !identifier) return null;
      return {
        entryChoice: entryChoice,
        manualServiceKey: manualServiceKey,
        rangeKey: rangeKey,
        identifier: identifier
      };
    } catch (error) {
      return null;
    }
  }

  function applyBookingDeepLink(deepLink){
    if (!deepLink) return false;

    if (deepLink.identifier && !normalizeAccountIdentifier()) {
      state.clientAccount.identifier = deepLink.identifier;
    }

    if (deepLink.entryChoice) {
      state.answers.entryChoice = deepLink.entryChoice;
    }

    state.answers.manualServiceKey = deepLink.manualServiceKey || '';
    state.answers.extensionMaintenanceTracks = '';
    state.answers.extensionNeedsBlowdry = null;
    state.answers.treatmentNeedsHaircut = null;
    state.answers.treatmentNeedsBlowdry = null;
    state.answers.blowdryStyle = '';
    state.answers.blowdryHairType = '';
    state.answers.colorGoal = '';
    state.answers.colorDimensionPlacement = '';
    state.answers.colorNeedsHaircut = null;
    state.answers.colorNeedsBlowdry = null;
    state.answers.singleProcessGlaze = null;
    state.answers.haircutLongOrThick = null;
    state.answers.haircutBigChange = null;
    state.slotId = '';
    state.slotLabel = '';
    state.slotEstimate = null;
    state.slotEstimateLoading = false;
    state.availabilityLoading = false;
    state.rangeKey = rangeOptionForKey(deepLink.rangeKey) ? deepLink.rangeKey : 'week_0';
    resetStylistStep();
    currentAvailabilityGroups = [];
    rebuildServiceStack();

    if (state.answers.entryChoice) {
      var startScreen = nextFrom('entry');

      if (state.answers.manualServiceKey) {
        if (state.answers.entryChoice === 'haircut') {
          startScreen = nextFrom('haircut-type');
        } else if (state.answers.entryChoice === 'extensions') {
          startScreen = nextFrom('extensions-type');
        } else if (state.answers.entryChoice === 'treatment') {
          startScreen = nextFrom('treatment-type');
        }
      }

      goTo(startScreen);
      return true;
    }

    updateUI();
    return false;
  }

  function applyBookingDeepLinkIfPresent(){
    return applyBookingDeepLink(parsedBookingDeepLink());
  }

  window.HS_APPLY_INLINE_BOOKING_CONTEXT = function(context){
    window.HS_INLINE_BOOKING_CONTEXT = context || null;
    return applyBookingDeepLink(normalizedInlineBookingContext(window.HS_INLINE_BOOKING_CONTEXT));
  };

  function genericServiceKey(serviceId, serviceName, bookingOrder){
    var normalizedId = canonicalServiceId(serviceId) || '';
    var normalizedName = String(serviceName || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    var fallback = normalizedName || 'catalog_service';
    return 'catalog_' + (normalizedId || fallback) + '_' + String(bookingOrder || 99);
  }

  function photoOptionObjects(optionIds){
    return (Array.isArray(optionIds) ? optionIds : []).map(function(optionId){
      return {
        id: optionId,
        name: PHOTO_OPTION_NAMES[optionId] || optionId
      };
    });
  }

  function analysisSuggestsHaircut(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : [];

    return recommended.some(function(item){
      return isHaircutLikeServiceKey(knownServiceKeyById(item && item.service_id));
    });
  }

  function analysisSuggestsHaircutBigChange(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : [];

    return recommended.some(function(item){
      var key = knownServiceKeyById(item && item.service_id);
      var optionIds = Array.isArray(item && item.suggested_option_ids) ? item.suggested_option_ids : [];
      return key === 'haircut' && optionIds.indexOf(MODIFIER_MAP.haircut.big_change.id) !== -1;
    });
  }

  function analysisImpliesObviousLongToBobShift(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var currentHair = analysis && analysis.current_hair_analysis ? analysis.current_hair_analysis : {};
    var inspoHair = analysis && analysis.inspiration_hair_analysis ? analysis.inspiration_hair_analysis : {};
    var transformation = analysis && analysis.transformation_path ? analysis.transformation_path : {};
    var currentText = [
      technical.current_hair,
      currentHair.haircut,
      currentHair.notes
    ].join(' ').toLowerCase();
    var inspoText = [
      technical.inspiration_hair,
      inspoHair.haircut,
      inspoHair.notes
    ].join(' ').toLowerCase();
    var haircutText = [
      analysis && analysis.consultation_trace && analysis.consultation_trace.haircut_plan,
      transformation.summary
    ].join(' ').toLowerCase();
    var summaryText = String(analysis && analysis.summary || '').toLowerCase();

    var currentLong = /(?:^|\W)long(?:\W|$)|long hair|longer hair|long length|long lengths|below shoulders|below the shoulders|mid-?back|shoulder length|shoulder-length|past shoulder/.test(currentText) ||
      /long hair|longer hair|below shoulders|past shoulder|major haircut|significant haircut/.test(summaryText);
    var currentMedium = /just above shoulders|above shoulders|above the shoulders|collarbone|neck length|medium-length|medium length|shoulder skimming|shoulder-skimming/.test(currentText);
    var inspoBob = /bob|chin-length|chin length|jaw-length|jaw length|short bob|above shoulders|above the shoulders|just above shoulders|just above the shoulders/.test(inspoText) ||
      /bob|chin-length|chin length|jaw-length|jaw length|shorter bob|short textured bob|textured bob|above shoulders|just above shoulders/.test(haircutText) ||
      /shorter, textured bob|short textured bob|chin-length bob|short bob|textured bob|above shoulders|just above shoulders/.test(summaryText);
    var inspoShortBob = /chin-length|chin length|jaw-length|jaw length|short bob|blunt bob|chin-length bob/.test(inspoText) ||
      /chin-length|chin length|jaw-length|jaw length|short bob|blunt bob|shorter bob/.test(haircutText) ||
      /chin-length bob|jaw-length bob|short bob|blunt bob/.test(summaryText);

    return (currentLong && inspoBob) || (currentMedium && inspoShortBob);
  }

  function analysisImpliesClearlyNotBigChange(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var currentHair = analysis && analysis.current_hair_analysis ? analysis.current_hair_analysis : {};
    var inspoHair = analysis && analysis.inspiration_hair_analysis ? analysis.inspiration_hair_analysis : {};
    var transformation = analysis && analysis.transformation_path ? analysis.transformation_path : {};
    var currentText = [
      technical.current_hair,
      currentHair.haircut,
      currentHair.notes
    ].join(' ').toLowerCase();
    var inspoText = [
      technical.inspiration_hair,
      inspoHair.haircut,
      inspoHair.notes
    ].join(' ').toLowerCase();
    var haircutText = [
      analysis && analysis.consultation_trace && analysis.consultation_trace.haircut_plan,
      transformation.summary,
      Array.isArray(transformation.steps) ? transformation.steps.join(' ') : ''
    ].join(' ').toLowerCase();
    var summaryText = String(analysis && analysis.summary || '').toLowerCase();
    var combined = [currentText, inspoText, haircutText, summaryText].join(' ');

    var currentBobFamily = /bob|lob|shoulder length|shoulder-length|shoulder length cut|shoulder-length cut|chin-length|jaw-length/.test(currentText);
    var inspoBobFamily = /bob|lob|shoulder length|shoulder-length|chin-length|jaw-length/.test(inspoText) ||
      /bob|lob|chin-length|jaw-length|blunt bob|textured bob/.test(haircutText);
    var refinementLanguage = /refresh|refine|maintain|cleanup|reshape|same length|similar length|polish|same-family|moderate|no big change|without a big change/.test(combined);
    var obviousMajorCutLanguage = /significant length change|major haircut change|big change|dramatic cut|much shorter/.test(combined);
    var colorFirstLanguage = /full highlight|partial highlight|face frame|brightness|blonde|tone|root shadow|pretone|dimension/.test(combined);

    if (currentBobFamily && inspoBobFamily) return true;
    if (currentBobFamily && /bob|lob|blunt bob|textured bob/.test(combined) && colorFirstLanguage) return true;
    if (/no big change needed|same-family bobs|same family bobs|haircut refinement is moderate|polish rather than major shape change/.test(combined)) return true;
    if (obviousMajorCutLanguage && !currentBobFamily) return false;
    if (refinementLanguage && !analysisImpliesObviousLongToBobShift(analysis)) return true;
    return false;
  }

  function analysisImpliesHaircutLongOrThick(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var currentHair = analysis && analysis.current_hair_analysis ? analysis.current_hair_analysis : {};
    var summaryText = String(analysis && analysis.summary || '').toLowerCase();
    var combined = [
      technical.current_hair,
      technical.transformation_analysis,
      currentHair.haircut,
      currentHair.texture,
      currentHair.notes,
      analysis && analysis.transformation_path && analysis.transformation_path.summary,
      summaryText
    ].join(' ').toLowerCase();

    var obviousLength =
      /very long|extra long|long hair|long lengths|below shoulders|below the shoulders|mid-?back|past shoulder|waist-length|long one-length/.test(combined);
    var obviousDensity =
      /very dense|dense hair|high density|thick hair|very thick|heavy density|a lot of hair|bulk|bulky/.test(combined);

    return obviousLength || obviousDensity;
  }

  function analysisImpliesClearlyNotHaircutLongOrThick(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var currentHair = analysis && analysis.current_hair_analysis ? analysis.current_hair_analysis : {};
    var summaryText = String(analysis && analysis.summary || '').toLowerCase();
    var combined = [
      technical.current_hair,
      currentHair.haircut,
      currentHair.texture,
      currentHair.notes,
      summaryText
    ].join(' ').toLowerCase();

    var shorterShape =
      /bob|lob|chin-length|jaw-length|shoulder-length|shoulder length/.test(combined);
    var lighterDensity =
      /fine|fine to medium density|medium density|not thick|little volume|flat/.test(combined);
    var explicitLongOrThick =
      /very long|extra long|long hair|long lengths|below shoulders|mid-?back|past shoulder|very dense|dense hair|high density|thick hair|very thick|heavy density/.test(combined);

    if (explicitLongOrThick) return false;
    if (shorterShape && lighterDensity) return true;
    return false;
  }

  function applyInferredPhotoConsultAnswers(analysis){
    if (!analysis) return;

    var focusAreas = getPhotoInspoFocusSelections();
    var hasExplicitFocusAreas = Array.isArray(focusAreas) && focusAreas.length;
    if (Array.isArray(focusAreas) && focusAreas.length) {
      delete state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID];
      state.photoFollowUpAnswers[PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID] = focusAreas.slice();
      if (focusAreas.indexOf('haircut') !== -1) {
        state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] = true;
      }
    }

    if (
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_HAIRCUT_CONFIRM_QUESTION_ID) &&
      (state.photoFollowUpAnswers.haircut_intent === true ||
        state.photoFollowUpAnswers.haircut_intent === 'yes' ||
        state.photoFollowUpAnswers.haircut_shape_intent === 'yes' ||
        state.photoFollowUpAnswers.haircut_shape_intent === 'shape_like_inspo' ||
        state.photoFollowUpAnswers.haircut_shape_intent === 'blunt_bob')
    ) {
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] = true;
    }

    if (
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true &&
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID) &&
      analysisImpliesObviousLongToBobShift(analysis)
    ) {
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] = true;
    } else if (
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true &&
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID) &&
      analysisImpliesClearlyNotBigChange(analysis)
    ) {
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] = false;
    }

    if (state.answers.haircutBigChange === null) {
      if (state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] === true) {
        state.answers.haircutBigChange = true;
      } else if (
        state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] === false ||
        analysisImpliesClearlyNotBigChange(analysis)
      ) {
        state.answers.haircutBigChange = false;
      }
    }

    if (
      findAnyPhotoHaircutService() ||
      analysisSuggestsHaircut(analysis) ||
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true
    ) {
      if (state.answers.haircutLongOrThick === null && analysisImpliesHaircutLongOrThick(analysis)) {
        state.answers.haircutLongOrThick = true;
      } else if (
        state.answers.haircutLongOrThick === null &&
        analysisImpliesClearlyNotHaircutLongOrThick(analysis)
      ) {
        state.answers.haircutLongOrThick = false;
      }
    }
  }

  function analysisSuggestsSingleProcess(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : [];

    return recommended.some(function(item){
      if (knownServiceKeyById(item && item.service_id) !== 'single_process') return false;
      return (Number(item && item.confidence) || 0) > 0 && (Number(item && item.booking_order) || 0) > 0;
    });
  }

  function analysisSuggestsPhotoColorWork(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : [];

    return recommended.some(function(item){
      var key = knownServiceKeyById(item && item.service_id);
      return key === 'single_process' || key === 'face_frame' || key === 'partial_highlight' || key === 'full_highlight';
    });
  }

  function analysisSuggestsSingleProcessExtraColorNeed(analysis){
    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var trace = analysis && analysis.consultation_trace ? analysis.consultation_trace : {};
    var combined = [
      technical.current_hair,
      technical.transformation_analysis,
      trace.base_color_plan,
      trace.booking_logic,
      analysis && analysis.summary
    ].join(' ').toLowerCase();

    return /extra long|very long|long and thick|long\/thick|very dense|dense hair|high density|thick hair|heavy density|extra product/.test(combined);
  }

  function analysisSuggestsSingleProcessGlazeNeed(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : (analysis && analysis.booking_strategy && Array.isArray(analysis.booking_strategy.recommended_services)
        ? analysis.booking_strategy.recommended_services
        : []);

    var hasExplicitGlazeOption = recommended.some(function(item){
      var optionIds = Array.isArray(item && item.suggested_option_ids) ? item.suggested_option_ids : [];
      return knownServiceKeyById(item && item.service_id) === 'single_process' &&
        optionIds.indexOf(MODIFIER_MAP.single_process.glaze.id) !== -1;
    });

    if (hasExplicitGlazeOption) return true;

    var technical = analysis && analysis.technical_analysis ? analysis.technical_analysis : {};
    var trace = analysis && analysis.consultation_trace ? analysis.consultation_trace : {};
    var transformation = analysis && analysis.transformation_path ? analysis.transformation_path : {};
    var combined = [
      technical.current_hair,
      technical.transformation_analysis,
      trace.base_color_plan,
      trace.dimension_plan,
      trace.booking_logic,
      transformation.summary,
      Array.isArray(transformation.steps) ? transformation.steps.join(' ') : '',
      analysis && analysis.summary
    ].join(' ').toLowerCase();

    return /\bglaze\b|\bgloss\b|glossing|tonal refresh|tone refresh|toner|shine|shinier|reflect|re-?gloss|refresh (?:the )?ends|refresh faded ends/.test(combined);
  }

  function goalMentionsGrayCoverage(){
    return /\b(gray|grey|root touch(?:\s|-)?up|cover(?:ing)? gray)\b/i.test(String(state.photoGoal || ''));
  }

  function inferPhotoPreAnalysisAnswersFromGoal(){
    var goalText = String(state.photoGoal || '').trim().toLowerCase();
    var answers = {};
    if (!goalText) return answers;

    if (/\b(no gray|no grey|not gray|not grey|don'?t cover gray|dont cover gray|skip gray)\b/.test(goalText)) {
      answers[PHOTO_GRAY_COVERAGE_QUESTION_ID] = 'no_gray';
      return answers;
    }

    if (/\b(gray|grey|root touch(?:\s|-)?up|cover(?:ing)? gray|gray coverage|grey coverage)\b/.test(goalText)) {
      answers[PHOTO_GRAY_COVERAGE_QUESTION_ID] = 'gray_coverage';
    }

    return answers;
  }

  function analysisHasGrayCoverageQuestion(questions){
    return questions.some(function(question){
      var idText = String(question && question.id || '');
      var questionText = String(question && question.question || '');
      return /gray|grey/.test(idText) || /gray|grey/.test(questionText);
    });
  }

  function photoHaircutBigChangeConfirmed(){
    if (state.photoAnalysis && analysisImpliesClearlyNotBigChange(state.photoAnalysis)) {
      return false;
    }
    return state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] === true;
  }

  function effectivePhotoHaircutBigChangeAnswer(){
    if (state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] === true) return true;
    if (state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID] === false) return false;
    if (state.photoAnalysis && analysisImpliesObviousLongToBobShift(state.photoAnalysis)) return true;
    if (state.photoAnalysis && analysisImpliesClearlyNotBigChange(state.photoAnalysis)) return false;
    return null;
  }

  function photoGrayCoverageNeeded(){
    return state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID] === 'gray_coverage' ||
      state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID] === 'full_coverage' ||
      state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID] === 'soft_blending';
  }

  function photoSingleProcessBookingNeeded(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : [];
    if (!recommended.length) return false;

    var grayStrategy = state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID];
    if (state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID] === 'gray_coverage') return true;
    if (grayStrategy === 'full_coverage') return true;
    if (grayStrategy === 'soft_blending') return true;
    return false;
  }

  function findPhotoSuggestedService(key){
    return state.photoSuggestedServices.find(function(item){
      return item.key === key;
    }) || null;
  }

  function findAnyPhotoHaircutService(){
    return state.photoSuggestedServices.find(function(item){
      return isHaircutLikeServiceKey(item && item.key);
    }) || null;
  }

  function photoServiceHasOption(key, optionId){
    var service = findPhotoSuggestedService(key);
    return !!(service && Array.isArray(service.selected_options) && service.selected_options.some(function(option){
      return option && option.id === optionId;
    }));
  }

  function photoSelectedBlowdryKey(){
    if (findPhotoSuggestedService('blowdry_signature')) return 'blowdry_signature';
    if (findPhotoSuggestedService('blowdry_classic')) return 'blowdry_classic';
    return '';
  }

  function buildPhotoSuggestedServices(analysis){
    var recommended = analysis && Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : (analysis && analysis.booking_strategy && Array.isArray(analysis.booking_strategy.recommended_services)
        ? analysis.booking_strategy.recommended_services
        : []);
    var hasStandaloneGlazeRecommendation = recommended.some(function(item){
      return knownServiceKeyById(item && item.service_id) === 'standalone_glaze';
    });

    var services = recommended.map(function(item){
      if ((Number(item && item.confidence) || 0) <= 0) return null;
      var normalizedServiceId = canonicalServiceId(item.service_id);
      var key = knownServiceKeyById(normalizedServiceId) || knownServiceKeyByName(item && item.service_name);
      var bookingOrder = Number(item && item.booking_order) || 99;
      if (!key) {
        return {
          key: genericServiceKey(normalizedServiceId, item && item.service_name, bookingOrder),
          name: String(item && item.service_name || 'Service').trim() || 'Service',
          service_id: normalizedServiceId,
          stylist_id: 'any',
          stylist_name: 'No preference',
          preferred_stylist_ids: [],
          selected_options: photoOptionObjects(item && item.suggested_option_ids),
          booking_order: bookingOrder
        };
      }
      if (isHaircutLikeServiceKey(key) && state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] !== true) {
        return null;
      }

      var selectedOptions = photoOptionObjects(item.suggested_option_ids);
      if (key === 'single_process') {
        var keepGlaze = selectedOptions.some(function(option){
          return option.id === MODIFIER_MAP.single_process.glaze.id;
        }) || (
          !hasStandaloneGlazeRecommendation &&
          (state.answers.singleProcessGlaze === true || analysisSuggestsSingleProcessGlazeNeed(analysis))
        );
        var keepExtraColor = selectedOptions.some(function(option){
          return option.id === MODIFIER_MAP.single_process.extra_color.id;
        }) && analysisSuggestsSingleProcessExtraColorNeed(analysis);

        selectedOptions = selectedOptions.filter(function(option){
          return option.id !== MODIFIER_MAP.single_process.glaze.id &&
            option.id !== MODIFIER_MAP.single_process.extra_color.id &&
            option.id !== MODIFIER_MAP.single_process.air_dry_transition.id;
        });

        if (keepGlaze) {
          selectedOptions.push(MODIFIER_MAP.single_process.glaze);
        }
        if (keepExtraColor) {
          selectedOptions.push(MODIFIER_MAP.single_process.extra_color);
        }
      }

      if (key === 'haircut') {
        selectedOptions = selectedOptions.filter(function(option){
          return option.id !== MODIFIER_MAP.haircut.big_change.id &&
            option.id !== MODIFIER_MAP.haircut.long_thick.id;
        });

        if (state.answers.haircutLongOrThick === true) {
          selectedOptions.push(MODIFIER_MAP.haircut.long_thick);
        }

        if (photoHaircutBigChangeConfirmed()) {
          selectedOptions.push(MODIFIER_MAP.haircut.big_change);
        }
      }

      if (key === 'blowdry_classic' || key === 'blowdry_signature') {
        selectedOptions = selectedOptions.filter(function(option){
          return option.id !== MODIFIER_MAP[key].standard.id &&
            option.id !== MODIFIER_MAP[key].long_thick.id &&
            option.id !== MODIFIER_MAP[key].extensions.id;
        });

        if (state.answers.blowdryHairType && MODIFIER_MAP[key][state.answers.blowdryHairType]) {
          selectedOptions.push(MODIFIER_MAP[key][state.answers.blowdryHairType]);
        }
      }

      return {
        key: key,
        name: SERVICE_NAMES[key],
        service_id: canonicalServiceId(SERVICE_MAP[key]),
        stylist_id: 'any',
        stylist_name: 'No preference',
        preferred_stylist_ids: [],
        selected_options: selectedOptions,
        booking_order: bookingOrder
      };
    }).filter(Boolean).sort(function(a, b){
      return (a.booking_order || 99) - (b.booking_order || 99);
    });

    if (
      photoSingleProcessBookingNeeded(analysis) &&
      !services.some(function(item){ return item.key === 'single_process'; })
    ) {
      services.unshift({
        key: 'single_process',
        name: SERVICE_NAMES.single_process,
        service_id: canonicalServiceId(SERVICE_MAP.single_process),
        stylist_id: 'any',
        stylist_name: 'No preference',
        preferred_stylist_ids: [],
        selected_options: analysisSuggestsSingleProcessGlazeNeed(analysis)
          ? [MODIFIER_MAP.single_process.glaze]
          : []
      });
    }

    if (needsAirDryTransitionForServices(services)) {
      services = services.map(function(item){
        if (item.key !== 'single_process') return item;

        var selectedOptions = (item.selected_options || []).filter(function(option){
          return option.id !== MODIFIER_MAP.single_process.air_dry_transition.id;
        });
        selectedOptions.push(MODIFIER_MAP.single_process.air_dry_transition);

        return {
          key: item.key,
          name: item.name,
          service_id: item.service_id,
          stylist_id: item.stylist_id,
          stylist_name: item.stylist_name,
          preferred_stylist_ids: item.preferred_stylist_ids || [],
          selected_options: selectedOptions,
          booking_order: item.booking_order
        };
      });
    }

    var singleProcessHasGlaze = services.some(function(item){
      return item.key === 'single_process' && Array.isArray(item.selected_options) && item.selected_options.some(function(option){
        return option && option.id === MODIFIER_MAP.single_process.glaze.id;
      });
    });

    if (singleProcessHasGlaze) {
      var seenPrepGloss = false;
      services = services.filter(function(item){
        if (item.key !== 'standalone_glaze') return true;
        var matchingRecommendation = recommended.find(function(rec){
          return canonicalServiceId(rec && rec.service_id) === canonicalServiceId(item.service_id) &&
            Number(rec && rec.booking_order) === Number(item.booking_order);
        });
        var reasonText = String((matchingRecommendation && matchingRecommendation.reason) || '').toLowerCase();
        var isPrepGloss = /\bpre-?fill\b|\bpre fill\b|repigment|re-?pigment|filler step|fill first|deposit first|prepare.*darken/.test(reasonText);
        if (isPrepGloss) {
          if (seenPrepGloss) return false;
          seenPrepGloss = true;
          return true;
        }
        return false;
      });
    }

    if (photoHaircutBigChangeConfirmed()) {
      services = services.slice().sort(function(a, b){
        var aIsBigChangeHaircut = a && a.key === 'haircut' && Array.isArray(a.selected_options) && a.selected_options.some(function(option){
          return option && option.id === MODIFIER_MAP.haircut.big_change.id;
        });
        var bIsBigChangeHaircut = b && b.key === 'haircut' && Array.isArray(b.selected_options) && b.selected_options.some(function(option){
          return option && option.id === MODIFIER_MAP.haircut.big_change.id;
        });

        if (aIsBigChangeHaircut && !bIsBigChangeHaircut) return -1;
        if (!aIsBigChangeHaircut && bIsBigChangeHaircut) return 1;

        return (a.booking_order || 99) - (b.booking_order || 99);
      }).map(function(item, index){
        return {
          key: item.key,
          name: item.name,
          service_id: item.service_id,
          stylist_id: item.stylist_id,
          stylist_name: item.stylist_name,
          preferred_stylist_ids: item.preferred_stylist_ids || [],
          selected_options: item.selected_options,
          booking_order: index + 1
        };
      });
    }

    var hasPhotoHaircutService = services.some(function(item){
      return isHaircutLikeServiceKey(item && item.key);
    });

    if (hasPhotoHaircutService) {
      services = services.filter(function(item){
        return item.key !== 'blowdry_classic' && item.key !== 'blowdry_signature';
      }).map(function(item, index){
        return {
          key: item.key,
          name: item.name,
          service_id: item.service_id,
          stylist_id: item.stylist_id,
          stylist_name: item.stylist_name,
          preferred_stylist_ids: item.preferred_stylist_ids || [],
          selected_options: item.selected_options,
          booking_order: index + 1
        };
      });
    }

    return services;
  }

  function nextPhotoServiceDetailScreen(){
    var effectiveHaircutBigChange = effectivePhotoHaircutBigChangeAnswer();
    if (state.answers.haircutBigChange === null && effectiveHaircutBigChange !== null) {
      state.answers.haircutBigChange = effectiveHaircutBigChange;
    }

    if (
      !findAnyPhotoHaircutService() &&
      analysisSuggestsPhotoColorWork(state.photoAnalysis) &&
      state.answers.colorNeedsHaircut === null
    ) {
      return 'color-haircut';
    }

    var blowdryKey = photoSelectedBlowdryKey();
    if (
      blowdryKey &&
      !state.answers.blowdryHairType &&
      !photoServiceHasOption(blowdryKey, MODIFIER_MAP[blowdryKey].standard.id) &&
      !photoServiceHasOption(blowdryKey, MODIFIER_MAP[blowdryKey].long_thick.id) &&
      !photoServiceHasOption(blowdryKey, MODIFIER_MAP[blowdryKey].extensions.id)
    ) {
      state.answers.blowdryStyle = blowdryKey === 'blowdry_signature' ? 'signature' : 'classic';
      return 'blowdry-hair-type';
    }

    if (
      findPhotoSuggestedService('haircut') &&
      state.answers.haircutLongOrThick === null &&
      !photoServiceHasOption('haircut', MODIFIER_MAP.haircut.long_thick.id)
    ) {
      return 'modifier-haircut-thick';
    }

    if (
      findPhotoSuggestedService('haircut') &&
      state.answers.haircutBigChange === null &&
      !photoServiceHasOption('haircut', MODIFIER_MAP.haircut.big_change.id)
    ) {
      return 'modifier-haircut-change';
    }

    return '';
  }

  function renderPreviewCards(container, items, emptyText){
    if (!items.length) {
      container.innerHTML = ''
        + '<div class="bk-empty bk-empty--photo">'
        +   '<div class="bk-emptyPhotoText">'
        +     '<div class="bk-emptyPhotoPrimary">Drop photos or click.</div>'
        +     '<div class="bk-emptyPhotoSecondary">Up to 6.</div>'
        +   '</div>'
        + '</div>';
      return;
    }

    container.innerHTML = items.map(function(item, index){
      return ''
        + '<div class="bk-photoCard">'
        +   '<img src="' + escapeHtml(item.dataUrl) + '" alt="Photo ' + (index + 1) + '">'
        + '</div>';
    }).join('');
  }

  function syncPhotoDropzoneState(){
    if (currentDropzoneCount) {
      currentDropzoneCount.textContent = currentPhotoImages.length + ' of 6';
    }
    if (inspoDropzoneCount) {
      inspoDropzoneCount.textContent = inspirationPhotoImages.length + ' of 6';
    }
    if (currentDropzone) {
      currentDropzone.setAttribute('data-has-files', currentPhotoImages.length ? 'true' : 'false');
    }
    if (inspoDropzone) {
      inspoDropzone.setAttribute('data-has-files', inspirationPhotoImages.length ? 'true' : 'false');
    }
  }

  function renderPhotoPreviews(){
    renderPreviewCards(currentPhotoPreviews, currentPhotoImages, 'No current photos yet.');
    renderPreviewCards(inspoPhotoPreviews, inspirationPhotoImages, 'No inspiration photos yet.');
    syncPhotoDropzoneState();
  }

  function normalizedPhotoQuestions(analysis){
    var bundle = analysis && analysis.question_bundle ? analysis.question_bundle : null;
    var raw = [];
    if (bundle && Array.isArray(bundle.must_know_for_path) && bundle.must_know_for_path.length) {
      raw = bundle.must_know_for_path.slice();
      if (Array.isArray(bundle.helpful_preferences) && bundle.helpful_preferences.length) {
        raw = raw.concat(bundle.helpful_preferences);
      }
    } else if (bundle && Array.isArray(bundle.helpful_preferences) && bundle.helpful_preferences.length) {
      raw = bundle.helpful_preferences.slice();
    } else if (Array.isArray(analysis && analysis.follow_up_questions)) {
      raw = analysis.follow_up_questions;
    }

    var questions = raw.map(function(item, index){
      if (typeof item === 'string') {
        return {
          id: 'question_' + (index + 1),
          question: item,
          type: 'boolean',
          options: []
        };
      }

      if (!item || typeof item !== 'object') return null;

      var questionId = String(item.id || ('question_' + (index + 1))).trim();
      if (questionId === PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID) {
        questionId = PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID;
      }
      var questionText = String(item.question || '').trim();
      if (!questionText) return null;

      var rawType = String(item.type || 'boolean').trim().toLowerCase();
      var type = rawType === 'single_select' || rawType === 'multi_select'
        ? rawType
        : 'boolean';
      var options = (type === 'single_select' || type === 'multi_select') && Array.isArray(item.options)
        ? item.options.map(function(option, optionIndex){
            if (!option || typeof option !== 'object') return null;
            var optionId = String(option.id || ('option_' + (optionIndex + 1))).trim();
            var optionLabel = String(option.label || '').trim();
            if (!optionId || !optionLabel) return null;
            return {
              id: optionId,
              label: optionLabel,
              description: String(option.description || '').trim()
            };
          }).filter(Boolean)
        : [];

      return {
        id: questionId,
        question: questionText,
        type: type,
        options: options
      };
    }).filter(Boolean);

    questions = questions.map(function(question){
      var text = String(question && question.question || '').toLowerCase();
      var looksLikeInspoCarryover = /carry over from (the )?inspo|carry over from (the )?inspiration|parts of the inspiration|what do you want from the inspiration|choose everything that applies|select all that apply/.test(text);

      if (
        question.id !== PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID &&
        looksLikeInspoCarryover
      ) {
        return {
          id: PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID,
          question: question.question,
          type: 'multi_select',
          options: Array.isArray(question.options) && question.options.length
            ? question.options
            : inferredInspoFocusOptions(analysis)
        };
      }

      return question;
    });

    questions = questions.map(function(question){
      if (question.id === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID) {
        var fallbackOptions = inspoFocusOptions();
        var rawOptions = Array.isArray(question.options) ? question.options : [];
        var normalizedOptions = rawOptions.map(function(option){
          if (!option) return null;
          var optionId = String(option.id || '').trim();
          var optionLabel = String(option.label || '').trim();
          if (!optionId || !optionLabel) return null;

          var fallback = fallbackOptions.find(function(item){ return item.id === optionId; });
          return {
            id: optionId,
            label: optionLabel,
            description: String(option.description || (fallback && fallback.description) || '').trim()
          };
        }).filter(Boolean);

        if (!normalizedOptions.length) {
          var canonicalById = {};
          fallbackOptions.forEach(function(option){
            canonicalById[option.id] = option;
          });

          normalizedOptions.forEach(function(option){
            if (!option || !option.id) return;
            canonicalById[option.id] = {
              id: option.id,
              label: option.label || (canonicalById[option.id] && canonicalById[option.id].label) || option.id,
              description: option.description || (canonicalById[option.id] && canonicalById[option.id].description) || ''
            };
          });

          getPhotoInspoFocusSelections().forEach(function(optionId){
            if (!optionId) return;
            if (!canonicalById[optionId]) {
              canonicalById[optionId] = {
                id: optionId,
                label: optionId,
                description: ''
              };
            }
          });

          normalizedOptions = fallbackOptions.map(function(option){
            return canonicalById[option.id] || option;
          });
        } else {
          getPhotoInspoFocusSelections().forEach(function(optionId){
            if (!optionId) return;
            var exists = normalizedOptions.some(function(option){
              return option && option.id === optionId;
            });
            if (!exists) {
              normalizedOptions.push({
                id: optionId,
                label: optionId,
                description: ''
              });
            }
          });
        }

        return {
          id: question.id,
          question: question.question || 'Which parts of the inspiration do you actually want us to carry over? Choose everything that applies.',
          type: 'multi_select',
          options: normalizedOptions
        };
      }

      if (question.id === PHOTO_GRAY_COVERAGE_QUESTION_ID) {
        return {
          id: question.id,
          question: question.question || 'When it comes to gray, which of these sounds most like what you need from this appointment?',
          type: 'single_select',
          options: grayCoverageOptions().map(function(fallback){
            var match = (question.options || []).find(function(option){
              return option && option.id === fallback.id;
            });
            return {
              id: fallback.id,
              label: match && match.label ? match.label : fallback.label,
              description: match && match.description ? match.description : fallback.description
            };
          })
        };
      }

      if (question.id === PHOTO_GRAY_STRATEGY_QUESTION_ID) {
        return {
          id: question.id,
          question: question.question || 'A colorist would usually narrow gray strategy down to one of these. Which result sounds closest to you?',
          type: 'single_select',
          options: grayStrategyOptions().map(function(fallback){
            var match = (question.options || []).find(function(option){
              return option && option.id === fallback.id;
            });
            return {
              id: fallback.id,
              label: match && match.label ? match.label : fallback.label,
              description: match && match.description ? match.description : fallback.description
            };
          })
        };
      }

      return question;
    });

    questions = questions.filter(function(question){
      return !questionMentionsHaircutIntent(question) && !questionBelongsToFrontendFlow(question);
    });

    questions = questions.filter(function(question){
      if (question.id !== 'haircut_shape_intent') return true;
      var haircutAlreadyIncluded = analysisSuggestsHaircut(analysis) ||
        state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true ||
        photoMultiAnswerIncludes(PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID, 'haircut');
      return !(haircutAlreadyIncluded && analysisImpliesClearlyNotBigChange(analysis));
    });

    questions = questions.filter(function(question){
      if (question.id !== 'multi_session_tolerance') return true;
      var consultOnly = !(analysis && Array.isArray(analysis.recommended_services) && analysis.recommended_services.length);
      if (consultOnly) return true;
      return !!(analysis && analysis.needs_human_review);
    });

    questions = questions.filter(function(question){
      if (question.id !== 'maintenance_routine') return true;
      var grayIntent = state.photoFollowUpAnswers[PHOTO_GRAY_COVERAGE_QUESTION_ID];
      var grayStrategy = state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID];
      return grayIntent === 'gray_coverage' ||
        grayIntent === 'gray_unsure' ||
        grayStrategy === 'full_coverage' ||
        grayStrategy === 'soft_blending' ||
        grayStrategy === 'dimensional_blend';
    });

    var hasExistingInspoFocusQuestion = hasQuestionWithId(questions, PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID);
    var inspoFocusCommitted = state.photoCommittedQuestionIds[PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID] === true;

    if (
      photoGrayQuestionStillNeeded() &&
      !hasQuestionWithId(questions, PHOTO_GRAY_COVERAGE_QUESTION_ID)
    ) {
      questions.unshift({
        id: PHOTO_GRAY_COVERAGE_QUESTION_ID,
        question: 'Before we decide on coverage timing, is gray actually part of what you want handled at this visit?',
        type: 'single_select',
        options: grayCoverageOptions()
      });
    }

    if (
      photoGrayDecisionStillOpen() &&
      !hasQuestionWithId(questions, PHOTO_GRAY_STRATEGY_QUESTION_ID)
    ) {
      questions.unshift({
        id: PHOTO_GRAY_STRATEGY_QUESTION_ID,
        question: 'Gray affects both timing and maintenance. Which of these paths sounds closer to what you would actually want if gray is part of this visit?',
        type: 'single_select',
        options: grayStrategyOptions()
      });
    }

    if (
      (!hasExistingInspoFocusQuestion || inspoFocusCommitted) &&
      state.photoFollowUpAnswers[PHOTO_HAIRCUT_CONFIRM_QUESTION_ID] === true &&
      !Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID) &&
      !analysisImpliesObviousLongToBobShift(analysis) &&
      !analysisImpliesClearlyNotBigChange(analysis)
    ) {
      questions.unshift({
        id: PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID,
        question: 'Would you call this a bigger haircut change, or more of a trim and shape refresh?',
        type: 'single_select',
        options: [
          {
            id: 'yes',
            label: 'A bigger haircut change',
            description: 'More than maintenance: a real shape, length, or silhouette change.'
          },
          {
            id: 'no',
            label: 'Mostly a trim or refresh',
            description: 'More of a cleanup, reshape, or maintenance cut.'
          }
        ]
      });
    }

    return questions;
  }

  function allPhotoQuestionsAnswered(questions){
    return questions.length && questions.every(function(question){
      if (!Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, question.id)) {
        return false;
      }
      if (question.type === 'multi_select') {
        var values = state.photoFollowUpAnswers[question.id];
        if (!Array.isArray(values) || !values.length) return false;
        return !photoQuestionNeedsCommit(question) || state.photoCommittedQuestionIds[question.id] === true;
      }
      return true;
    });
  }

  function currentPhotoQuestion(){
    var questions = normalizedPhotoQuestions(state.photoAnalysis);
    for (var i = 0; i < questions.length; i += 1) {
      if (!Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, questions[i].id)) {
        return questions[i];
      }
      if (questions[i].type === 'multi_select') {
        var values = state.photoFollowUpAnswers[questions[i].id];
        if (!Array.isArray(values) || !values.length) {
          return questions[i];
        }
        if (photoQuestionNeedsCommit(questions[i]) && state.photoCommittedQuestionIds[questions[i].id] !== true) {
          return questions[i];
        }
      }
      else {
        continue;
      }
    }
    return null;
  }

  function unansweredPhotoQuestion(question){
    if (!question) return false;
    if (!Object.prototype.hasOwnProperty.call(state.photoFollowUpAnswers, question.id)) {
      return true;
    }
    if (question.type === 'multi_select') {
      var values = state.photoFollowUpAnswers[question.id];
      if (!Array.isArray(values) || !values.length) return true;
      return photoQuestionNeedsCommit(question) && state.photoCommittedQuestionIds[question.id] !== true;
    }
    return false;
  }

  function unansweredPhotoQuestionCount(){
    return normalizedPhotoQuestions(state.photoAnalysis).filter(function(question){
      return unansweredPhotoQuestion(question);
    }).length;
  }

  function photoAnswerIsSelected(questionId, candidate){
    return state.photoFollowUpAnswers[questionId] === candidate;
  }

  function canonicalPhotoAnswerValue(questionId, raw){
    var value = String(raw || '').trim();
    if (!questionId) return value;

    if (questionId === 'existing_dimension_strategy') {
      if (value === 'reuse') return 'reuse_existing_lightness';
      if (value === 'recolor_existing') return 'reuse_existing_lightness';
      if (value === 'new_placement') return 'add_more_dimension';
      if (value === 'unsure') return 'unsure_need_guidance';
    }

    if (questionId === 'base_color_history_status') {
      if (value === 'natural') return 'natural_growout';
      if (value === 'previously_colored') return 'artificial_color_present';
      if (value === 'unsure') return 'unsure_history';
    }

    if (questionId === PHOTO_GRAY_COVERAGE_QUESTION_ID) {
      if (value === 'yes') return 'gray_coverage';
      if (value === 'no') return 'no_gray';
      if (value === 'unsure') return 'gray_unsure';
    }

    return value;
  }

  function photoQuestionNeedsCommit(question){
    return !!(question && question.type === 'multi_select' && question.id === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID);
  }

  function renderPhotoQuestionChoices(question, mode){
    if (!question) return '';

    if (question.type === 'single_select' && Array.isArray(question.options) && question.options.length) {
      return question.options.map(function(option){
        var selected = photoAnswerIsSelected(question.id, option.id) ? ' is-selected' : '';
        var meta = option.description || 'Use this to guide the recommendation.';
        return ''
          + '<button class="bk-choice' + selected + '" type="button"'
          + ' data-photo-question-id="' + escapeHtml(question.id) + '"'
          + ' data-photo-answer-kind="single_select"'
          + ' data-photo-answer-value="' + escapeHtml(option.id) + '"'
          + (mode === 'followup' ? ' data-choice-type="photo-followup-answer"' : '')
          + '>'
          +   '<p class="bk-choice__title">' + escapeHtml(option.label) + '</p>'
          +   '<p class="bk-choice__meta">' + escapeHtml(meta) + '</p>'
          + '</button>';
      }).join('');
    }

    if (question.type === 'multi_select' && Array.isArray(question.options) && question.options.length) {
      var list = question.options.map(function(option){
        var selected = photoMultiAnswerIncludes(question.id, option.id) ? ' is-selected' : '';
        var meta = option.description || 'Choose anything that feels important to you.';
        return ''
          + '<button class="bk-choice' + selected + '" type="button"'
          + ' data-photo-question-id="' + escapeHtml(question.id) + '"'
          + ' data-photo-answer-kind="multi_select"'
          + ' data-photo-answer-value="' + escapeHtml(option.id) + '"'
          + (mode === 'followup' ? ' data-choice-type="photo-followup-answer"' : '')
          + '>'
          +   '<p class="bk-choice__title">' + escapeHtml(option.label) + '</p>'
          +   '<p class="bk-choice__meta">' + escapeHtml(meta) + '</p>'
          + '</button>';
      }).join('');

      if (!photoQuestionNeedsCommit(question)) {
        return list;
      }

      var selectedValues = state.photoFollowUpAnswers[question.id];
      var canContinue = Array.isArray(selectedValues) && selectedValues.length > 0;
      if (!canContinue) {
        return list;
      }

      return list + ''
        + '<div class="bk-actions" style="padding-top:12px;border-top:none;">'
        +   '<button class="bk-btn bk-btn--primary" type="button"'
        +   ' data-choice-type="photo-followup-continue"'
        +   '>Continue</button>'
        + '</div>';
    }

    var yesSelected = photoAnswerIsSelected(question.id, true) ? ' is-selected' : '';
    var noSelected = photoAnswerIsSelected(question.id, false) ? ' is-selected' : '';

    return ''
      + '<button class="bk-choice' + yesSelected + '" type="button"'
      + ' data-photo-question-id="' + escapeHtml(question.id) + '"'
      + ' data-photo-answer-kind="boolean"'
      + ' data-photo-answer-value="yes"'
      + (mode === 'followup' ? ' data-choice-type="photo-followup-answer"' : '')
      + '>'
      +   '<p class="bk-choice__title">Yes</p>'
      +   '<p class="bk-choice__meta">That sounds right.</p>'
      + '</button>'
      + '<button class="bk-choice' + noSelected + '" type="button"'
      + ' data-photo-question-id="' + escapeHtml(question.id) + '"'
      + ' data-photo-answer-kind="boolean"'
      + ' data-photo-answer-value="no"'
      + (mode === 'followup' ? ' data-choice-type="photo-followup-answer"' : '')
      + '>'
      +   '<p class="bk-choice__title">No</p>'
      +   '<p class="bk-choice__meta">Show me the other path.</p>'
      + '</button>';
  }

  function storePhotoAnswer(questionId, raw, kind){
    if (!questionId || !raw) return;
    raw = canonicalPhotoAnswerValue(questionId, raw);
    if (questionId === PHOTO_HAIRCUT_CONFIRM_QUESTION_ID) {
      state.photoFollowUpAnswers[questionId] = raw === 'yes';
      if (raw !== 'yes') {
        delete state.photoFollowUpAnswers[PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID];
      }
      state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
      updateDebugPanel('storePhotoAnswer');
      return;
    }
    if (questionId === PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID) {
      state.photoFollowUpAnswers[questionId] = raw === 'yes';
      state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
      updateDebugPanel('storePhotoAnswer');
      return;
    }
    if (questionId === PHOTO_GRAY_COVERAGE_QUESTION_ID) {
      state.photoFollowUpAnswers[questionId] = raw;
      if (raw !== 'gray_unsure') {
        delete state.photoFollowUpAnswers[PHOTO_GRAY_STRATEGY_QUESTION_ID];
      }
      state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
      updateDebugPanel('storePhotoAnswer');
      return;
    }
    if (questionId === PHOTO_GRAY_STRATEGY_QUESTION_ID) {
      state.photoFollowUpAnswers[questionId] = raw;
      updateDebugPanel('storePhotoAnswer');
      state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
      return;
    }
    if (kind === 'multi_select') {
      var current = questionId === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID
        ? getPhotoInspoFocusSelections().slice()
        : (Array.isArray(state.photoFollowUpAnswers[questionId])
          ? state.photoFollowUpAnswers[questionId].slice()
          : []);
      var next = current.indexOf(raw) === -1
        ? current.concat(raw)
        : current.filter(function(value){ return value !== raw; });
      if (questionId === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID) {
        setPhotoInspoFocusSelections(next);
      } else {
        state.photoFollowUpAnswers[questionId] = next;
      }
      delete state.photoCommittedQuestionIds[questionId];
      state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
      updateDebugPanel('storePhotoAnswer');
      return;
    }
    if (kind === 'boolean') {
      state.photoFollowUpAnswers[questionId] = raw === 'yes';
      return;
    }
    state.photoFollowUpAnswers[questionId] = raw;
  }

  function resetPhotoResults(){
    state.photoAnalysis = null;
    state.photoSuggestedServices = [];
    state.photoApplied = false;
    state.photoFollowUpAnswers = {};
    state.photoCommittedQuestionIds = {};
    state.answers.haircutBigChange = null;
    if (photoSummary) photoSummary.textContent = 'Analyze photos to see a suggested service stack.';
    if (photoResults) photoResults.innerHTML = '';
    if (photoQuestions) photoQuestions.innerHTML = '';
    if (photoRefineBtn) photoRefineBtn.disabled = true;
    if (photoApplyBtn) photoApplyBtn.disabled = true;
  }

  function hasBlockingPhotoDecision(){
    return photoBlockingDecisionIds().length > 0;
  }

  function photoBlockingDecisionMessage(){
    var blockerIds = photoBlockingDecisionIds();
    var activeQuestion = currentPhotoQuestion();
    var blockerId = blockerIds[0] || (activeQuestion && activeQuestion.id) || '';

    if (blockerId === PHOTO_GRAY_COVERAGE_QUESTION_ID || blockerId === PHOTO_GRAY_STRATEGY_QUESTION_ID) {
      return 'We still need to lock in your gray coverage path before we can move forward, because it changes timing and service setup.';
    }
    if (blockerId === PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID) {
      return 'We still need to confirm whether this haircut is a refinement or a bigger change before we move forward, because that changes timing and booking order.';
    }
    if (blockerId === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID) {
      return 'We still need to confirm which parts of the inspiration you actually want to carry over before we move forward, so the plan reflects your real goal.';
    }
    return 'We still need one more consultation decision before we can move forward.';
  }

  function photoConsultOnlyMode(){
    var analysis = state.photoAnalysis || {};
    var hasSuggestedServices = Array.isArray(state.photoSuggestedServices) && state.photoSuggestedServices.length > 0;
    var hasAnalyzerServices = (Array.isArray(analysis.recommended_services) && analysis.recommended_services.length > 0) ||
      !!(analysis.booking_strategy && Array.isArray(analysis.booking_strategy.recommended_services) && analysis.booking_strategy.recommended_services.length > 0);
    return !hasSuggestedServices && !hasAnalyzerServices;
  }

  function photoUnbookableSteps(){
    var bookingStrategy = state.photoAnalysis && state.photoAnalysis.booking_strategy
      ? state.photoAnalysis.booking_strategy
      : null;
    return bookingStrategy && Array.isArray(bookingStrategy.unbookable_steps)
      ? bookingStrategy.unbookable_steps.filter(Boolean)
      : [];
  }

  function photoNeedsHumanReview(){
    var analysis = state.photoAnalysis || {};
    var bookingStrategy = analysis.booking_strategy || {};
    var explicitBookableStrategy =
      bookingStrategy &&
      bookingStrategy.needs_human_review === false &&
      Array.isArray(bookingStrategy.unbookable_steps) &&
      bookingStrategy.unbookable_steps.length === 0;

    if (explicitBookableStrategy) return false;

    return !!analysis.needs_human_review ||
      !!bookingStrategy.needs_human_review ||
      photoUnbookableSteps().length > 0;
  }

  function renderPhotoResults(){
    var analysis = state.photoAnalysis || {};
    var analyzerRecommended = Array.isArray(analysis.recommended_services)
      ? analysis.recommended_services
      : (analysis.booking_strategy && Array.isArray(analysis.booking_strategy.recommended_services)
        ? analysis.booking_strategy.recommended_services
        : []);
    var recommended = analyzerRecommended
      ? analyzerRecommended.filter(function(item){
          return (Number(item && item.confidence) || 0) > 0 && (Number(item && item.booking_order) || 0) > 0;
        })
      : [];
    var questions = normalizedPhotoQuestions(analysis);

    if (photoSummary) {
      photoSummary.textContent = analysis.summary || 'No summary returned.';
    }

    if (photoResults) {
      photoResults.innerHTML = recommended.length ? recommended.map(function(item){
      var confidence = Math.round((Number(item.confidence) || 0) * 100);
      var optionText = Array.isArray(item.suggested_option_ids) && item.suggested_option_ids.length
        ? item.suggested_option_ids.map(function(optionId){ return PHOTO_OPTION_NAMES[optionId] || optionId; }).join(', ')
        : 'No modifiers suggested.';

      return ''
        + '<div class="bk-analysisCard">'
        +   '<div class="bk-choice__title">' + escapeHtml(item.service_name || item.service_id || 'Recommended service') + '</div>'
        +   '<div class="bk-choice__meta">' + escapeHtml(item.reason || '') + '</div>'
        +   '<div class="bk-choice__meta">' + escapeHtml(optionText) + '</div>'
        +   '<div class="bk-choice__meta">' + escapeHtml(confidence + '% match') + '</div>'
        + '</div>';
      }).join('') : '<div class="bk-empty">No services confidently recommended yet.</div>';
    }

    if (photoQuestions) {
      photoQuestions.innerHTML = questions.length
        ? '<div class="bk-analysisCard"><div class="bk-choice__meta">A few quick consultation questions will appear next so we can finalize the booking strategy.</div></div>'
        : (photoConsultOnlyMode()
          ? '<div class="bk-analysisCard"><div class="bk-choice__meta">Consult mode is active right now, so we are just gathering the exact guest inputs the color plan still needs before reconnecting booking.</div></div>'
          : (photoNeedsHumanReview()
          ? '<div class="bk-analysisCard"><div class="bk-choice__meta">This plan still needs a stylist review before booking because at least one technical step is not cleanly represented in the current catalog.</div></div>'
          : (hasBlockingPhotoDecision()
          ? '<div class="bk-analysisCard"><div class="bk-choice__meta">We still need one more consult decision before the booking can be finalized.</div></div>'
          : '')));
    }

    if (photoRefineBtn) {
      photoRefineBtn.disabled = !allPhotoQuestionsAnswered(questions);
    }
    if (photoApplyBtn) {
      photoApplyBtn.disabled = photoConsultOnlyMode() || photoNeedsHumanReview() || !state.photoSuggestedServices.length || !allPhotoQuestionsAnswered(questions) || hasBlockingPhotoDecision();
    }
  }

  function hasPhotoQuestionBundle(){
    return normalizedPhotoQuestions(state.photoAnalysis).length > 0;
  }

  function renderPhotoFollowup(){
    var question = currentPhotoQuestion();
    if (!question) {
      syncPhotoConsultHeader(null, 0, 0);
      return;
    }
    var total = normalizedPhotoQuestions(state.photoAnalysis).length;
    var remaining = unansweredPhotoQuestionCount();
    var currentIndex = total - remaining + 1;
    photoFollowupTitle.textContent = question.question;
    photoFollowupText.textContent = photoFollowupSupportText(question, currentIndex, total);
    syncPhotoConsultHeader(question, currentIndex, total);
    photoFollowupChoices.innerHTML = renderPhotoQuestionChoices(question, 'followup');
  }

  function fileToImage(file){
    return new Promise(function(resolve, reject){
      var reader = new FileReader();
      reader.onload = function(){
        var img = new Image();
        img.onload = function(){ resolve(img); };
        img.onerror = reject;
        img.src = String(reader.result || '');
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function fileToOptimizedDataUrl(file){
    return fileToImage(file).then(function(img){
      var maxSide = 1600;
      var width = img.width;
      var height = img.height;
      var scale = Math.min(1, maxSide / Math.max(width, height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round(height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', 0.82);
    });
  }

  async function loadPhotoFiles(filesLike, target, label){
    var files = Array.prototype.slice.call(filesLike || []).slice(0, 6);
    target.length = 0;
    resetPhotoResults();
    renderPhotoPreviews();

    if (!files.length) return;

    setMessage('Preparing photos...');

    try {
      for (var i = 0; i < files.length; i += 1) {
        target.push({
          name: files[i].name || (label + ' ' + (i + 1)),
          dataUrl: await fileToOptimizedDataUrl(files[i])
        });
      }
      renderPhotoPreviews();
      setMessage('Photos ready to analyze.', 'is-success');
    } catch (error) {
      target.length = 0;
      renderPhotoPreviews();
      setMessage(error && error.message ? error.message : 'Could not prepare those photos.', 'is-error');
    }
  }

  async function loadPhotoSet(input, target, label){
    return loadPhotoFiles(input.files, target, label);
  }

  function bindPhotoDropzone(dropzone, input, target, label){
    if (!dropzone || !input) return;

    ['dragenter', 'dragover'].forEach(function(eventName){
      dropzone.addEventListener(eventName, function(event){
        event.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'dragend', 'drop'].forEach(function(eventName){
      dropzone.addEventListener(eventName, function(event){
        event.preventDefault();
        if (eventName === 'dragleave' && dropzone.contains(event.relatedTarget)) return;
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', function(event){
      var files = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : null;
      if (!files || !files.length) return;
      loadPhotoFiles(files, target, label);
    });
  }

  async function analyzePhotos(){
    state.photoGoal = String(photoGoalInput.value || '').trim();
    var preAnalysisAnswers = inferPhotoPreAnalysisAnswersFromGoal();

    if (!currentPhotoImages.length && !inspirationPhotoImages.length) {
      throw new Error('Upload at least one current or inspiration photo first.');
    }

    var response = await fetch(PHOTO_ANALYZE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        goal: state.photoGoal,
        pre_analysis_answers: preAnalysisAnswers,
        current_images: currentPhotoImages.map(function(item){ return item.dataUrl; }),
        inspiration_images: inspirationPhotoImages.map(function(item){ return item.dataUrl; }),
        images: currentPhotoImages.concat(inspirationPhotoImages).map(function(item){ return item.dataUrl; })
      })
    });

    var data = await response.json().catch(function(){ return null; });
    showDebug(data);
    if (!response.ok || !data || !data.ok) {
      throw new Error((data && data.error) || 'Could not analyze photos.');
    }

    state.photoFollowUpAnswers = preAnalysisAnswers;
    state.photoCommittedQuestionIds = {};
    state.answers.haircutBigChange = null;
    state.photoAnalysis = data.analysis || null;
    applyInferredPhotoConsultAnswers(state.photoAnalysis);
    state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
    state.photoApplied = false;
    updateDebugPanel('analyzePhotos');
    renderPhotoResults();
    return data;
  }

  async function refinePhotoAnalysis(){
    if (!state.photoAnalysis) {
      throw new Error('Analyze photos first.');
    }

    var response = await fetch(PHOTO_ANALYZE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        goal: state.photoGoal,
        current_images: currentPhotoImages.map(function(item){ return item.dataUrl; }),
        inspiration_images: inspirationPhotoImages.map(function(item){ return item.dataUrl; }),
        images: currentPhotoImages.concat(inspirationPhotoImages).map(function(item){ return item.dataUrl; }),
        initial_analysis: state.photoAnalysis,
        follow_up_answers: state.photoFollowUpAnswers
      })
    });

    var data = await response.json().catch(function(){ return null; });
    showDebug(data);
    if (!response.ok || !data || !data.ok) {
      throw new Error((data && data.error) || 'Could not refine photo analysis.');
    }

    state.answers.haircutBigChange = null;
    state.photoAnalysis = data.analysis || null;
    applyInferredPhotoConsultAnswers(state.photoAnalysis);
    state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
    state.photoApplied = false;
    updateDebugPanel('refinePhotoAnalysis');
    renderPhotoResults();
    return data;
  }

  function applyPhotoSuggestion(){
    state.photoApplied = true;
    state.answers.haircutBigChange = effectivePhotoHaircutBigChangeAnswer();
    rebuildServiceStack();
    updateDebugPanel('applyPhotoSuggestion');
    setMessage('Suggested services applied.', 'is-success');
    updateUI();
  }

  async function completePhotoFlow(){
    if (photoConsultOnlyMode()) {
      setMessage('Consult-only mode is active, so we are stopping at questions and answers until booking is wired back in.', 'is-success');
      updateDebugPanel('consultOnlyPhotoFlow');
      renderPhotoResults();
      goTo('photo');
      return;
    }

    if (hasBlockingPhotoDecision()) {
      setMessage(photoBlockingDecisionMessage(), 'is-error');
      renderPhotoFollowup();
      goTo('photo-followup');
      return;
    }
    if (photoNeedsHumanReview()) {
      var unbookableSteps = photoUnbookableSteps();
      setMessage(
        unbookableSteps.length
          ? 'This plan still needs a stylist review before booking because the current catalog does not represent every technical step: ' + unbookableSteps.join('; ')
          : 'This plan still needs a stylist review before booking because the current catalog does not represent every technical step.',
        'is-error'
      );
      renderPhotoResults();
      goTo('photo');
      return;
    }
    applyPhotoSuggestion();
    var nextScreen = nextPhotoServiceDetailScreen();
    if (nextScreen) {
      goTo(nextScreen);
      return;
    }
    await maybeLoadStylistsAndAdvance();
  }

  function rebuildServiceStack(){
    var previousByKey = {};
    state.serviceStack.forEach(function(item){
      previousByKey[item.key] = item;
    });

    state.serviceStack = [];

    if (state.answers.entryChoice === 'photo') {
    state.serviceStack = state.photoSuggestedServices.map(function(item){
      return {
        key: item.key,
        name: item.name,
        service_id: canonicalServiceId(item.service_id),
        stylist_id: item.stylist_id || 'any',
        stylist_name: item.stylist_name || 'No preference',
        preferred_stylist_ids: item.preferred_stylist_ids || [],
        price: null,
        selected_options: item.selected_options || []
      };
      });
      if (
        state.answers.colorNeedsHaircut === true &&
        !state.serviceStack.some(function(item){
          return item.key === 'haircut';
        })
      ) {
        state.serviceStack.push({
          key: 'haircut',
          name: SERVICE_NAMES.haircut,
          service_id: canonicalServiceId(SERVICE_MAP.haircut),
          stylist_id: 'any',
          stylist_name: 'No preference',
          preferred_stylist_ids: [],
          price: null,
          selected_options: selectedOptionsForService('haircut')
        });
      }
      if (
        state.answers.colorNeedsBlowdry === true &&
        state.answers.blowdryStyle &&
        !state.serviceStack.some(function(item){
          return item.key === 'blowdry_classic' || item.key === 'blowdry_signature';
        })
      ) {
        state.serviceStack.push({
          key: selectedBlowdryKey(),
          name: SERVICE_NAMES[selectedBlowdryKey()],
          service_id: canonicalServiceId(SERVICE_MAP[selectedBlowdryKey()]),
          stylist_id: 'any',
          stylist_name: 'No preference',
          preferred_stylist_ids: [],
          price: null,
          selected_options: selectedOptionsForService(selectedBlowdryKey())
        });
      }
      return;
    }

    if (state.answers.entryChoice === 'blowdry' && state.answers.blowdryStyle) {
      pushService(selectedBlowdryKey());
    }

    if (
      (state.answers.entryChoice === 'haircut' ||
        state.answers.entryChoice === 'extensions' ||
        state.answers.entryChoice === 'treatment') &&
      state.answers.manualServiceKey
    ) {
      pushService(state.answers.manualServiceKey);
    }

    if (state.answers.entryChoice === 'color') {
      if (
        state.answers.colorGoal === 'gray_only' ||
        state.answers.colorGoal === 'gray_plus_brightness' ||
        state.answers.colorGoal === 'darker_richer'
      ) {
        pushService('single_process');
      }

      if (
        (state.answers.colorGoal === 'gray_plus_brightness' ||
          state.answers.colorGoal === 'lighter_brighter') &&
        state.answers.colorDimensionPlacement
      ) {
        pushService(state.answers.colorDimensionPlacement);
      }

      if (state.answers.colorNeedsHaircut === true) pushService('haircut');

      if (
        state.answers.colorNeedsBlowdry === true &&
        state.answers.colorNeedsHaircut !== true &&
        state.answers.blowdryStyle
      ) {
        pushService(selectedBlowdryKey());
      }
    }

    if (
      state.answers.entryChoice === 'extensions' &&
      state.answers.manualServiceKey === 'extension_maintenance' &&
      state.answers.extensionNeedsBlowdry === true &&
      state.answers.blowdryStyle
    ) {
      pushService(selectedBlowdryKey());
    }

    if (state.answers.entryChoice === 'treatment') {
      if (state.answers.treatmentNeedsHaircut === true) {
        pushService('haircut');
      } else if (
        state.answers.treatmentNeedsBlowdry === true &&
        state.answers.blowdryStyle
      ) {
        pushService(selectedBlowdryKey());
      }
    }

    state.serviceStack = state.serviceStack.map(function(item){
      var previous = previousByKey[item.key] || {};
      return {
        key: item.key,
        name: item.name,
        service_id: item.service_id,
        stylist_id: previous.stylist_id || 'any',
        stylist_name: previous.stylist_name || 'No preference',
        preferred_stylist_ids: previous.preferred_stylist_ids || [],
        price: previous.price || null,
        selected_options: selectedOptionsForService(item.key)
      };
    });
  }

  function renderStack(){
    if (summaryHeading) summaryHeading.style.display = 'none';
    if (stackList) stackList.innerHTML = '';
    renderSummaryMeta();
  }

  function row(label, value){
    return '<div class="bk-row"><div class="bk-row__label">' + escapeHtml(label) + '</div><div class="bk-row__value">' + escapeHtml(value) + '</div></div>';
  }

  function updateReview(){
    reviewPanel.innerHTML = '';
  }

  function updateDone(){
    donePanel.innerHTML = '';
  }

  async function fetchStaffDirectoryPage(forceRefresh){
    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'staff-directory-derived',
        force_refresh: forceRefresh === true
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not load team details');
    return data;
  }

  async function loadStaffDirectoryPage(forceRefresh){
    state.staffDirectoryPage.loading = true;
    state.staffDirectoryPage.error = '';
    renderStaffDirectory();

    try {
      var data = await fetchStaffDirectoryPage(forceRefresh);
      state.staffDirectoryPage.supported = !!data.supported;
      state.staffDirectoryPage.staff = Array.isArray(data.staff) ? data.staff.slice() : [];
      state.staffDirectoryPage.debug = data.debug || null;
    } catch (error) {
      state.staffDirectoryPage.supported = false;
      state.staffDirectoryPage.staff = [];
      state.staffDirectoryPage.debug = null;
      state.staffDirectoryPage.error = error && error.message ? error.message : 'Could not load team details.';
    } finally {
      state.staffDirectoryPage.loading = false;
      renderStaffDirectory();
    }
  }

  function renderStaffDirectory(){
    if (!staffDirectoryPanel) return;

    var page = state.staffDirectoryPage || {};
    var staff = Array.isArray(page.staff) ? page.staff.slice() : [];
    var loading = !!page.loading;
    var error = String(page.error || '').trim();
    var expandedId = String(page.expandedId || '').trim();

    function renderServiceRow(service){
      var title = String(service && service.name || '').trim();
      var price = service && typeof service.price === 'number' ? formatMoney(service.price) : '';
      return ''
        + '<div class="bk-staffDirectoryService">'
        +   '<div class="bk-staffDirectoryServiceMain">'
        +     '<p class="bk-staffDirectoryServiceName">' + escapeHtml(title || 'Service') + '</p>'
        +   '</div>'
        +   (price ? '<span class="bk-staffDirectoryServicePrice">' + escapeHtml(price) + '</span>' : '')
        + '</div>';
    }

    staffDirectoryPanel.innerHTML = ''
      + '<div class="bk-staffDirectoryHead">'
      +   '<div class="bk-staffStoryTop">'
      +     '<h3 class="bk-staffStoryTitle">meet the <em>team...</em></h3>'
      +   '</div>'
      +   (loading
            ? ''
              + '<div class="bk-staffStoryLoading">'
              +   '<p class="bk-staffStoryText">We’re pulling together the details of your team menu.</p>'
              +   '<div class="bk-staffStoryLoadingLines" aria-hidden="true">'
              +     '<span></span>'
              +     '<span></span>'
              +     '<span></span>'
              +   '</div>'
              + '</div>'
            : (error
                ? '<div class="bk-dashboardEmpty">' + escapeHtml(error) + '</div>'
                : ''))
      + '</div>'
      + '<div class="bk-staffDirectoryGrid">'
      +   (!loading && !error
            ? (staff.length
                ? staff.map(function(member){
                    var services = Array.isArray(member && member.services) ? member.services.slice() : [];
                    var avatar = String(member && member.avatar || '').trim();
                    var initials = String(member && member.name || 'S').trim().split(/\s+/).slice(0,2).map(function(part){ return part.charAt(0).toUpperCase(); }).join('');
                    var meta = [String(member && member.role || '').trim(), Array.isArray(member && member.location_names) ? member.location_names.join(', ') : ''].filter(Boolean).join(' · ');
                    var memberId = String(member && member.id || '').trim();
                    var isOpen = !!memberId && memberId === expandedId;
                    services.sort(function(a, b){
                      return String(a && a.name || '').localeCompare(String(b && b.name || ''));
                    });
                    return ''
                      + '<article class="bk-staffDirectoryCard' + (isOpen ? ' is-open' : '') + '">'
                      +   '<button class="bk-staffDirectoryCardToggle" type="button" data-choice-type="staff-directory-toggle" data-choice-id="' + escapeHtml(memberId) + '">'
                      +     '<div class="bk-staffDirectoryTop">'
                      +       (avatar
                                ? '<div class="bk-staffAvatar"><img src="' + escapeHtml(avatar) + '" alt="' + escapeHtml(member.name || 'Staff') + '" loading="lazy" /></div>'
                                : '<div class="bk-staffAvatar"><div class="bk-staffAvatarFallback">' + escapeHtml(initials || 'S') + '</div></div>')
                      +       '<div class="bk-staffDirectoryIdentity">'
                      +         '<h3 class="bk-staffDirectoryName">' + escapeHtml(String(member && member.name || '').trim()) + '</h3>'
                      +         (meta ? '<p class="bk-staffDirectoryMeta">' + escapeHtml(meta) + '</p>' : '')
                      +       '</div>'
                      +       '<span class="bk-staffDirectoryChevron">' + (isOpen ? '−' : '+') + '</span>'
                      +     '</div>'
                      +   '</button>'
                      +   (String(member && member.bio || '').trim() ? '<p class="bk-staffDirectoryBio">' + escapeHtml(String(member.bio).trim()) + '</p>' : '')
                      +   (services.length
                            ? '<div class="bk-staffDirectoryServices">' + services.map(renderServiceRow).join('') + '</div>'
                            : '<div class="bk-dashboardEmpty">No bookable services surfaced for this staff member yet.</div>')
                      + '</article>';
                  }).join('')
                : '<div class="bk-dashboardEmpty">No staff details were returned from Boulevard for this directory view.</div>')
            : '')
      + '</div>';
  }

  function renderDashboard(){
    if (!dashboardPanel) return;

    var dashboard = state.clientDashboard || { profile: null, appointments: [] };
    var liveData = state.clientAccount.dashboardData || null;
    var bootstrap = state.clientAccount.bootstrap || null;
    var authStart = state.clientAccount.authStart || null;
    var authVerify = state.clientAccount.authVerify || null;
    var profile = (authVerify && authVerify.client) || (liveData && liveData.profile) || dashboard.profile || null;
    var appointments = mergedDashboardAppointments();
    var cards = Array.isArray(liveData && liveData.cards) ? liveData.cards : [];
    var vouchers = Array.isArray(liveData && liveData.vouchers) ? liveData.vouchers : [];
    var referralCodes = Array.isArray(liveData && liveData.referral_codes) ? liveData.referral_codes : [];
    var referrals = Array.isArray(liveData && liveData.referrals) ? liveData.referrals : [];
    var hasSavedSession = hasSavedClientSession();
    var hasLiveData = hasLiveClientDashboardData();
    var upcoming = appointments.filter(appointmentIsUpcoming).sort(function(a, b){
      return appointmentSortValue(a) - appointmentSortValue(b);
    });
    var past = appointments.filter(function(record){
      return !appointmentIsUpcoming(record);
    }).sort(function(a, b){
      return appointmentSortValue(b) - appointmentSortValue(a);
    });
    var profileName = dashboardProfileName(profile) || 'Your profile';
    var nextVisit = upcoming[0] || null;
    var activeSection = state.clientAccount.dashboardSection === 'vouchers'
      ? 'vouchers'
      : (state.clientAccount.dashboardSection === 'cards'
        ? 'cards'
        : (state.clientAccount.dashboardSection === 'referrals' ? 'referrals' : 'appointments'));
    var activeTab = state.clientAccount.dashboardTab === 'past' ? 'past' : 'upcoming';
    var visibleAppointments = activeTab === 'past' ? past : upcoming;

    function authStatusLabel(){
      if (state.clientAccount.loading) return 'Checking';
      return bootstrap && bootstrap.status === 'session_attached' ? 'Connected' : 'Sign-in needed';
    }

    function authStatusNote(){
      if (state.clientAccount.loading) {
        return 'Checking whether a Boulevard client session is attached.';
      }
      if (!bootstrap) {
        return 'This custom dashboard is ready for Boulevard-authenticated history, but no client session has been attached yet.';
      }
      if (bootstrap.status === 'session_attached') {
        return 'A client token is attached. Next we can use it to load real appointment history and profile data from Boulevard.';
      }
      return (bootstrap.auth_scheme && bootstrap.auth_scheme.note) || 'Boulevard history needs an authenticated client session.';
    }

    function statusLabel(record, upcomingState){
      if (record && record.cancelled) return 'Cancelled';
      if (upcomingState) return 'Upcoming';
      var stateLabel = String(record && record.state || '').trim();
      return stateLabel ? stateLabel.replace(/_/g, ' ') : 'Completed';
    }

    function statusClass(record, upcomingState){
      if (record && record.cancelled) return ' is-cancelled';
      if (upcomingState) return ' is-upcoming';
      return '';
    }

    function appointmentLead(record){
      return String(record && (record.location_name || record.slot_label) || '').trim();
    }

    function appointmentServices(record){
      var services = Array.isArray(record && record.services) ? record.services : [];
      return services.slice(0, 4).map(function(service){
        var staffName = String(service && (service.staff_name || service.stylist_name) || '').trim();
        var optionText = Array.isArray(service && service.options) ? service.options.join(', ') : '';
        var suffix = [staffName, optionText].filter(Boolean).join(' · ');
        return {
          name: String(service && service.name || 'Service').trim() + (suffix ? ' (' + suffix + ')' : ''),
          detail: ''
        };
      });
    }

    function renderAppointmentRow(record, upcomingState){
      var services = appointmentServices(record);
      var appointmentId = dashboardAppointmentKey(record);
      var appointmentAction = state.clientAccount.appointmentAction || {};
      var isManaging = appointmentAction.appointmentId === appointmentId;
      var isBusy = isManaging && appointmentAction.loading;
      var canCancel = upcomingState && record && !record.cancelled && record.cancellable;
      var canReschedule = upcomingState && record && !record.cancelled && record.reschedulable;
      var actionMarkup = '';
      var rescheduleMarkup = '';

      if (canCancel || canReschedule) {
        actionMarkup = ''
          + '<div class="bk-dashboardRowActions">'
          +   (canReschedule ? '<button class="bk-dashboardRowAction" type="button" data-choice-type="dashboard-reschedule-start" data-choice-id="' + escapeHtml(appointmentId) + '"' + (isBusy ? ' disabled' : '') + '>' + escapeHtml(isBusy && appointmentAction.mode.indexOf('reschedule') === 0 ? 'Loading…' : 'Reschedule') + '</button>' : '')
          +   (canCancel ? '<button class="bk-dashboardRowAction" type="button" data-choice-type="dashboard-cancel-appointment" data-choice-id="' + escapeHtml(appointmentId) + '"' + (isBusy ? ' disabled' : '') + '>' + escapeHtml(isBusy && appointmentAction.mode === 'cancel' ? 'Cancelling…' : 'Cancel') + '</button>' : '')
          + '</div>';
      }

      if (isManaging && appointmentAction.mode.indexOf('reschedule') === 0) {
        rescheduleMarkup = ''
          + '<div class="bk-dashboardReschedule">'
          +   '<p class="bk-dashboardRescheduleLabel">' + escapeHtml(appointmentAction.selectedDate ? 'Choose a new time.' : 'Choose a new date.') + '</p>'
          +   (!appointmentAction.selectedDate
                ? '<div class="bk-dashboardChipList">'
                  + (Array.isArray(appointmentAction.dates) && appointmentAction.dates.length
                      ? appointmentAction.dates.slice(0, 10).map(function(dateValue){
                          return '<button class="bk-dashboardChip" type="button" data-choice-type="dashboard-reschedule-date" data-choice-id="' + escapeHtml(appointmentId) + '" data-date="' + escapeHtml(dateValue) + '">' + escapeHtml(formatDashboardDateOnly(dateValue, dateValue)) + '</button>';
                        }).join('')
                      : '<span class="bk-dashboardRescheduleLabel">' + escapeHtml(isBusy ? 'Loading dates…' : 'No reschedule dates available right now.') + '</span>')
                  + '</div>'
                : '<div class="bk-dashboardChipList">'
                  + (Array.isArray(appointmentAction.times) && appointmentAction.times.length
                      ? appointmentAction.times.slice(0, 12).map(function(time){
                          return '<button class="bk-dashboardChip' + (appointmentAction.selectedTimeId === time.bookable_time_id ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-reschedule-time" data-choice-id="' + escapeHtml(appointmentId) + '" data-bookable-time-id="' + escapeHtml(time.bookable_time_id || '') + '">' + escapeHtml(formatDashboardTimeOnly(time.start_at, time.start_at)) + '</button>';
                        }).join('')
                      : '<span class="bk-dashboardRescheduleLabel">' + escapeHtml(isBusy ? 'Loading times…' : 'No times available on that date.') + '</span>')
                  + '</div>')
          +   '<button class="bk-dashboardRowAction" type="button" data-choice-type="dashboard-reschedule-reset" data-choice-id="' + escapeHtml(appointmentId) + '">Close</button>'
          + '</div>';
      }

      return ''
        + '<article class="bk-dashboardRow' + (record && record.cancelled ? ' is-cancelled' : '') + '">'
        +   '<div class="bk-dashboardRowMain">'
        +     '<div class="bk-dashboardRowTop">'
        +       '<h4 class="bk-dashboardRowTitle">' + escapeHtml(formatDashboardDate(record && record.start_at, 'Booked visit')) + '</h4>'
        +     '</div>'
        +     '<div class="bk-dashboardRowServices">'
        +       (services.length
              ? services.map(function(service){
                  return '<div class="bk-dashboardRowService"><span>' + escapeHtml(service.name) + '</span><span>' + escapeHtml(service.detail || '') + '</span></div>';
                }).join('')
              : '<div class="bk-dashboardRowService"><span>Appointment</span><span></span></div>')
        +     '</div>'
        +     actionMarkup
        +     rescheduleMarkup
        +   '</div>'
        +   '<div class="bk-dashboardRowAside">'
        +     '<span class="bk-dashboardStatus' + statusClass(record, upcomingState) + '">' + escapeHtml(statusLabel(record, upcomingState)) + '</span>'
        +   '</div>'
        + '</article>';
    }

    function renderSignInPanel(){
      var codeSent = !!String(state.clientAccount.requestId || '').trim();
      var authMethodLabel = 'phone';
      var destinationLabel = String(
        authStart && (authStart.obfuscated_phone_number || authStart.obfuscatedPhoneNumber || authStart.identifier_masked || authStart.email || '')
        || state.clientAccount.identifier
        || ''
      ).trim();
      return ''
        + '<div class="bk-dashboardPanel">'
        +   '<div class="bk-dashboardSection">'
        +     '<div class="bk-dashboardSectionHead"><div><p class="bk-dashboardSectionTitle">Account access</p><p class="bk-dashboardSectionMeta">' + escapeHtml(codeSent ? ('Enter the code we sent to your ' + authMethodLabel + (destinationLabel ? ' at ' + destinationLabel : '') + '.') : 'Use your phone number to sign in.') + '</p></div></div>'
        +     (!codeSent
              ? ''
                + '<label class="bk-field bk-field--quiet"><span class="bk-label">Phone</span><input class="bk-input" id="bkDashboardIdentifier" inputmode="tel" placeholder="' + escapeHtml('+13105555555') + '" value="' + escapeHtml(state.clientAccount.identifier || '') + '" /></label>'
                + '<div class="bk-actions" style="padding-top:0;">'
                +   '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="dashboard-auth-start">' + escapeHtml(state.clientAccount.loading ? 'Working…' : 'Text me a code') + '</button>'
                + '</div>'
              : ''
                + '<label class="bk-field bk-field--quiet"><span class="bk-label">Verification code</span><input class="bk-input" id="bkDashboardCode" inputmode="numeric" placeholder="123456" value="' + escapeHtml(state.clientAccount.verificationCode || '') + '" /></label>'
                + '<div class="bk-actions" style="padding-top:0;">'
                +   '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="dashboard-auth-verify">' + escapeHtml(state.clientAccount.loading ? 'Checking…' : 'Verify code') + '</button>'
                +   '<button class="bk-btn bk-btn--ghost" type="button" data-choice-type="dashboard-auth-reset">Use a different phone</button>'
                + '</div>')
        +   '</div>'
        + '</div>';
    }

    function renderConnectedPanel(){
      var firstName = String(profile && (profile.firstName || profile.first_name) || '').trim();
      var sessionNote = !hasLiveData && hasSavedSession && !state.clientAccount.loading
        ? 'Saved session found, but live Boulevard account data has not loaded yet. Refresh or sign in again.'
        : '';
      return ''
        + '<div class="bk-dashboardHeader">'
        +   '<div class="bk-dashboardHeaderTop">'
        +     '<div class="bk-dashboardProfile">'
        +       '<h4 class="bk-dashboardProfileName">' + escapeHtml('Welcome, ' + (firstName || profileName)) + '</h4>'
        +       '<div class="bk-inlineUtilityNav">'
        +         '<button class="bk-dashboardHeaderAction" type="button" data-choice-type="dashboard-back-booking">Back to booking</button>'
        +         '<button class="bk-dashboardHeaderAction" type="button" data-choice-type="dashboard-auth-refresh">' + escapeHtml(state.clientAccount.loading ? 'Refreshing…' : 'Refresh') + '</button>'
        +         '<button class="bk-dashboardHeaderAction" type="button" data-choice-type="dashboard-auth-clear">Sign out</button>'
        +       '</div>'
        +     '</div>'
        +   '</div>'
        +   (sessionNote ? '<div class="bk-dashboardEmpty" style="margin-top:12px;">' + escapeHtml(sessionNote) + '</div>' : '')
        + '</div>';
    }

    function renderWalletRow(title, meta, badge){
      return ''
        + '<article class="bk-dashboardWalletRow">'
        +   '<div class="bk-dashboardWalletMain">'
        +     '<h4 class="bk-dashboardWalletTitle">' + escapeHtml(title || '') + '</h4>'
        +     (meta ? '<p class="bk-dashboardWalletMeta">' + escapeHtml(meta) + '</p>' : '')
        +   '</div>'
        +   (badge ? '<span class="bk-dashboardStatus is-upcoming">' + escapeHtml(badge) + '</span>' : '')
        + '</article>';
    }

    function renderCardsPanel(){
      return ''
        + '<div class="bk-dashboardPanel" style="grid-column:1 / -1;">'
        +   '<div class="bk-dashboardSection">'
        +     '<div class="bk-dashboardSectionHead"><div><p class="bk-dashboardSectionTitle">Saved cards</p><p class="bk-dashboardSectionMeta">' + escapeHtml(cards.length ? 'Cards Boulevard already knows for this client.' : 'No saved cards yet.') + '</p></div></div>'
        +     '<div class="bk-dashboardWallet">'
        +       (cards.length
              ? cards.map(function(card){
                  var brand = String(card && card.brand || '').trim();
                  var last4 = String(card && card.last4 || '').trim();
                  var expMonth = card && card.exp_month ? String(card.exp_month).padStart(2, '0') : '';
                  var expYear = card && card.exp_year ? String(card.exp_year) : '';
                  var title = String(card && card.name || '').trim() || [brand, last4 ? '•••• ' + last4 : ''].filter(Boolean).join(' ');
                  var meta = [expMonth && expYear ? 'Expires ' + expMonth + '/' + expYear : '', brand].filter(Boolean).join(' · ');
                  return renderWalletRow(title, meta, brand || 'Card');
                }).join('')
              : '<div class="bk-dashboardEmpty">Saved cards will appear here.</div>')
        +     '</div>'
        +   '</div>'
        + '</div>';
    }

    function renderVouchersPanel(){
      return ''
        + '<div class="bk-dashboardPanel" style="grid-column:1 / -1;">'
        +   '<div class="bk-dashboardSection">'
        +     '<div class="bk-dashboardSectionHead"><div><p class="bk-dashboardSectionTitle">Vouchers</p><p class="bk-dashboardSectionMeta">' + escapeHtml(vouchers.length ? 'Available client vouchers from Boulevard.' : 'No vouchers available right now.') + '</p></div></div>'
        +     '<div class="bk-dashboardWallet">'
        +       (vouchers.length
              ? vouchers.map(function(voucher){
                  var count = typeof (voucher && voucher.available_count) === 'number' ? voucher.available_count : null;
                  var meta = voucher && voucher.expires_on
                    ? 'Expires ' + formatDashboardDateOnly(voucher.expires_on, voucher.expires_on)
                    : 'No expiration listed';
                  var badge = count === null ? 'Voucher' : (count + ' available');
                  return renderWalletRow(String(voucher && voucher.name || 'Voucher').trim(), meta, badge);
                }).join('')
              : '<div class="bk-dashboardEmpty">Redeemable vouchers will appear here.</div>')
        +     '</div>'
        +   '</div>'
        + '</div>';
    }

    function renderReferralsPanel(){
      return ''
        + '<div class="bk-dashboardPanel" style="grid-column:1 / -1;">'
        +   '<div class="bk-dashboardSection">'
        +     '<div class="bk-dashboardSectionHead"><div><p class="bk-dashboardSectionTitle">Referrals</p><p class="bk-dashboardSectionMeta">' + escapeHtml(referrals.length ? 'Your referral activity and code.' : 'Your referral code and history.') + '</p></div></div>'
        +     '<div class="bk-dashboardWallet">'
        +       (referralCodes.length
              ? referralCodes.map(function(item, index){
                  return renderWalletRow(
                    index === 0 ? 'Referral code' : 'Referral code ' + (index + 1),
                    String(item && item.code || '').trim(),
                    'Code'
                  );
                }).join('')
              : '<div class="bk-dashboardEmpty">No referral code is available for this client right now.</div>')
        +       (referrals.length
              ? referrals.map(function(referral){
                  var created = referral && referral.created_at ? formatDashboardDateOnly(referral.created_at, referral.created_at) : '';
                  var reward = referral && typeof referral.referrer_reward_amount === 'number'
                    ? ('Reward ' + formatMoney(referral.referrer_reward_amount))
                    : '';
                  var voucherReward = referral && typeof referral.voucher_quantity === 'number' && referral.voucher_quantity > 0
                    ? (referral.voucher_quantity + ' voucher' + (referral.voucher_quantity === 1 ? '' : 's'))
                    : '';
                  var source = String(referral && (referral.referral_source_name || referral.referrer_client_name) || '').trim();
                  var meta = [created, source, reward, voucherReward].filter(Boolean).join(' · ');
                  return renderWalletRow(
                    String(referral && (referral.client_first_name || 'Referral') || 'Referral').trim(),
                    meta,
                    referral && referral.from_referral_program ? 'Program' : 'Referral'
                  );
                }).join('')
              : '')
        +     '</div>'
        +   '</div>'
        + '</div>';
    }

    dashboardPanel.innerHTML = ''
      + '<section class="bk-dashboardGrid">'
      +   (hasSavedSession ? renderConnectedPanel() : renderSignInPanel())
      +   (hasSavedSession
            ? ''
              + '<div class="bk-dashboardPanel" style="grid-column:1 / -1;">'
              +   '<div class="bk-dashboardSection">'
              +     '<div class="bk-dashboardTabs">'
              +       '<button class="bk-dashboardTab' + (activeSection === 'appointments' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-section" data-choice-id="appointments">Appointments</button>'
              +       '<button class="bk-dashboardTab' + (activeSection === 'referrals' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-section" data-choice-id="referrals">Referrals</button>'
              +       '<button class="bk-dashboardTab' + (activeSection === 'vouchers' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-section" data-choice-id="vouchers">Vouchers</button>'
              +       '<button class="bk-dashboardTab' + (activeSection === 'cards' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-section" data-choice-id="cards">Saved cards</button>'
              +     '</div>'
              +   '</div>'
              + '</div>'
              +   (activeSection === 'appointments'
                    ? ''
                      + '<div class="bk-dashboardPanel" style="grid-column:1 / -1;">'
                      +   '<div class="bk-dashboardSection">'
                      +     '<div class="bk-dashboardSectionHead"><div><p class="bk-dashboardSectionTitle">Appointments</p><p class="bk-dashboardSectionMeta">' + escapeHtml(activeTab === 'upcoming' ? (nextVisit ? 'Everything coming up next.' : 'Nothing upcoming right now.') : (past.length ? 'Your past visits.' : 'No previous visits yet.')) + '</p></div></div>'
                      +     '<div class="bk-dashboardTabs">'
                      +       '<button class="bk-dashboardTab' + (activeTab === 'upcoming' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-tab" data-choice-id="upcoming">Upcoming</button>'
                      +       '<button class="bk-dashboardTab' + (activeTab === 'past' ? ' is-selected' : '') + '" type="button" data-choice-type="dashboard-tab" data-choice-id="past">Past</button>'
                      +     '</div>'
                      +     '<div class="bk-dashboardTimeline">'
                      +       (visibleAppointments.length
                            ? visibleAppointments.map(function(record){ return renderAppointmentRow(record, activeTab === 'upcoming'); }).join('')
                            : '<div class="bk-dashboardEmpty">' + escapeHtml(activeTab === 'upcoming' ? 'No upcoming appointments yet.' : 'Your appointment history will appear here.') + '</div>')
                      +     '</div>'
                      +   '</div>'
                      + '</div>'
                    : (activeSection === 'referrals'
                      ? renderReferralsPanel()
                      : (activeSection === 'vouchers' ? renderVouchersPanel() : renderCardsPanel())))
            : '')
      + '</section>';
  }

  function renderTimeGroups(groups, selectedId){
    if (state.availabilityLoading) {
      timeChoices.innerHTML = ''
        + '<div class="bk-timeLoading">'
        +   '<p class="bk-timeLoadingLine">Looking for openings</p>'
        +   '<div class="bk-timeLoadingMeta">'
        +     '<div class="bk-timeLoadingBars" aria-hidden="true"><span></span><span></span><span></span></div>'
        +     '<p class="bk-timeLoadingCopy">Pulling together the best openings for this visit.</p>'
        +   '</div>'
        + '</div>';
      return;
    }

    if (!groups.length) {
      var signedIn = !!String(state.clientAccount && state.clientAccount.clientToken || '').trim();
      var waitlistMode = String(state.clientAccount.waitlistMode || 'first_available');
      var preferredDate = String(state.clientAccount.waitlistPreferredDate || '');
      timeChoices.innerHTML = ''
        + '<div class="bk-empty">'
        +   '<div>No times available in this range. Try another range above.</div>'
        +   (signedIn
              ? ''
                + '<div class="bk-waitlistPrefs">'
                +   '<div class="bk-waitlistModes">'
                +     '<button class="bk-waitlistMode' + (waitlistMode === 'first_available' ? ' is-selected' : '') + '" type="button" data-choice-type="waitlist-mode" data-choice-id="first_available">First available</button>'
                +     '<button class="bk-waitlistMode' + (waitlistMode === 'specific_date' ? ' is-selected' : '') + '" type="button" data-choice-type="waitlist-mode" data-choice-id="specific_date">Specific date</button>'
                +   '</div>'
                +   (waitlistMode === 'specific_date'
                      ? '<label class="bk-field bk-field--quiet"><span class="bk-label">Preferred date</span><input class="bk-input" id="bkWaitlistDate" type="date" min="' + escapeHtml(todayInputValue()) + '" value="' + escapeHtml(preferredDate) + '" /></label>'
                      : '')
                + '</div>'
              : '')
        +   '<div class="bk-actions" style="padding-top:12px;">'
        +     (signedIn
              ? '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="join-waitlist">' + escapeHtml(state.clientAccount.waitlistLoading ? 'Joining waitlist…' : 'Join waitlist') + '</button>'
              : '<button class="bk-btn bk-btn--primary" type="button" data-choice-type="open-dashboard" data-choice-id="dashboard">Sign in to join waitlist</button>')
        +   '</div>'
        + '</div>';
      return;
    }

    timeChoices.innerHTML = groups.map(function(group){
      var slots = Array.isArray(group.slots) ? group.slots : [];
      if (!slots.length) return '';

      return ''
        + '<div class="bk-dayGroup">'
        +   '<div class="bk-dayHeader">' + escapeHtml(group.label || group.date || '') + '</div>'
        +   '<div class="bk-timeGrid">'
        +     slots.map(function(slot){
                var selected = slot.id === selectedId ? ' is-selected' : '';
                var timeOnly = formatTimeOnly(slot);
                var staffSummary = slotStaffSummary(slot);
                var breakout = Array.isArray(slot.service_breakout) && slot.service_breakout.length
                  ? slot.service_breakout.map(function(item){
                      return '<span>' + escapeHtml((item.service_name || 'Service') + ': ' + (item.staff_name || 'No preference')) + '</span>';
                    }).join('')
                  : '';

                var slotPrice = slot.id === selectedId && slot.slot_summary && typeof slot.slot_summary.total === 'number'
                  ? '<div class="bk-timePrice">' + escapeHtml(formatMoney(slot.slot_summary.total)) + '</div>'
                  : '';

                return ''
                  + '<button class="bk-choice bk-timeButton' + selected + '" type="button" data-choice-type="time" data-choice-id="' + escapeHtml(slot.id) + '" data-choice-label="' + escapeHtml((group.label || '') + ', ' + timeOnly) + '">'
                  +   '<p class="bk-choice__title">' + escapeHtml(timeOnly) + '</p>'
                  +   (staffSummary ? '<p class="bk-timeStaff">' + escapeHtml(staffSummary) + '</p>' : '')
                  +   (selected && breakout ? '<div class="bk-timeBreakout">' + breakout + '</div>' : '')
                  +   slotPrice
                  + '</button>';
              }).join('')
        +   '</div>'
        + '</div>';
    }).join('');
  }

  function renderPerServicePanels(){
    var item = currentStylistService();

    if (!item) {
      if (stylistStepTitle) stylistStepTitle.textContent = 'Choose your stylist.';
      if (stylistStepText) stylistStepText.textContent = 'Pick one or more stylists for this service, or leave it as no preference.';
      perServiceStaffPanels.innerHTML = '<div class="bk-empty">Choose your services first.</div>';
      return;
    }

    var options = state.staffOptionsByService[item.service_id] || [];
    var serviceLabel = item.name.replace(/^hs\./, '');
    var question = 'Who do you want to do your ' + serviceLabel.toLowerCase() + '?';

    if (stylistStepTitle) stylistStepTitle.textContent = question;
    if (stylistStepText) {
      stylistStepText.textContent = state.serviceStack.length > 1
        ? 'Choose one or more stylists for ' + serviceLabel + ', or leave it as no preference.'
        : 'Pick one or more stylists for this service, or leave it as no preference.';
    }

    function cleanBioPreview(option){
      var bio = String((option && option.bio) || '').trim();
      if (bio) return bio.length > 140 ? bio.slice(0, 137).replace(/\s+\S*$/, '') + '...' : bio;
      return '';
    }

    function inferStaffRole(option){
      if (!option || option.id === 'any') return 'No preference';
      if (option.role) {
        var normalizedRole = String(option.role).trim().toLowerCase();
        if (normalizedRole === 'hs.stylist' || normalizedRole === 'stylist 1' || normalizedRole === 'stylist 2') {
          return 'Stylist';
        }
        return String(option.role).trim() || 'Salon Team';
      }
      var text = [option.name, option.bio, option.note].filter(Boolean).join(' ').toLowerCase();
      if (/extension|weft|hand-tied/.test(text)) return 'Extensions';
      if (/blond|balayage|foil|highlight|lived-in|dimensional|color|corrective|gloss/.test(text)) return 'Color';
      if (/cut|bob|pixie|shape|precision|scissor|fringe/.test(text)) return 'Cut';
      if (/blowout|blowdry|finish|style|styling|waves|curl|event|bridal/.test(text)) return 'Styling';
      return 'Salon Team';
    }

    function roleRank(role){
      var normalizedRole = String(role || '').trim().toLowerCase();
      if (normalizedRole === 'hs.stylist') return 1;
      if (normalizedRole === 'stylist 2') return 2;
      if (normalizedRole === 'stylist 1') return 3;
      if (normalizedRole === 'color') return 10;
      if (normalizedRole === 'cut') return 11;
      if (normalizedRole === 'extensions') return 12;
      if (normalizedRole === 'styling') return 13;
      if (normalizedRole === 'salon team') return 14;
      return 20;
    }

    function renderStaffButton(option){
      var selectedIds = selectedStylistIdsForItem(item);
      var selected = option.id === 'any'
        ? (!selectedIds.length ? ' is-selected' : '')
        : (selectedIds.indexOf(option.id) !== -1 ? ' is-selected' : '');
      var role = inferStaffRole(option);
      var bio = cleanBioPreview(option);
      var noPrefClass = option.id === 'any' ? ' bk-staffNoPref' : '';
      var name = option.name || '';
      var avatar = String((option && option.avatar) || '').trim();
      var initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map(function(part){
        return part.charAt(0);
      }).join('') || 'HT';
      var avatarMarkup = option.id === 'any'
        ? ''
        : (avatar
        ? '<img src="' + escapeHtml(avatar) + '" alt="' + escapeHtml(name) + '" loading="lazy" />'
        : '<div class="bk-staffAvatarFallback">' + escapeHtml(initials) + '</div>');

      return ''
        + '<button class="bk-choice bk-choice--staff' + selected + noPrefClass + '" type="button" data-choice-type="service-staff" data-service-id="' + escapeHtml(item.service_id) + '" data-choice-id="' + escapeHtml(option.id) + '" data-choice-label="' + escapeHtml(option.name || '') + '">'
        +   '<div class="bk-staffCardTop">'
        +     (avatarMarkup ? '<div class="bk-staffAvatar">' + avatarMarkup + '</div>' : '')
        +     '<div class="bk-staffBody">'
        +       '<div class="bk-staffIdentity">'
        +         '<p class="bk-staffName">' + escapeHtml(option.name || '') + '</p>'
        +         '<span class="bk-staffRoleTag">' + escapeHtml(role) + '</span>'
        +       '</div>'
        +       (bio ? '<p class="bk-staffBio">' + escapeHtml(bio) + '</p>' : '')
        +     '</div>'
        +   '</div>'
        + '</button>';
    }

    var list = '<div class="bk-empty">No stylists available yet.</div>';
    if (options.length) {
      var noPreferenceOption = null;
      var grouped = {};

      options.forEach(function(option){
        if (option.id === 'any') {
          noPreferenceOption = option;
          return;
        }
        var role = inferStaffRole(option);
        if (!grouped[role]) grouped[role] = [];
        grouped[role].push(option);
      });

      var roleBlocks = Object.keys(grouped).sort(function(a, b){
        var rankDiff = roleRank(a) - roleRank(b);
        if (rankDiff !== 0) return rankDiff;
        return a.localeCompare(b);
      }).map(function(role){
        var cards = grouped[role].sort(function(a, b){
          return String(a.name || '').localeCompare(String(b.name || ''));
        }).map(renderStaffButton).join('');
        return ''
          + '<div class="bk-staffRoleBlock">'
          +   '<div class="bk-staffRoleHead">'
          +     '<span class="bk-staffRoleKicker">' + escapeHtml(role) + '</span>'
          +     '<span class="bk-staffRoleRule"></span>'
          +   '</div>'
          +   '<div class="bk-grid">' + cards + '</div>'
          + '</div>';
      }).join('');

      list = ''
        + (noPreferenceOption
          ? '<div class="bk-staffRoleBlock"><div class="bk-grid bk-grid--single">' + renderStaffButton(noPreferenceOption) + '</div></div>'
          : '')
        + roleBlocks;
    }

    perServiceStaffPanels.innerHTML = ''
      + '<div class="bk-serviceStaffGroup">'
      +   list
      + '</div>';
  }

  function goTo(screen){
    if (screen !== 'dashboard' && screen !== 'staff-directory') {
      state.lastBookingScreen = screen;
    }
    state.screen = screen;
    updateUI();
  }

  function nextAfterBlowdryHairType(){
    if (state.answers.entryChoice === 'blowdry') return 'stylist-per-service';
    if (state.answers.entryChoice === 'color') {
      if (hasServiceKey('single_process') && state.answers.colorGoal !== 'darker_richer') return 'modifier-glaze';
      return 'stylist-per-service';
    }
    if (state.answers.entryChoice === 'treatment') return 'stylist-per-service';
    if (state.answers.entryChoice === 'extensions') return 'stylist-per-service';
    return 'stylist-per-service';
  }

  function treatmentNeedsFinishQuestions(){
    return ['treatment_smoothfiller', 'treatment_keratin', 'treatment_magic_sleek'].indexOf(state.answers.manualServiceKey) !== -1;
  }

  function nextFrom(screen){
    var a = state.answers;

    if (screen === 'entry') {
      if (a.entryChoice === 'photo') return 'photo-analyze';
      if (a.entryChoice === 'blowdry') return 'blowdry-style';
      if (a.entryChoice === 'haircut') return 'haircut-type';
      if (a.entryChoice === 'color') return 'color-goal';
      if (a.entryChoice === 'extensions') return 'extensions-type';
      if (a.entryChoice === 'treatment') return 'treatment-type';
    }

    if (screen === 'photo-analyze') return 'photo-followup';
    if (screen === 'photo-followup') return 'stylist-per-service';
    if (screen === 'blowdry-style') {
      if (a.entryChoice === 'extensions' && a.manualServiceKey === 'extension_maintenance') {
        return 'stylist-per-service';
      }
      return 'blowdry-hair-type';
    }
    if (screen === 'blowdry-hair-type') return nextAfterBlowdryHairType();
    if (screen === 'haircut-type') {
      if (manualEntryHasStandardHaircut()) return 'modifier-haircut-thick';
      return 'stylist-per-service';
    }
    if (screen === 'extensions-type') {
      if (a.manualServiceKey === 'extension_maintenance') return 'extension-maintenance-tracks';
      return 'stylist-per-service';
    }
    if (screen === 'extension-maintenance-tracks') return 'extension-blowdry';
    if (screen === 'extension-blowdry') {
      if (a.extensionNeedsBlowdry) return 'blowdry-style';
      return 'stylist-per-service';
    }
    if (screen === 'treatment-type') return treatmentNeedsFinishQuestions() ? 'treatment-haircut' : 'stylist-per-service';
    if (screen === 'treatment-haircut') {
      if (a.treatmentNeedsHaircut === true) return 'modifier-haircut-thick';
      return 'treatment-blowdry';
    }
    if (screen === 'treatment-blowdry') {
      if (a.treatmentNeedsBlowdry) return 'blowdry-style';
      return 'stylist-per-service';
    }

    if (screen === 'color-goal') {
      if (a.colorGoal === 'gray_only') return 'color-haircut';
      if (a.colorGoal === 'gray_plus_brightness') return 'color-placement';
      if (a.colorGoal === 'lighter_brighter') return 'color-placement';
      if (a.colorGoal === 'darker_richer') return 'color-haircut';
    }

    if (screen === 'color-placement') return 'color-haircut';

    if (screen === 'color-haircut') {
      if (a.colorNeedsHaircut === true) {
        if (hasServiceKey('single_process') && a.colorGoal !== 'darker_richer') return 'modifier-glaze';
        return 'modifier-haircut-thick';
      }
      return 'color-blowdry';
    }

    if (screen === 'color-blowdry') {
      if (a.colorNeedsBlowdry) return 'blowdry-style';
      if (hasServiceKey('single_process') && a.colorGoal !== 'darker_richer') return 'modifier-glaze';
      return 'stylist-per-service';
    }

    if (screen === 'modifier-glaze') {
      if (hasServiceKey('haircut')) return 'modifier-haircut-thick';
      return 'stylist-per-service';
    }

    if (screen === 'modifier-haircut-thick') return 'modifier-haircut-change';
    if (screen === 'modifier-haircut-change') return 'stylist-per-service';
    if (screen === 'stylist-per-service') return 'time';
    if (screen === 'time') return 'guest';
    if (screen === 'guest') return 'review';
    if (screen === 'review') return 'done';
    if (screen === 'dashboard') return 'dashboard';
    return screen;
  }

  function prevFrom(screen){
    var a = state.answers;

    if (screen === 'entry') return 'entry';
    if (screen === 'photo-analyze') return 'entry';
    if (screen === 'photo-followup') return 'photo-analyze';

    if (screen === 'blowdry-style') {
      if (a.entryChoice === 'blowdry') return 'entry';
      if (a.entryChoice === 'extensions' && a.manualServiceKey === 'extension_maintenance') return 'extension-blowdry';
      return 'color-blowdry';
    }

    if (screen === 'blowdry-hair-type') return 'blowdry-style';
    if (screen === 'haircut-type') return 'entry';
    if (screen === 'extensions-type') return 'entry';
    if (screen === 'extension-maintenance-tracks') return 'extensions-type';
    if (screen === 'extension-blowdry') return 'extension-maintenance-tracks';
    if (screen === 'treatment-type') return 'entry';
    if (screen === 'treatment-haircut') return 'treatment-type';
    if (screen === 'treatment-blowdry') return 'treatment-haircut';
    if (screen === 'color-goal') return 'entry';
    if (screen === 'color-placement') return 'color-goal';

    if (screen === 'color-haircut') {
      if (a.colorGoal === 'gray_only') return 'color-goal';
      if (a.colorGoal === 'gray_plus_brightness' || a.colorGoal === 'lighter_brighter') return 'color-placement';
      return 'color-goal';
    }

    if (screen === 'color-blowdry') return 'color-haircut';

    if (screen === 'modifier-glaze') {
      if (a.entryChoice === 'color' && a.colorNeedsHaircut === true) return 'color-haircut';
      return a.colorNeedsBlowdry ? 'blowdry-hair-type' : 'color-blowdry';
    }

    if (screen === 'modifier-haircut-thick') {
      if (a.entryChoice === 'haircut') return 'haircut-type';
      if (a.entryChoice === 'treatment' && a.treatmentNeedsHaircut === true) return 'treatment-haircut';
      if (a.entryChoice === 'color' && a.colorNeedsHaircut === true) {
        return hasServiceKey('single_process') && a.colorGoal !== 'darker_richer'
          ? 'modifier-glaze'
          : 'color-haircut';
      }
      if (hasServiceKey('single_process') && a.colorGoal !== 'darker_richer') return 'modifier-glaze';
      return 'color-blowdry';
    }

    if (screen === 'modifier-haircut-change') return 'modifier-haircut-thick';

    if (screen === 'stylist-per-service') {
      if (a.entryChoice === 'photo') return 'photo-analyze';
      if (manualEntryHasStandardHaircut() || hasServiceKey('haircut')) return 'modifier-haircut-change';
      if (a.entryChoice === 'haircut') return 'haircut-type';
      if (hasServiceKey('single_process') && a.colorGoal !== 'darker_richer') return 'modifier-glaze';
      if (hasStandaloneBlowdryInVisit()) return 'blowdry-hair-type';
      if (a.entryChoice === 'blowdry') return 'entry';
      if (a.entryChoice === 'extensions') {
        if (a.extensionNeedsBlowdry === true && a.manualServiceKey === 'extension_maintenance' && a.blowdryStyle) return 'blowdry-style';
        if (a.manualServiceKey === 'extension_maintenance') return 'extension-blowdry';
        return 'extensions-type';
      }
      if (a.entryChoice === 'treatment') {
        if (a.treatmentNeedsHaircut === true) return 'modifier-haircut-change';
        if (a.treatmentNeedsBlowdry === true) return 'blowdry-hair-type';
        return treatmentNeedsFinishQuestions() ? 'treatment-blowdry' : 'treatment-type';
      }
      return 'color-blowdry';
    }

    if (screen === 'time') return 'stylist-per-service';
    if (screen === 'guest') return 'time';
    if (screen === 'review') return 'guest';
    if (screen === 'done') return 'review';
    if (screen === 'dashboard') return 'entry';
    if (screen === 'staff-directory') return 'entry';
    return 'entry';
  }

  function canContinue(){
    var s = state.screen;
    var isSignedIn = !!activeSignedInClientProfile();
    if (s === 'entry') return !!state.answers.entryChoice;
    if (s === 'photo-analyze') return false;
    if (s === 'photo-followup') return false;
    if (s === 'blowdry-style') return !!state.answers.blowdryStyle;
    if (s === 'blowdry-hair-type') return !!state.answers.blowdryHairType;
    if (s === 'haircut-type') return !!state.answers.manualServiceKey;
    if (s === 'extensions-type') return !!state.answers.manualServiceKey;
    if (s === 'extension-maintenance-tracks') return !!state.answers.extensionMaintenanceTracks;
    if (s === 'extension-blowdry') return state.answers.extensionNeedsBlowdry !== null;
    if (s === 'treatment-type') return !!state.answers.manualServiceKey;
    if (s === 'treatment-haircut') return state.answers.treatmentNeedsHaircut !== null;
    if (s === 'treatment-blowdry') return state.answers.treatmentNeedsBlowdry !== null;
    if (s === 'color-goal') return !!state.answers.colorGoal;
    if (s === 'color-placement') return !!state.answers.colorDimensionPlacement;
    if (s === 'color-haircut') return state.answers.colorNeedsHaircut !== null;
    if (s === 'color-blowdry') return state.answers.colorNeedsBlowdry !== null;
    if (s === 'modifier-glaze') return state.answers.singleProcessGlaze !== null;
    if (s === 'modifier-haircut-thick') return state.answers.haircutLongOrThick !== null;
    if (s === 'modifier-haircut-change') return state.answers.haircutBigChange !== null;
    if (s === 'stylist-per-service') return true;
    if (s === 'time') return !!state.slotId;
    if (s === 'guest') {
      if (isSignedIn) return hasCompletePaymentMethod();
      return !!state.firstName && !!state.lastName && !!state.email && !!state.phone && hasCompletePaymentMethod();
    }
    if (s === 'review') return true;
    if (s === 'dashboard') return false;
    if (s === 'staff-directory') return false;
    return false;
  }

  function isQuestionScreen(screen){
    return BOOKING_QUESTION_SCREENS.indexOf(screen) !== -1;
  }

  function progressValueForScreen(screen){
    return typeof BOOKING_PROGRESS_BY_SCREEN[screen] === 'number' ? BOOKING_PROGRESS_BY_SCREEN[screen] : 0;
  }

  function updateProgressUI(){
    if (!progressEl || !progressFillEl) return;
    var hide = state.screen === 'entry' || state.screen === 'dashboard' || state.screen === 'staff-directory';
    progressEl.classList.toggle('is-hidden', hide);
    progressEl.hidden = hide;
    progressEl.setAttribute('aria-hidden', hide ? 'true' : 'false');
    progressFillEl.style.width = (hide ? 0 : progressValueForScreen(state.screen)) + '%';
  }

  function updateUI(){
    var signedInProfile = activeSignedInClientProfile();
    var savedCards = availableSavedCards();
    var hideContinueForSavedCard = state.screen === 'guest' && savedCards.length && hasSavedCardSelected();
    var inlineBackOnly = isQuestionScreen(state.screen);

    root.querySelectorAll('.bk-screen').forEach(function(screen){
      screen.classList.toggle('is-active', screen.getAttribute('data-screen') === state.screen);
    });

    if (state.screen === 'photo-followup') {
      renderPhotoFollowup();
    } else {
      syncPhotoConsultHeader(null, 0, 0);
    }

    renderStack();
    renderTimeMeta();
    renderRangeChoices();
    renderBookingAccountInline();
    renderGuestPaymentMethods();
    updateProgressUI();

    if (guestHeading) {
      guestHeading.textContent = signedInProfile ? 'Payment details...' : 'Your details...';
    }
    if (entryGate && entryChoices) {
      var showEntryGate = state.screen === 'entry' && !signedInProfile;
      entryGate.hidden = !showEntryGate;
      entryChoices.hidden = showEntryGate;
    }
    if (guestContactFields) {
      guestContactFields.style.display = signedInProfile ? 'none' : '';
    }

    document.querySelectorAll('[data-choice-type="gratuity"]').forEach(function(btn){
      btn.classList.toggle('is-selected', btn.getAttribute('data-choice-id') === state.gratuityChoice);
    });
    if (gratuityCustomWrap) {
      gratuityCustomWrap.classList.toggle('is-active', state.gratuityChoice === 'custom');
    }

    backBtn.disabled = state.screen === 'entry' || state.screen === 'done';
    nextBtn.disabled = state.screen === 'dashboard' || state.screen === 'staff-directory' ? true : (!canContinue() || state.screen === 'done');
    nextBtn.textContent = state.screen === 'review' ? 'Book now' : (state.screen === 'done' ? 'Booked' : ((state.screen === 'dashboard' || state.screen === 'staff-directory') ? 'Saved' : 'Continue'));
    nextBtn.style.display = (hideContinueForSavedCard || inlineBackOnly) ? 'none' : '';
    if (actionsBar) {
      actionsBar.classList.toggle('is-inlineBack', inlineBackOnly);
    }
    if (actionsBar && actionsHome) {
      var activeActionsMount = null;
      if (state.screen === 'stylist-per-service' && stylistActionsMount) {
        activeActionsMount = stylistActionsMount;
      } else if (state.screen === 'time' && timeActionsMount) {
        activeActionsMount = timeActionsMount;
      }
      if (activeActionsMount) {
        if (actionsBar.parentNode !== activeActionsMount) {
          activeActionsMount.appendChild(actionsBar);
        }
      } else if (actionsBar.parentNode !== actionsHome) {
        actionsHome.appendChild(actionsBar);
      }
    }

    if (state.screen === 'review') updateReview();
    if (state.screen === 'done') updateDone();
    if (state.screen === 'dashboard') renderDashboard();
    if (state.screen === 'staff-directory') renderStaffDirectory();
  }

  async function fetchAvailabilityContext(){
    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'availability-context',
        include_staff_directory: true,
        services: servicePayload()
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not load stylist options');
    return {
      services: Array.isArray(data.services) ? data.services : [],
      staffDirectory: Array.isArray(data.staff_directory) ? data.staff_directory : []
    };
  }

  async function hydrateStylistOptions(){
    var context = await fetchAvailabilityContext();
    var services = Array.isArray(context && context.services) ? context.services : [];
    state.staffOptionsByService = {};
    state.staffDirectory = Array.isArray(context && context.staffDirectory) ? context.staffDirectory.slice() : [];
    services.forEach(function(service){
      var staff = Array.isArray(service.staff) ? service.staff.slice() : [];
      var hasNoPreference = staff.some(function(option){ return option.id === 'any'; });

      if (!hasNoPreference) {
        staff.unshift({
          id: 'any',
          name: 'No preference',
          note: 'Show me all combinations.'
        });
      }

      state.staffOptionsByService[service.service_id] = staff;
    });
    renderPerServicePanels();
  }

  async function fetchBookingProxyJson(payload, timeoutMs){
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = null;

    if (controller && Number(timeoutMs) > 0) {
      timeoutId = setTimeout(function(){
        controller.abort();
      }, Number(timeoutMs));
    }

    try {
      var response = await fetch(BOOKING_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      });

      var data = await response.json().catch(function(){ return null; });
      if (!response.ok || !data || !data.ok) {
        var rawError = String((data && data.error) || '').toLowerCase();
        if (response.status === 429 || rawError.indexOf('rate limit') > -1 || rawError.indexOf('status=429') > -1 || rawError.indexOf('api limit exceeded') > -1) {
          throw new Error('Availability is still loading. Please tap another time or try this week again.');
        }
      }
      return { response: response, data: data };
    } catch (error) {
      if (error && error.name === 'AbortError') {
        throw new Error('Availability is taking too long. Please try another week.');
      }
      throw error;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  async function fetchAvailability(onPartial){
    var weeklyDates = weeklyRangeDatesForKey(state.rangeKey);
    if (weeklyDates.length) {
      var partialGroupsByIndex = new Array(weeklyDates.length);
      var weeklyResponses = await Promise.allSettled(weeklyDates.map(function(dateValue, index){
        return fetchBookingProxyJson({
            action: 'availability',
            services: servicePayload(),
            date: dateValue,
            include_slot_breakout: true
          }, 12000).then(function(result){
            if (
              result &&
              result.response &&
              result.response.ok &&
              result.data &&
              result.data.ok &&
              Array.isArray(result.data.date_groups)
            ) {
              partialGroupsByIndex[index] = result.data.date_groups;
              if (typeof onPartial === 'function') {
                var partialMerged = [];
                partialGroupsByIndex.forEach(function(groups){
                  if (Array.isArray(groups) && groups.length) {
                    partialMerged = partialMerged.concat(groups);
                  }
                });
                onPartial(partialMerged);
              }
            }
            return result;
          });
      }));

      var mergedGroups = [];
      for (var i = 0; i < weeklyResponses.length; i += 1) {
        var settled = weeklyResponses[i];
        if (!settled || settled.status !== 'fulfilled') continue;
        var result = settled.value;
        if (!result.response.ok || !result.data || !result.data.ok) {
          continue;
        }
        if (!Array.isArray(result.data.date_groups)) {
          continue;
        }
        mergedGroups = mergedGroups.concat(result.data.date_groups);
      }

      if (!mergedGroups.length) {
        var failedMessage = weeklyResponses.find(function(result){
          return result && result.status === 'rejected' && result.reason;
        });
        if (failedMessage && failedMessage.reason && failedMessage.reason.message) {
          throw new Error(failedMessage.reason.message);
        }
      }

      return mergedGroups;
    }

    var result = await fetchBookingProxyJson({
      action: 'availability',
      services: servicePayload(),
      range_key: availabilityRangeKeyForRequest(),
      include_slot_breakout: true
    }, 12000);
    var response = result.response;
    var data = result.data;
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not load availability');
    if (!Array.isArray(data.date_groups)) throw new Error('Could not load availability.');
    return data.date_groups;
  }

  async function applyRangeSelection(nextRangeKey){
    if (nextRangeKey) {
      state.rangeKey = nextRangeKey;
    }
    state.slotId = '';
    state.slotLabel = '';
    state.slotEstimate = null;
    state.slotEstimateLoading = false;
    if (state.screen !== 'time') {
      updateUI();
      return;
    }
    var requestToken = ++availabilityRequestToken;
    currentAvailabilityGroups = [];
    state.availabilityLoading = true;
    updateUI();
    renderTimeGroups([], state.slotId);
    renderTimeMeta();
    setMessage('');
    try {
      var nextGroups = await fetchAvailability(function(partialGroups){
        if (requestToken !== availabilityRequestToken) return;
        currentAvailabilityGroups = Array.isArray(partialGroups) ? partialGroups : [];
        if (currentAvailabilityGroups.length) {
          state.availabilityLoading = false;
        }
        renderTimeGroups(currentAvailabilityGroups, state.slotId);
        renderTimeMeta();
        updateUI();
      });
      if (requestToken !== availabilityRequestToken) return;
      currentAvailabilityGroups = Array.isArray(nextGroups) ? nextGroups : [];
      state.availabilityLoading = false;
      renderTimeGroups(currentAvailabilityGroups, state.slotId);
      renderTimeMeta();
    } catch (error) {
      if (requestToken !== availabilityRequestToken) return;
      currentAvailabilityGroups = [];
      renderTimeGroups(currentAvailabilityGroups, state.slotId);
      renderTimeMeta();
      throw error;
    } finally {
      if (requestToken !== availabilityRequestToken) return;
      state.availabilityLoading = false;
      updateUI();
    }
  }

  async function reloadAvailabilityForCurrentRange(){
    await applyRangeSelection('');
  }

  async function fetchSlotEstimate(slotId){
    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'slot-breakout',
        services: servicePayload(),
        slot_id: slotId
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not load slot details');
    return {
      summary: data.summary || null,
      service_breakout: Array.isArray(data.service_breakout) ? data.service_breakout : []
    };
  }

  async function fetchSlotPriceOnly(slotId){
    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'slot-estimate',
        services: servicePayload(),
        slot_id: slotId
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not load slot estimate');
    return data.summary || null;
  }

  async function tokenizeCard(card){
    var response = await fetch(BOULEVARD_TOKENIZE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        card: {
          name: card.name,
          number: card.number,
          cvv: card.cvv,
          exp_month: Number(card.exp_month),
          exp_year: Number(card.exp_year),
          address_postal_code: card.address_postal_code
        }
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data) throw new Error('Could not tokenize card');

    var token = data.id || data.token || data.card_token || (data.data && (data.data.id || data.data.token)) || '';
    if (!token) throw new Error('Token response shape: ' + JSON.stringify(data));
    return token;
  }

  function hasCardInput(){
    return !!(state.cardNumber || state.cardCvv || state.cardExpMonth || state.cardExpYear || state.cardPostal || state.cardName);
  }

  function hasSavedCardSelected(){
    return !!String(state.selectedSavedCardId || '').trim();
  }

  function availableSavedCards(){
    return Array.isArray(state.clientAccount && state.clientAccount.dashboardData && state.clientAccount.dashboardData.cards)
      ? state.clientAccount.dashboardData.cards
      : [];
  }

  function clearCardInputs(){
    state.cardName = '';
    state.cardNumber = '';
    state.cardExpMonth = '';
    state.cardExpYear = '';
    state.cardCvv = '';
    state.cardPostal = '';
    if (cardNameInput) cardNameInput.value = '';
    if (cardNumberInput) cardNumberInput.value = '';
    if (cardExpMonthInput) cardExpMonthInput.value = '';
    if (cardExpYearInput) cardExpYearInput.value = '';
    if (cardCvvInput) cardCvvInput.value = '';
    if (cardPostalInput) cardPostalInput.value = '';
    if (cardBrandTag) {
      cardBrandTag.textContent = '';
      cardBrandTag.classList.remove('is-visible');
    }
  }

  function validateCardIfPresent(){
    if (hasSavedCardSelected()) return true;
    if (!hasCardInput()) return true;
    return !!(state.cardName && state.cardNumber && state.cardCvv && state.cardExpMonth && state.cardExpYear && state.cardPostal);
  }

  function hasCompleteCardInput(){
    return !!(state.cardName && state.cardNumber && state.cardCvv && state.cardExpMonth && state.cardExpYear && state.cardPostal);
  }

  function hasCompletePaymentMethod(){
    return hasSavedCardSelected() || hasCompleteCardInput();
  }

  function renderGuestPaymentMethods(){
    if (!paymentMethodsPanel || !paymentQuickPanel) return;
    var cards = availableSavedCards();
    if (!cards.length) {
      paymentMethodsPanel.innerHTML = '';
      paymentQuickPanel.classList.remove('is-hidden');
      return;
    }

    paymentMethodsPanel.innerHTML = ''
      + cards.map(function(card){
        var id = String(card && card.id || '').trim();
        var brand = String(card && card.brand || '').trim();
        var last4 = String(card && card.last4 || '').trim();
        var expMonth = card && card.exp_month ? String(card.exp_month).padStart(2, '0') : '';
        var expYear = card && card.exp_year ? String(card.exp_year) : '';
        var title = String(card && card.name || '').trim() || [brand, last4 ? '•••• ' + last4 : ''].filter(Boolean).join(' ');
        var meta = [brand, expMonth && expYear ? 'Expires ' + expMonth + '/' + expYear : ''].filter(Boolean).join(' · ');
        return ''
          + '<button class="bk-paymentMethod' + (state.selectedSavedCardId === id ? ' is-selected' : '') + '" type="button" data-choice-type="saved-card" data-choice-id="' + escapeHtml(id) + '">'
          +   '<span class="bk-paymentMethodTitle">' + escapeHtml(title || 'Saved card') + '</span>'
          +   (meta ? '<span class="bk-paymentMethodMeta">' + escapeHtml(meta) + '</span>' : '')
          + '</button>';
      }).join('')
      + '<button class="bk-paymentMethod' + (!state.selectedSavedCardId ? ' is-selected' : '') + '" type="button" data-choice-type="saved-card" data-choice-id="">'
      +   '<span class="bk-paymentMethodTitle">Use a different card</span>'
      +   '<span class="bk-paymentMethodMeta">Enter a new card for this booking.</span>'
      + '</button>';

    paymentQuickPanel.classList.toggle('is-hidden', hasSavedCardSelected());
  }

  async function submitBooking(){
    syncInputs();

    if (!validateCardIfPresent()) throw new Error('Complete all credit card fields to continue.');
    if (!hasCompletePaymentMethod()) throw new Error('Choose a saved card or complete all credit card fields to continue.');
    if (state.gratuityChoice === 'custom') {
      var customPercentage = Number(state.gratuityCustom);
      if (!Number.isFinite(customPercentage) || customPercentage < 0) {
        throw new Error('Enter a valid custom gratuity percentage.');
      }
    }

    var cardToken = '';
    if (!hasSavedCardSelected() && hasCardInput()) {
      cardToken = await tokenizeCard({
        name: state.cardName || [state.firstName, state.lastName].filter(Boolean).join(' ').trim(),
        number: state.cardNumber,
        cvv: state.cardCvv,
        exp_month: state.cardExpMonth,
        exp_year: state.cardExpYear,
        address_postal_code: state.cardPostal
      });
      showDebug({
        debug: {
          source: 'tokenizeCard',
          card_token: cardToken
        }
      });
    }

    var gratuityFixed = gratuityFixedAmount();
    var appointmentNote = buildAppointmentPhotoNote();
    var bookingPayload = {
      action: 'book',
      services: servicePayload(),
      slot_id: state.slotId,
      first_name: state.firstName,
      last_name: state.lastName,
      email: state.email,
      phone: state.phone,
      card_token: cardToken,
      saved_card_id: hasSavedCardSelected() ? state.selectedSavedCardId : '',
      client_token: hasSavedCardSelected() ? (state.clientAccount.clientToken || '') : '',
      notes: appointmentNote,
      gratuity_fixed: gratuityFixed,
      advance_gratuity: gratuityFixed === null ? null : {
        fixed: gratuityFixed
      }
    };

    showDebug({
      debug: {
        source: 'bookRequest',
        payload: bookingPayload
      }
    });

    var response = await fetch(BOOKING_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bookingPayload)
    });

    var data = await response.json().catch(function(){ return null; });
    showDebug({
      debug: {
        source: 'bookResponse',
        payload: bookingPayload,
        response: data,
        status: response.status
      }
    });
    if (!response.ok || !data || !data.ok) throw new Error((data && data.error) || 'Could not complete booking');
    return data;
  }

  async function maybeLoadStylistsAndAdvance(){
    rebuildServiceStack();
    var finishingScreen = finishingScreenBeforeStylists();
    if (finishingScreen) {
      if (finishingScreen === 'color-blowdry') {
        setMessage('Before we pick a stylist, do you want a finishing service at the end of the appointment so you do not leave with wet hair?');
      } else {
        setMessage('');
      }
      goTo(finishingScreen);
      return;
    }
    resetStylistStep();
    setMessage('Loading stylists...');
    await hydrateStylistOptions();
    setMessage('');
    goTo('stylist-per-service');
  }

  async function continuePhotoAppliedFlow(){
    if (hasBlockingPhotoDecision()) {
      setMessage(photoBlockingDecisionMessage(), 'is-error');
      renderPhotoFollowup();
      goTo('photo-followup');
      return;
    }
    if (state.answers.haircutBigChange === null) {
      state.answers.haircutBigChange = effectivePhotoHaircutBigChangeAnswer();
    }
    state.photoSuggestedServices = buildPhotoSuggestedServices(state.photoAnalysis);
    rebuildServiceStack();
    updateDebugPanel('continuePhotoAppliedFlow');

    var nextScreen = nextPhotoServiceDetailScreen();
    if (nextScreen) {
      goTo(nextScreen);
      return;
    }

    await maybeLoadStylistsAndAdvance();
  }

  async function advanceAfterSelection(){
    var next = nextFrom(state.screen);

    if (next === 'stylist-per-service') {
      await maybeLoadStylistsAndAdvance();
      return;
    }

    goTo(next);
  }

  root.addEventListener('click', async function(event){
    var button = event.target.closest('[data-choice-type]');
    if (!button) return;

    var type = button.getAttribute('data-choice-type');
    var id = button.getAttribute('data-choice-id');
    var label = button.getAttribute('data-choice-label');

    try {
      if (type === 'entry') {
        state.answers.entryChoice = id;
        state.answers.manualServiceKey = '';
        state.answers.extensionMaintenanceTracks = '';
        state.answers.extensionNeedsBlowdry = null;
        state.answers.blowdryStyle = '';
        state.answers.blowdryHairType = '';
        state.answers.colorGoal = '';
        state.answers.colorDimensionPlacement = '';
        state.answers.colorNeedsHaircut = null;
        state.answers.colorNeedsBlowdry = null;
        state.answers.singleProcessGlaze = null;
        state.answers.haircutLongOrThick = null;
        state.answers.haircutBigChange = null;
        state.photoGoal = '';
        state.photoApplied = false;
        state.photoAnalysis = null;
        state.photoSuggestedServices = [];
        state.photoFollowUpAnswers = {};
        state.staffDirectory = [];
        state.staffOptionsByService = {};
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        state.availabilityLoading = false;
        state.rangeKey = 'week_0';
        resetStylistStep();
        currentAvailabilityGroups = [];
        currentPhotoImages = [];
        inspirationPhotoImages = [];
        if (photoGoalInput) photoGoalInput.value = '';
        if (currentPhotoFilesInput) currentPhotoFilesInput.value = '';
        if (inspoPhotoFilesInput) inspoPhotoFilesInput.value = '';
        resetPhotoResults();
        renderPhotoPreviews();
        rebuildServiceStack();
        goTo(nextFrom('entry'));
        return;
      }

      if (type === 'open-dashboard') {
        syncInputs();
        if (!state.clientAccount.bootstrap) {
          fetchClientDashboardBootstrap().then(function(){
            if (state.clientAccount.clientToken) {
              return fetchClientDashboardData();
            }
          }).catch(function(error){
            setMessage(error && error.message ? error.message : 'Could not check Boulevard account status.', 'is-error');
          });
        } else if (state.clientAccount.clientToken && !state.clientAccount.dashboardData) {
          fetchClientDashboardData().catch(function(error){
            setMessage(error && error.message ? error.message : 'Could not load Boulevard appointments.', 'is-error');
          });
        }
        goTo('dashboard');
        return;
      }

      if (type === 'open-staff-directory') {
        if (!state.staffDirectoryPage.staff.length && !state.staffDirectoryPage.loading) {
          loadStaffDirectoryPage(false).catch(function(error){
            setMessage(error && error.message ? error.message : 'Could not load team details.', 'is-error');
          });
        }
        goTo('staff-directory');
        return;
      }

      if (type === 'dashboard-cancel-appointment') {
        if (!window.confirm('Cancel this appointment?')) return;
        await cancelDashboardAppointment(id);
        return;
      }

      if (type === 'dashboard-reschedule-start') {
        await loadDashboardRescheduleDates(id);
        return;
      }

      if (type === 'dashboard-reschedule-date') {
        var rescheduleDate = String(button.getAttribute('data-date') || '').trim();
        if (!rescheduleDate) return;
        await loadDashboardRescheduleTimes(id, rescheduleDate);
        return;
      }

      if (type === 'dashboard-reschedule-time') {
        var bookableTimeId = String(button.getAttribute('data-bookable-time-id') || '').trim();
        if (!bookableTimeId) return;
        await confirmDashboardReschedule(id, bookableTimeId);
        return;
      }

      if (type === 'dashboard-reschedule-reset') {
        clearDashboardAppointmentAction();
        renderDashboard();
        return;
      }

      if (type === 'dashboard-auth-method') {
        state.clientAccount.authMethod = id === 'phone' ? 'phone' : 'email';
        state.clientAccount.authStart = null;
        state.clientAccount.authVerify = null;
        state.clientAccount.verificationCode = '';
        state.clientAccount.requestId = '';
        state.clientAccount.challengeToken = '';
        state.clientAccount.dashboardData = null;
        renderDashboard();
        return;
      }

      if (type === 'dashboard-tab') {
        state.clientAccount.dashboardTab = id === 'past' ? 'past' : 'upcoming';
        renderDashboard();
        return;
      }

      if (type === 'dashboard-back-booking') {
        goTo(state.lastBookingScreen || 'entry');
        return;
      }

      if (type === 'dashboard-section') {
        state.clientAccount.dashboardSection = id === 'vouchers'
          ? 'vouchers'
          : (id === 'cards' ? 'cards' : (id === 'referrals' ? 'referrals' : 'appointments'));
        renderDashboard();
        return;
      }

      if (type === 'dashboard-auth-start') {
        state.clientAccount.authMethod = 'phone';
        var identifierInput = document.getElementById('bkDashboardIdentifier');
        state.clientAccount.identifier = String(identifierInput && identifierInput.value || '').trim();
        try {
          await startClientAccountAuth();
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Could not send a verification code.', 'is-error');
          updateUI();
        }
        return;
      }

      if (type === 'dashboard-auth-verify') {
        state.clientAccount.authMethod = 'phone';
        var verifyIdentifierInput = document.getElementById('bkDashboardIdentifier');
        var codeInput = document.getElementById('bkDashboardCode');
        state.clientAccount.identifier = String(verifyIdentifierInput && verifyIdentifierInput.value || state.clientAccount.identifier || '').trim();
        state.clientAccount.verificationCode = String(codeInput && codeInput.value || '').trim();
        try {
          await verifyClientAccountCode();
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Could not verify that code.', 'is-error');
          updateUI();
        }
        return;
      }

      if (type === 'dashboard-auth-reset') {
        state.clientAccount.authStart = null;
        state.clientAccount.authVerify = null;
        state.clientAccount.verificationCode = '';
        state.clientAccount.requestId = '';
        state.clientAccount.challengeToken = '';
        renderDashboard();
        return;
      }

      if (type === 'dashboard-auth-refresh') {
        var dashboardTokenInput = document.getElementById('bkDashboardClientToken');
        state.clientAccount.clientToken = String(dashboardTokenInput && dashboardTokenInput.value || state.clientAccount.clientToken || '').trim();
        await fetchClientDashboardBootstrap();
        if (state.clientAccount.clientToken) {
          await fetchClientDashboardData();
        }
        return;
      }

      if (type === 'dashboard-auth-clear') {
        state.clientAccount.identifier = '';
        state.clientAccount.verificationCode = '';
        state.clientAccount.requestId = '';
        state.clientAccount.challengeToken = '';
        state.clientAccount.clientToken = '';
        state.clientAccount.bootstrap = null;
        state.clientAccount.authStart = null;
        state.clientAccount.authVerify = null;
        state.clientAccount.dashboardData = null;
        state.selectedSavedCardId = '';
        state.clientAccount.dashboardSection = 'appointments';
        state.clientAccount.dashboardTab = 'upcoming';
        saveClientDashboardToken('');
        saveLiveDashboardData(emptyLiveDashboardData());
        renderDashboard();
        return;
      }

      if (type === 'staff-directory-refresh') {
        await loadStaffDirectoryPage(true);
        return;
      }

      if (type === 'staff-directory-back') {
        goTo(state.lastBookingScreen || 'entry');
        return;
      }

      if (type === 'staff-directory-toggle') {
        state.staffDirectoryPage.expandedId = state.staffDirectoryPage.expandedId === id ? '' : id;
        renderStaffDirectory();
        return;
      }

      if (type === 'saved-card') {
        state.selectedSavedCardId = String(id || '').trim();
        if (state.selectedSavedCardId) {
          clearCardInputs();
        }
        updateUI();
        if (state.screen === 'guest' && state.selectedSavedCardId) {
          goTo('review');
        }
        return;
      }

      if (type === 'manual-service') {
        trackBookingSelection('next_visit_booking_service_selected', {
          selection_type: 'manual_service',
          selection_value: id || ''
        });
        state.answers.manualServiceKey = id;
        state.answers.extensionMaintenanceTracks = '';
        state.answers.extensionNeedsBlowdry = null;
        state.answers.treatmentNeedsHaircut = null;
        state.answers.treatmentNeedsBlowdry = null;
        state.answers.blowdryStyle = '';
        state.answers.blowdryHairType = '';
        state.answers.haircutLongOrThick = null;
        state.answers.haircutBigChange = null;
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        await advanceAfterSelection();
        return;
      }

      if (type === 'extension-tracks') {
        trackBookingSelection('next_visit_booking_question_answered', {
          question_key: 'extension_tracks',
          answer_value: id || ''
        });
        state.answers.extensionMaintenanceTracks = id;
        state.answers.extensionNeedsBlowdry = null;
        state.answers.blowdryStyle = '';
        state.answers.blowdryHairType = '';
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        await advanceAfterSelection();
        return;
      }

      if (type === 'color-goal') {
        trackBookingSelection('next_visit_booking_service_selected', {
          selection_type: 'color_goal',
          selection_value: id || ''
        });
        state.answers.colorGoal = id;
        state.answers.colorDimensionPlacement = '';
        state.answers.colorNeedsHaircut = null;
        state.answers.colorNeedsBlowdry = null;
        state.answers.singleProcessGlaze = null;
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        await advanceAfterSelection();
        return;
      }

      if (type === 'answer') {
        var answerKey = button.getAttribute('data-answer-key');
        var raw = button.getAttribute('data-answer-value');
        trackBookingSelection('next_visit_booking_question_answered', {
          question_key: answerKey || '',
          answer_value: raw || ''
        });
        state.answers[answerKey] = raw === 'yes' ? true : false;

        if (answerKey === 'colorNeedsBlowdry' && raw === 'no') {
          state.answers.blowdryStyle = '';
          state.answers.blowdryHairType = '';
        }

        if (answerKey === 'extensionNeedsBlowdry' && raw === 'no') {
          state.answers.blowdryStyle = '';
          state.answers.blowdryHairType = '';
        }

        if (answerKey === 'treatmentNeedsHaircut') {
          if (raw === 'yes') {
            state.answers.treatmentNeedsBlowdry = null;
            state.answers.blowdryStyle = '';
            state.answers.blowdryHairType = '';
          }
          if (raw === 'no') {
            state.answers.haircutLongOrThick = null;
            state.answers.haircutBigChange = null;
          }
        }

        if (answerKey === 'treatmentNeedsBlowdry' && raw === 'no') {
          state.answers.blowdryStyle = '';
          state.answers.blowdryHairType = '';
        }

        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        if (state.answers.entryChoice === 'photo' && state.photoApplied) {
          await continuePhotoAppliedFlow();
          return;
        }
        await advanceAfterSelection();
        return;
      }

      if (type === 'blowdry-style') {
        trackBookingSelection('next_visit_booking_question_answered', {
          question_key: 'blowdry_style',
          answer_value: id || ''
        });
        state.answers.blowdryStyle = id;
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        await advanceAfterSelection();
        return;
      }

      if (type === 'blowdry-hair') {
        trackBookingSelection('next_visit_booking_question_answered', {
          question_key: 'blowdry_hair_type',
          answer_value: id || ''
        });
        state.answers.blowdryHairType = id;
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        if (state.answers.entryChoice === 'photo' && state.photoApplied) {
          await continuePhotoAppliedFlow();
          return;
        }
        await advanceAfterSelection();
        return;
      }

      if (type === 'placement') {
        trackBookingSelection('next_visit_booking_question_answered', {
          question_key: 'color_dimension_placement',
          answer_value: id || ''
        });
        state.answers.colorDimensionPlacement = id;
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        rebuildServiceStack();
        await advanceAfterSelection();
        return;
      }

      if (type === 'service-staff') {
        var serviceId = button.getAttribute('data-service-id');
        trackBookingSelection('next_visit_booking_stylist_selected', {
          service_id: serviceId || '',
          stylist_id: id || '',
          stylist_label: button.getAttribute('data-choice-label') || ''
        });

        state.serviceStack = state.serviceStack.map(function(item){
          if (item.service_id !== serviceId) return item;
          var option = findStaffOption(serviceId, id);
          var currentIds = selectedStylistIdsForItem(item);
          var nextIds = [];

          if (id !== 'any') {
            nextIds = currentIds.slice();
            var existingIndex = nextIds.indexOf(id);
            if (existingIndex >= 0) {
              nextIds.splice(existingIndex, 1);
            } else {
              nextIds.push(id);
            }
          }

          return {
            key: item.key,
            name: item.name,
            service_id: item.service_id,
            stylist_id: id === 'any'
              ? 'any'
              : (nextIds[0] || 'any'),
            stylist_name: id === 'any'
              ? 'No preference'
              : stylistSummaryLabel(serviceId, nextIds),
            preferred_stylist_ids: id === 'any' ? [] : nextIds,
            price: option && typeof option.price === 'number' ? option.price : null,
            selected_options: item.selected_options || []
          };
        });

        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        renderPerServicePanels();
        updateUI();
        return;
      }

      if (type === 'range') {
        trackBookingSelection('next_visit_booking_range_selected', {
          range_key: id || '',
          range_label: label || ''
        });
        await applyRangeSelection(id);
        return;
      }

      if (type === 'waitlist-mode') {
        state.clientAccount.waitlistMode = id === 'specific_date' ? 'specific_date' : 'first_available';
        if (state.clientAccount.waitlistMode === 'specific_date' && !state.clientAccount.waitlistPreferredDate) {
          state.clientAccount.waitlistPreferredDate = todayInputValue();
        }
        renderTimeGroups(currentAvailabilityGroups, state.slotId);
        updateUI();
        return;
      }

      if (type === 'range-prev' || type === 'range-next') {
        var moved = shiftWeekRange(type === 'range-next' ? 1 : -1);
        if (!moved) return;
        await reloadAvailabilityForCurrentRange();
        return;
      }

      if (type === 'time') {
        clearSelectedSlotRetry();
        var selectedSlot = null;
        currentAvailabilityGroups.some(function(group){
          var slots = Array.isArray(group && group.slots) ? group.slots : [];
          return slots.some(function(slot){
            if (slot && slot.id === id) {
              selectedSlot = slot;
              return true;
            }
            return false;
          });
        });
        var selectedSlotId = id;
        trackBookingSelection('next_visit_booking_time_selected', {
          slot_id: id || '',
          slot_label: label || '',
          start_at: selectedSlot && selectedSlot.start_at ? selectedSlot.start_at : ''
        });
        state.slotId = id;
        state.slotLabel = label;
        state.slotStartAt = selectedSlot && selectedSlot.start_at ? selectedSlot.start_at : '';
        state.slotEstimate = null;
        state.slotEstimateLoading = true;
        renderTimeGroups(currentAvailabilityGroups, state.slotId);
        renderSummaryMeta();
        renderTimeMeta();
        updateUI();

        var slotEstimateReady = false;
        try {
          var slotDetails = await fetchSlotEstimateWithRetry(id, 2);
          state.slotEstimate = slotDetails && slotDetails.summary ? slotDetails.summary : null;
          if (selectedSlot) {
            selectedSlot.slot_summary = slotDetails && slotDetails.summary ? slotDetails.summary : null;
            selectedSlot.service_breakout = slotDetails && Array.isArray(slotDetails.service_breakout)
              ? slotDetails.service_breakout
              : [];
            selectedSlot.breakout_error = null;
          }
          slotEstimateReady = true;
        } catch (error) {
          state.slotEstimate = null;
          if (selectedSlot) {
            selectedSlot.slot_summary = null;
            selectedSlot.service_breakout = [];
            selectedSlot.breakout_error = error && error.message ? error.message : '';
          }
          if (isRateLimitedBookingMessage(error && error.message)) {
            scheduleSelectedSlotRetry(id, label, selectedSlot);
          } else {
            setMessage(error && error.message ? error.message : 'Could not load slot estimate.', 'is-error');
          }
        } finally {
          state.slotEstimateLoading = false;
          renderTimeGroups(currentAvailabilityGroups, state.slotId);
          renderSummaryMeta();
          renderTimeMeta();
          updateUI();
          if (slotEstimateReady && state.slotId === selectedSlotId) {
            hydrateBookingProfileFromSignedInClient();
            goTo('guest');
          }
        }
        return;
      }

      if (type === 'join-waitlist') {
        try {
          await joinWaitlistFromCurrentSelection();
          trackBookingSelection('next_visit_booking_waitlist_joined', {
            waitlist_mode: String(state.clientAccount && state.clientAccount.waitlistMode || 'first_available').trim() || 'first_available',
            preferred_date: String(state.clientAccount && state.clientAccount.waitlistPreferredDate || '').trim()
          });
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Could not join the waitlist.', 'is-error');
        }
        return;
      }

      if (type === 'gratuity') {
        state.gratuityChoice = id || 'none';
        if (state.gratuityChoice !== 'custom') {
          state.gratuityCustom = '';
          if (gratuityCustomInput) gratuityCustomInput.value = '';
        }
        trackGratuitySelectionActivity('next_visit_booking_gratuity_selected');
        updateUI();
        return;
      }

      if (type === 'remove-service') {
        state.serviceStack = state.serviceStack.filter(function(item){ return item.key !== id; });
        state.slotId = '';
        state.slotLabel = '';
        state.slotEstimate = null;
        state.slotEstimateLoading = false;
        resetStylistStep();
        updateUI();
        return;
      }
    } catch (error) {
      state.availabilityLoading = false;
      if (state.screen === 'time') {
        renderTimeGroups(currentAvailabilityGroups, state.slotId);
        renderTimeMeta();
      }
      setMessage(error && error.message ? error.message : 'Something went wrong.', 'is-error');
      updateUI();
    }
  });

  [
    firstNameInput,
    lastNameInput,
    emailInput,
    phoneInput,
    cardNameInput,
    cardNumberInput,
    cardExpMonthInput,
    cardExpYearInput,
    cardCvvInput,
    cardPostalInput
  ].forEach(function(input){
    input.addEventListener('input', function(){
      syncInputs();
      updateUI();
    });
  });

  root.addEventListener('input', function(event){
    var target = event.target;
    if (!target || target.id !== 'bkWaitlistDate') return;
    state.clientAccount.waitlistPreferredDate = String(target.value || '').trim();
  });

  if (gratuityCustomInput) {
    gratuityCustomInput.addEventListener('change', function(){
      syncInputs();
      if (state.gratuityChoice === 'custom') {
        trackGratuitySelectionActivity('next_visit_booking_gratuity_updated');
      }
      updateUI();
    });
  }

  if (summaryMeta) {
    summaryMeta.addEventListener('click', async function(event){
      var button = event.target && event.target.closest ? event.target.closest('[data-choice-type]') : null;
      if (!button) return;
      var type = button.getAttribute('data-choice-type');
      if (type !== 'dashboard-auth-start' && type !== 'dashboard-auth-verify' && type !== 'dashboard-auth-reset') {
        return;
      }
      event.preventDefault();

      if (type === 'dashboard-auth-start') {
        state.clientAccount.authMethod = 'phone';
        var identifierInput = document.getElementById('bkDashboardIdentifier');
        state.clientAccount.identifier = String(identifierInput && identifierInput.value || '').trim();
        try {
          await startClientAccountAuth();
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Could not send a verification code.', 'is-error');
          updateUI();
        }
        return;
      }

      if (type === 'dashboard-auth-verify') {
        state.clientAccount.authMethod = 'phone';
        var verifyIdentifierInput = document.getElementById('bkDashboardIdentifier');
        var codeInput = document.getElementById('bkDashboardCode');
        state.clientAccount.identifier = String(verifyIdentifierInput && verifyIdentifierInput.value || state.clientAccount.identifier || '').trim();
        state.clientAccount.verificationCode = String(codeInput && codeInput.value || '').trim();
        try {
          await verifyClientAccountCode();
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Could not verify that code.', 'is-error');
          updateUI();
        }
        return;
      }

      if (type === 'dashboard-auth-reset') {
        trackBookingSelection('next_visit_booking_auth_reset', {
          auth_method: state.clientAccount.authMethod || 'phone'
        });
        state.clientAccount.authStart = null;
        state.clientAccount.authVerify = null;
        state.clientAccount.verificationCode = '';
        state.clientAccount.requestId = '';
        state.clientAccount.challengeToken = '';
        updateUI();
      }
    });
  }

  if (bookingAccountInline) {
    bookingAccountInline.addEventListener('click', function(event){
      var button = event.target.closest('[data-choice-type]');
      if (!button) return;
      event.preventDefault();
      var type = button.getAttribute('data-choice-type');
      if (type === 'booking-inline-back') {
        goTo(state.lastBookingScreen || 'entry');
        return;
      }
      if (type === 'open-staff-directory') {
        goTo('staff-directory');
        if (!state.staffDirectoryPage.staff.length && !state.staffDirectoryPage.loading) {
          loadStaffDirectoryPage(false).catch(function(error){
            setMessage(error && error.message ? error.message : 'Could not load team details.', 'is-error');
          });
        } else {
          renderStaffDirectory();
        }
        return;
      }
      if (type !== 'open-dashboard') return;
      syncInputs();
      if (!state.clientAccount.bootstrap) {
        fetchClientDashboardBootstrap().then(function(){
          if (state.clientAccount.clientToken) {
            return fetchClientDashboardData();
          }
        }).catch(function(error){
          setMessage(error && error.message ? error.message : 'Could not check Boulevard account status.', 'is-error');
        });
      } else if (state.clientAccount.clientToken && !state.clientAccount.dashboardData) {
        fetchClientDashboardData().catch(function(error){
          setMessage(error && error.message ? error.message : 'Could not load Boulevard appointments.', 'is-error');
        });
      }
      goTo('dashboard');
    });
  }

  currentPhotoFilesInput.addEventListener('change', function(){
    loadPhotoSet(currentPhotoFilesInput, currentPhotoImages, 'Current photo');
  });

  inspoPhotoFilesInput.addEventListener('change', function(){
    loadPhotoSet(inspoPhotoFilesInput, inspirationPhotoImages, 'Inspiration photo');
  });

  bindPhotoDropzone(currentDropzone, currentPhotoFilesInput, currentPhotoImages, 'Current photo');
  bindPhotoDropzone(inspoDropzone, inspoPhotoFilesInput, inspirationPhotoImages, 'Inspiration photo');

  if (rangePrevBtn) {
    rangePrevBtn.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      if (!shiftWeekRange(-1)) return;
      reloadAvailabilityForCurrentRange().catch(function(error){
        setMessage(error && error.message ? error.message : 'Could not load availability.', 'is-error');
      });
    });
  }

  if (rangeNextBtn) {
    rangeNextBtn.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      if (!shiftWeekRange(1)) return;
      reloadAvailabilityForCurrentRange().catch(function(error){
        setMessage(error && error.message ? error.message : 'Could not load availability.', 'is-error');
      });
    });
  }

  photoClearBtn.addEventListener('click', function(){
    currentPhotoImages = [];
    inspirationPhotoImages = [];
    currentPhotoFilesInput.value = '';
    inspoPhotoFilesInput.value = '';
    photoGoalInput.value = '';
    state.photoGoal = '';
    renderPhotoPreviews();
    resetPhotoResults();
    setMessage('');
    if (debugPanel) debugPanel.style.display = 'none';
    updateUI();
  });

  photoAnalyzeBtn.addEventListener('click', async function(){
    photoAnalyzeBtn.disabled = true;
    setThinkingState(true, 'analyze');
    setMessage('Analyzing photos...');

    try {
      await analyzePhotos();

      if (hasPhotoQuestionBundle()) {
        renderPhotoFollowup();
        setMessage('');
        goTo('photo-followup');
      } else {
        await completePhotoFlow();
      }
    } catch (error) {
      setMessage(error && error.message ? error.message : 'Could not analyze photos.', 'is-error');
    } finally {
      setThinkingState(false);
      photoAnalyzeBtn.disabled = false;
    }
  });

  if (photoQuestions) {
    photoQuestions.addEventListener('click', function(event){
      var button = event.target.closest('[data-photo-question-id]');
      if (!button || !state.photoAnalysis) return;
      var choiceType = button.getAttribute('data-choice-type') || '';
      if (choiceType === 'photo-followup-answer' || choiceType === 'photo-followup-continue') return;

      var questionId = String(button.getAttribute('data-photo-question-id') || '');
      var raw = button.getAttribute('data-photo-answer-value');
      var kind = button.getAttribute('data-photo-answer-kind') || 'boolean';
      if (!questionId || !raw) return;

      storePhotoAnswer(questionId, raw, kind);
      renderPhotoResults();
    });
  }

  root.addEventListener('click', function(event){
    var continueButton = event.target.closest('[data-choice-type="photo-followup-continue"]');
    if (continueButton) {
      var activeQuestion = currentPhotoQuestion();
      if (!activeQuestion) return;
      if (activeQuestion.type === 'multi_select') {
        var selected = state.photoFollowUpAnswers[activeQuestion.id];
        if (!Array.isArray(selected) || !selected.length) return;
        state.photoCommittedQuestionIds[activeQuestion.id] = true;
      }
      if (currentPhotoQuestion()) {
        renderPhotoFollowup();
        setMessage('');
        goTo('photo-followup');
      } else {
        setThinkingState(true, 'refine');
        setMessage('');

        refinePhotoAnalysis().then(async function(){
          if (hasPhotoQuestionBundle()) {
            renderPhotoFollowup();
            setMessage('');
            goTo('photo-followup');
            return;
          }

          await completePhotoFlow();
        }).catch(function(error){
          setMessage(error && error.message ? error.message : 'Could not refine suggestion.', 'is-error');
        }).finally(function(){
          setThinkingState(false);
        });
      }
      return;
    }

    var button = event.target.closest('[data-choice-type="photo-followup-answer"]');
    if (!button) return;

    var question = currentPhotoQuestion();
    if (!question) return;

    var questionId = String(button.getAttribute('data-photo-question-id') || question.id || '');
    var raw = button.getAttribute('data-photo-answer-value') || button.getAttribute('data-answer-value');
    var kind = button.getAttribute('data-photo-answer-kind') || 'boolean';
    var effectiveKind = question.id === PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID
      ? 'multi_select'
      : (question.type || kind || 'boolean');
    if (!questionId || !raw) return;

    storePhotoAnswer(questionId, raw, effectiveKind);
    if (effectiveKind === 'multi_select') {
      if (!photoQuestionNeedsCommit(question)) {
        setThinkingState(true, 'refine');
        setMessage('');

        refinePhotoAnalysis().then(async function(){
          if (hasPhotoQuestionBundle()) {
            renderPhotoFollowup();
            setMessage('');
            goTo('photo-followup');
            return;
          }

          await completePhotoFlow();
        }).catch(function(error){
          setMessage(error && error.message ? error.message : 'Could not refine suggestion.', 'is-error');
        }).finally(function(){
          setThinkingState(false);
        });
        return;
      }
      renderPhotoFollowup();
      setMessage('');
      return;
    }
    if (currentPhotoQuestion()) {
      renderPhotoFollowup();
      setMessage('');
      goTo('photo-followup');
      return;
    }

    setThinkingState(true, 'refine');
    setMessage('');

    refinePhotoAnalysis().then(async function(){
      if (hasPhotoQuestionBundle()) {
        renderPhotoFollowup();
        setMessage('');
        goTo('photo-followup');
        return;
      }

      await completePhotoFlow();
    }).catch(function(error){
      setMessage(error && error.message ? error.message : 'Could not refine suggestion.', 'is-error');
    }).finally(function(){
      setThinkingState(false);
    });
  });

  if (photoRefineBtn) {
    photoRefineBtn.addEventListener('click', async function(){
      photoRefineBtn.disabled = true;
      setThinkingState(true, 'refine');
      setMessage('');

      try {
        await refinePhotoAnalysis();
        if (hasPhotoQuestionBundle()) {
          renderPhotoFollowup();
          setMessage('');
          goTo('photo-followup');
          return;
        }
        await completePhotoFlow();
      } catch (error) {
        setMessage(error && error.message ? error.message : 'Could not refine suggestion.', 'is-error');
        renderPhotoResults();
      } finally {
        setThinkingState(false);
        photoRefineBtn.disabled = false;
      }
    });
  }

  if (photoApplyBtn) {
    photoApplyBtn.addEventListener('click', async function(){
      try {
        await completePhotoFlow();
      } catch (error) {
        setMessage(error && error.message ? error.message : 'Could not continue with that suggestion.', 'is-error');
        updateUI();
      }
    });
  }

  backBtn.addEventListener('click', function(){
    if (state.screen === 'entry') return;
    setMessage('');
    goTo(prevFrom(state.screen));
  });

  nextBtn.addEventListener('click', async function(){
    syncInputs();
    if (!canContinue()) return;

    try {
      if (state.screen === 'stylist-per-service') {
        var finishedAll = advanceStylistStep();
        renderPerServicePanels();
        updateUI();

        if (finishedAll) {
          state.slotId = '';
          state.slotLabel = '';
          state.slotEstimate = null;
          state.slotEstimateLoading = false;
          goTo('time');
          await applyRangeSelection('');
        }
        return;
      }

      if (state.screen === 'time') {
        hydrateBookingProfileFromSignedInClient();
        goTo('guest');
        return;
      }

      if (state.screen === 'guest') {
        goTo('review');
        return;
      }

      if (state.screen === 'review') {
        nextBtn.disabled = true;
        nextBtn.textContent = 'Booking...';
        try {
          state.confirmation = await submitBooking();
          storeConfirmedAppointment();
          trackBookingActivity('conversion', 'next_visit_booking_completed', {
            page_section: 'next_visit_booking',
            slot_id: state.slotId || '',
            slot_label: state.slotLabel || '',
            services: servicePayload().map(function(service){
              return {
                service_id: service.service_id || '',
                staff_id: service.staff_id || '',
                option_ids: Array.isArray(service.option_ids) ? service.option_ids.slice(0, 12) : []
              };
            })
          });
          setMessage('Booking created successfully.', 'is-success');
          goTo('done');
        } catch (error) {
          setMessage(error && error.message ? error.message : 'We could not create that booking just now.', 'is-error');
          updateUI();
        }
      }
    } catch (error) {
      setMessage(error && error.message ? error.message : 'Something went wrong.', 'is-error');
      updateUI();
    }
  });

  hydrateDashboardProfile();
  renderPhotoPreviews();
  applyBookingDeepLinkIfPresent();
  updateUI();

  if (state.clientAccount.clientToken) {
    fetchClientDashboardBootstrap().then(function(){
      return fetchClientDashboardData();
    }).catch(function(){
      fetchClientDashboardData().catch(function(){
        updateUI();
      });
    });
  }
  })();
